/* ===========================================================
 * ru.js
 * Russion translation for Trumbowyg
 * http://alex-d.github.com/Trumbowyg
 * ===========================================================
 * Author : Yuri Lya
 */
jQuery.trumbowyg.langs.ru={viewHTML:"Посмотреть HTML",formatting:"Форматирование",p:"Обычный",blockquote:"Цитата",code:"Код",header:"Заголовок",bold:"Полужирный",italic:"Курсив",strikethrough:"Зачеркнутый",underline:"Подчеркнутый",strong:"Полужирный",em:"Курсив",del:"Зачеркнутый",unorderedList:"Обычный список",orderedList:"Нумерованный список",insertImage:"Вставить изображение",insertVideo:"Вставить видео",link:"Ссылка",createLink:"Вставить ссылку",unlink:"Удалить ссылку",justifyLeft:"По левому краю",justifyCenter:"По центру",justifyRight:"По правому краю",justifyFull:"По ширине",horizontalRule:"Горизонтальная линия",fullscreen:"Во весь экран",close:"Закрыть",submit:"Вставить",reset:"Отменить",required:"Обязательное",description:"Описание",title:"Подсказка",text:"Текст"};
!function(o){"use strict";function r(o){return("0"+parseInt(o).toString(16)).slice(-2)}function e(o){return-1===o.search("rgb")?o.replace("#",""):"rgba(0, 0, 0, 0)"===o?"transparent":(o=o.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/),r(o[1])+r(o[2])+r(o[3]))}function f(o,r){var f=[];if(!o.style)return f;if(""!==o.style.backgroundColor){var c=e(o.style.backgroundColor);r.o.plugins.colors.colorList.indexOf(c)>=0?f.push("backColor"+c):f.push("backColorFree")}var a;return""!==o.style.color?a=e(o.style.color):o.hasAttribute("color")&&(a=e(o.getAttribute("color"))),a&&(r.o.plugins.colors.colorList.indexOf(a)>=0?f.push("foreColor"+a):f.push("foreColorFree")),f}function c(r,e){var f=[];o.each(e.o.plugins.colors.colorList,function(o,c){var a=r+c,d={fn:r,forceCss:!0,param:"#"+c,style:"background-color: #"+c+";"};e.addBtnDef(a,d),f.push(a)});var c=r+"Remove",a={fn:"removeFormat",param:r,style:"background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAG0lEQVQIW2NkQAAfEJMRmwBYhoGBYQtMBYoAADziAp0jtJTgAAAAAElFTkSuQmCC);"};e.addBtnDef(c,a),f.push(c);var d=r+"Free",t={fn:function(){e.openModalInsert(e.lang[r],{color:{label:r,value:"#FFFFFF"}},function(o){return e.execCmd(r,o.color),!0})},text:"#",style:"text-indent: 0;line-height: 20px;padding: 0 5px;"};return e.addBtnDef(d,t),f.push(d),f}o.extend(!0,o.trumbowyg,{langs:{cs:{foreColor:"Barva textu",backColor:"Barva pozadí"},en:{foreColor:"Text color",backColor:"Background color"},fr:{foreColor:"Couleur du texte",backColor:"Couleur de fond"},sk:{foreColor:"Farba textu",backColor:"Farba pozadia"},zh_cn:{foreColor:"文字颜色",backColor:"背景颜色"}}});var a={colorList:["ffffff","000000","eeece1","1f497d","4f81bd","c0504d","9bbb59","8064a2","4bacc6","f79646","ffff00","f2f2f2","7f7f7f","ddd9c3","c6d9f0","dbe5f1","f2dcdb","ebf1dd","e5e0ec","dbeef3","fdeada","fff2ca","d8d8d8","595959","c4bd97","8db3e2","b8cce4","e5b9b7","d7e3bc","ccc1d9","b7dde8","fbd5b5","ffe694","bfbfbf","3f3f3f","938953","548dd4","95b3d7","d99694","c3d69b","b2a2c7","b7dde8","fac08f","f2c314","a5a5a5","262626","494429","17365d","366092","953734","76923c","5f497a","92cddc","e36c09","c09100","7f7f7f","0c0c0c","1d1b10","0f243e","244061","632423","4f6128","3f3151","31859b","974806","7f6000"]};o.extend(!0,o.trumbowyg,{plugins:{color:{init:function(r){r.o.plugins.colors=o.extend(!0,{},a,r.o.plugins.colors||{});var e={dropdown:c("foreColor",r)},f={dropdown:c("backColor",r)};r.addBtnDef("foreColor",e),r.addBtnDef("backColor",f)},tagHandler:f}}})}(jQuery);
/* ===========================================================
 * Elena: Плагины  uploadImage, uploadFile
 * На основе плагина upload, для загурзки файлов для ссылок
 * Сделала отдельный файл, т.к. в плагине upload предусмотрена только загрузка изображений
 *
 * trumbowyg.upload.js v1.2
 * Upload plugin for Trumbowyg
 * http://alex-d.github.com/Trumbowyg
 * ===========================================================
 */

(function ($) {
    'use strict';

    var defaultOptions = {
        serverPath: '',
        fileFieldName: 'fileToUpload',
        data: [],
        headers: {},
        xhrFields: {},
        urlPropertyName: 'file',
        statusPropertyName: 'success',
        success: undefined,
        error: undefined
    };

    function getDeep(object, propertyParts) {
        var mainProperty = propertyParts.shift(),
            otherProperties = propertyParts;

        if (object !== null) {
            if (otherProperties.length === 0) {
                return object[mainProperty];
            }

            if (typeof object === 'object') {
                return getDeep(object[mainProperty], otherProperties);
            }
        }
        return object;
    }

    addXhrProgressEvent();

    $.extend(true, $.trumbowyg, {
        langs: {
            ru: {
                uploadImage: 'Загрузить изображение',
                uploadFile: 'Загрузить файл',
                file: 'Файл',
                uploadError: 'Ошибка',
                undo:'Отменить',
                redo:'Вернуть',
                image:'Изображение',
                linkUpload:'Ссылка'
            }
        },
        // jshint camelcase:true

        plugins: {
            uploadImage: {
              init: function (trumbowyg) {
                trumbowyg.o.plugins.upload = $.extend(true, {}, defaultOptions, trumbowyg.o.plugins.uploadImage || {});
                var btnDef = uploadInitBtn(trumbowyg,'image');

                trumbowyg.addBtnDef('uploadImage', btnDef);
              }
            },
            uploadFile: {
                init: function (trumbowyg) {
                    trumbowyg.o.plugins.upload = $.extend(true, {}, defaultOptions, trumbowyg.o.plugins.uploadFile || {});
                    var btnDef = uploadInitBtn(trumbowyg,'link');

                    trumbowyg.addBtnDef('uploadFile', btnDef);
                }
            }
        }
    });

    //формирует модальное окно загрузки
    function uploadInitBtn(trumbowyg,formType){
      return {
        ico: 'upload',
        fn: function () {
          trumbowyg.saveRange();

          var file, formFields = {},
            prefix = trumbowyg.o.prefix;

          //поля формы, в зависимости от типа
          if(formType == 'link'){
            formFields = {
              file: {
                type: 'File',
                required: true
              },
              title: {
                label: 'title',
                value: ''
              },
              text: {
                label: 'text',
                value: trumbowyg.getRangeText()
              },
              target: {
                label: 'Target',
                value: ''
              }
            };
          } else {
            formFields = {
              file: {
                type: 'file',
                required: true,
                attributes: {
                  accept: 'image/*'
                }
              },
              alt: {
                label: 'description',
                value: trumbowyg.getRangeText()
              }
            };
          }

          var $modal = trumbowyg.openModalInsert(
            // Title
            trumbowyg.lang.upload,

            // Fields
            formFields,

            // Callback
            function (values) {
              var data = new FormData();
              data.append(trumbowyg.o.plugins.upload.fileFieldName, file);

              trumbowyg.o.plugins.upload.data.map(function (cur) {
                data.append(cur.name, cur.value);
              });

              if ($('.' + prefix + 'progress', $modal).length === 0) {
                $('.' + prefix + 'modal-title', $modal)
                  .after(
                    $('<div/>', {
                      'class': prefix + 'progress'
                    }).append(
                      $('<div/>', {
                        'class': prefix + 'progress-bar'
                      })
                    )
                  );
              }

              $.ajax({
                url: trumbowyg.o.plugins.upload.serverPath,
                headers: trumbowyg.o.plugins.upload.headers,
                xhrFields: trumbowyg.o.plugins.upload.xhrFields,
                type: 'POST',
                data: data,
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false,

                progressUpload: function (e) {
                  $('.' + prefix + 'progress-bar').stop().animate({
                    width: Math.round(e.loaded * 100 / e.total) + '%'
                  }, 200);
                },

                success: function (data) {
                  if (trumbowyg.o.plugins.upload.success) {
                    trumbowyg.o.plugins.upload.success(data, trumbowyg, $modal, values);
                  } else {

                    if (!!getDeep(data, trumbowyg.o.plugins.upload.statusPropertyName.split('.'))) {
                      var url = getDeep(data, trumbowyg.o.plugins.upload.urlPropertyName.split('.'));

                      if(formType == 'link'){
                        trumbowyg.execCmd('createLink', url);
                        $('a[href="' + url + '"]:not([title])', trumbowyg.$box).attr('title', values.title);
                        $('a[href="' + url + '"]:not([target])', trumbowyg.$box).attr('target', values.target);
                        if(values.text){
                          $('a[href="' + url + '"]', trumbowyg.$box).text(values.text);
                        }
                      } else {
                        trumbowyg.execCmd('insertImage', url);
                        $('img[src="' + url + '"]:not([alt])', trumbowyg.$box).attr('alt', values.alt);
                      }

                      setTimeout(function () {
                        trumbowyg.closeModal();
                      }, 250);
                      trumbowyg.$c.trigger('tbwuploadsuccess', [trumbowyg, data, url]);
                    } else {
                      trumbowyg.addErrorOnModalField(
                        $('input[type=file]', $modal),
                        trumbowyg.lang[data.message]
                      );
                      trumbowyg.$c.trigger('tbwuploaderror', [trumbowyg, data]);
                    }
                  }
                },

                error: trumbowyg.o.plugins.upload.error || function () {
                  trumbowyg.addErrorOnModalField(
                    $('input[type=file]', $modal),
                    trumbowyg.lang.uploadError
                  );
                  trumbowyg.$c.trigger('tbwuploaderror', [trumbowyg]);
                }
              });
            }
          );

          $('input[type=file]').on('change', function (e) {
            try {
              // If multiple files allowed, we just get the first.
              file = e.target.files[0];
            } catch (err) {
              // In IE8, multiple files not allowed
              file = e.target.value;
            }
          });
        }
      };
    }

    function addXhrProgressEvent() {
        if (!$.trumbowyg && !$.trumbowyg.addedXhrProgressEvent) {   // Avoid adding progress event multiple times
            var originalXhr = $.ajaxSettings.xhr;
            $.ajaxSetup({
                xhr: function () {
                    var req = originalXhr(),
                        that = this;
                    if (req && typeof req.upload === 'object' && that.progressUpload !== undefined) {
                        req.upload.addEventListener('progress', function (e) {
                            that.progressUpload(e);
                        }, false);
                    }

                    return req;
                }
            });
            $.trumbowyg.addedXhrProgressEvent = true;
        }
    }
})(jQuery);

(function() {
  'use strict';

  angular
    .module('web', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ngMask',
            'ui.router', 'ui.bootstrap', 'ui.select', 'toastr', 'dialogs.main', 'ngFileUpload',
            'angularSpectrumColorpicker','bootstrapLightbox','720kb.datepicker','trumbowyg-ng','ngFileSaver','updateMeta']);

})();

/**
 * Created by Елена on 02.03.2016.
 */
angular.module('web')
  .factory('Worker', function($http, ApiUri){
    var worker = {};

    worker.list = function(params){
      return $http.get(ApiUri + '/workers',{params:params});
    };

    worker.load = function(id){
      return $http.get(ApiUri + '/workers/item',{params:{id:id}});
    };

    worker.listPermitions = function(params){
      return $http.get(ApiUri + '/workers/item/permitions',{params:params});
    };

    worker.setPermitions = function(params){
      return $http.post(ApiUri + '/workers/item/permitions/update',params);
    };

    worker.create = function(item){
      return $http.post(ApiUri + '/workers/create',item);
    };

    worker.update = function(item){
      return $http.post(ApiUri + '/workers/update',item);
    };

    worker.changeIp = function(params){
      return $http.post(ApiUri + '/workers/changeIp',params);
    };

    worker.changePass = function(params){
      return $http.post(ApiUri + '/workers/changePass',params);
    };

    worker.delete = function(id){
      return $http.post(ApiUri + '/workers/delete',{id:id});
    };

    return worker;
  });

/**
 * Created by Елена on 30.07.2018
 */

angular.module('web')
  .factory('Voting', function($http, ApiUri){
    var item = {};

    item.cnt = function(params){
      return $http.get(ApiUri + '/voting/cnt',{params:params});
    };

    item.list = function(params){
      return $http.get(ApiUri + '/voting/get',{params:params});
    };

    item.load = function(id){
      return $http.get(ApiUri + '/voting/item',{params:{id:id}});
    };

    item.create = function(item){
      return $http.post(ApiUri + '/voting/create',item);
    };

    item.update = function(item){
      return $http.post(ApiUri + '/voting/update',item);
    };

    item.delete = function(id){
      return $http.post(ApiUri + '/voting/delete',{id:id});
    };

    item.params = function(params){
      return $http.get(ApiUri + '/voting/params',{params:params});
    };

    item.answers = function(params){
      return $http.get(ApiUri + '/voting/answers',{params:params});
    };

    item.result = function(params){
      return $http.get(ApiUri + '/voting/result',{params:params});
    };

    item.resultCnt = function(params){
      return $http.get(ApiUri + '/voting/result/cnt',{params:params});
    };

    item.resultOwners = function(params){
      return $http.get(ApiUri + '/voting/result/owners',{params:params});
    };

    item.loadResult = function(params){
      return $http.get(ApiUri + '/voting/result/item',{params:params});
    };

    item.createResult = function(params){
      return $http.post(ApiUri + '/voting/result/create',params);
    };

    item.updateResult = function(params){
      return $http.post(ApiUri + '/voting/result/update',params);
    };

    item.deleteResult = function(id){
      return $http.post(ApiUri + '/voting/result/delete',{id:id});
    };

    item.questions = function(params){
      return $http.get(ApiUri + '/voting/question',{params:params});
    };

    item.loadQuestion = function(id){
      return $http.get(ApiUri + '/voting/question/item',{params:{id:id}});
    };

    item.createQuestion = function(params){
      return $http.post(ApiUri + '/voting/question/create',params);
    };

    item.updateQuestion = function(params){
      return $http.post(ApiUri + '/voting/question/update',params);
    };

    item.deleteQuestion = function(id){
      return $http.post(ApiUri + '/voting/question/delete',{id:id});
    };

    item.validateNumVotes = function(params){
      return $http.get(ApiUri + '/voting/owners/num_votes',{params:params});
    };

    item.protocol = function(params){
      return $http.get(ApiUri + '/voting/protocol',{params:params});
    };

    return item;
  });

/**
 * Created by Елена on 25.08.2017.
 */

angular.module('web')
  .factory('Video', function($http, ApiUri){
    var item = {};

    item.list = function(params){
      return $http.get(ApiUri + '/video/cameras',{params:params});
    };

    item.rtmpSecureKey = function(params){
      return $http.get(ApiUri + '/video/rtmpSecureKey',{params:params});
    };

    return item;
  });

/**
 * Created by Елена on 30.08.2016.
 */
angular.module('web')
  .factory('Technician', function($http, ApiUri){
    var item = {};

    item.list = function(params){
      return $http.get(ApiUri + '/technicians/items',{params:params});
    };

    item.load = function(id){
      return $http.get(ApiUri + '/technicians/item',{params:{id:id}});
    };

    item.create = function(item){
      return $http.post(ApiUri + '/technicians/create',item);
    };

    item.update = function(item){
      return $http.post(ApiUri + '/technicians/update',item);
    };

    item.delete = function(id){
      return $http.post(ApiUri + '/technicians/delete',{id:id});
    };

    return item;
  });

/**
 * Created by Елена on 26.08.2016.
 */
angular.module('web')
  .factory('TechOrder', function($http, ApiUri){
    var tech_order = {};

    tech_order.cnt = function(params){
      return $http.get(ApiUri + '/tech_orders/cnt',{params:params});
    };

    tech_order.list = function(params){
      return $http.get(ApiUri + '/tech_orders/items',{params:params});
    };

    tech_order.listStatuses = function(params){
      return $http.get(ApiUri + '/tech_orders/statuses',{params:params});
    };

    tech_order.load = function(id){
      return $http.get(ApiUri + '/tech_orders/item',{params:{id:id}});
    };

    tech_order.loadStatus = function(id){
      return $http.get(ApiUri + '/tech_orders/statuses/item',{params:{id:id}});
    };

    tech_order.create = function(item){
      return $http.post(ApiUri + '/tech_orders/create',item);
    };

    tech_order.update = function(item){
      return $http.post(ApiUri + '/tech_orders/update',item);
    };

    tech_order.delete = function(item){
      return $http.post(ApiUri + '/tech_orders/delete',item);
    };

    tech_order.updateRead = function(item){
      return $http.post(ApiUri + '/tech_orders/update/read',item);
    };

    tech_order.listOrderStatuses = function(params){
      return $http.get(ApiUri + '/tech_orders/order_statuses/',{params:params});
    };

    tech_order.createOrderStatus = function(item){
      return $http.post(ApiUri + '/tech_orders/order_statuses/create',item);
    };

    return tech_order;
  });

/**
 * Created by Елена on 14.11.2016.
 */
angular.module('web')
  .factory('Sync', function($http, ApiUri){
    var item = {};

    item.importFromBonus = function(params){
      return $http.post(ApiUri + '/import/bonus', params);
    };

    item.exportToBonus = function(params){
      return $http.post(ApiUri + '/export/bonus', params);
    };

    item.exportToOneC = function(params){
      return $http.post(ApiUri + '/export/OneC', params);
    };

    item.exportToExcel = function(params){
      return $http.post(ApiUri + '/export/excel', params);
    };

    return item;
  });

/**
 * Created by Елена on 26.10.2016.
 */
angular.module('web')
  .factory('Receipt', function($http, ApiUri){
    var item = {};

    item.cnt = function(params){
      return $http.get(ApiUri + '/receipts/cnt',{params:params});
    };

    item.list = function(params){
      return $http.get(ApiUri + '/receipts',{params:params});
    };

    item.load = function(params){
      return $http.get(ApiUri + '/receipts/item',{params:params});
    };

    item.create = function(item){
      return $http.post(ApiUri + '/receipts/create',item);
    };

    item.update = function(item){
      return $http.post(ApiUri + '/receipts/update',item);
    };

    item.delete = function(id){
      return $http.post(ApiUri + '/receipts/delete',{id:id});
    };

    return item;
  });

/**
 * Created by Елена on 25.07.2016.
 */
angular.module('web')
  .factory('Theme', function($http, ApiUri){
    var theme = {};

    theme.list = function(params){
      return $http.get(ApiUri + '/themes/list',{params:params});
    };

    theme.load = function(params){
      return $http.get(ApiUri + '/themes/item',{params:params});
    };

    return theme;
  });

/**
 * Created by Елена on 14.07.2016.
 */

angular.module('web')
  .factory('Structure', function($http, ApiUri){
    var structure = {};

    structure.listComponents = function(){
      return $http.get(ApiUri + '/structure/components');
    };

    structure.getOrderNum = function(params){
      return $http.get(ApiUri + '/structure/item/order_max',{params:params});
    };

    structure.list = function(params){
      return $http.get(ApiUri + '/structure',{params:params});
    };

    structure.load = function(id){
      return $http.get(ApiUri + '/structure/item',{params:{id:id}});
    };

    structure.create = function(item){
      return $http.post(ApiUri + '/structure/create',item);
    };

    structure.update = function(item){
      return $http.post(ApiUri + '/structure/update',item);
    };

    structure.updateImages = function(item){
      return $http.post(ApiUri + '/structure/update/images',item);
    };

    structure.setMainPage = function(item){
      return $http.post(ApiUri + '/structure/update/main_page',item);
    };

    structure.delete = function(id){
      return $http.post(ApiUri + '/structure/delete',{id:id});
    };

    return structure;
  });

/**
 * Created by Елена on 14.07.2016.
 */

angular.module('web')
  .factory('Domain', function($http, ApiUri){
    var domain = {};

    domain.load = function(params){
      return $http.get(ApiUri + '/companies/domain',{params:params});
    };

    domain.update = function(item){
      return $http.post(ApiUri + '/companies/domains/update',item);
    };

    domain.updateLogo = function(params){
      return $http.post(ApiUri + '/companies/domains/update/logo',params);
    };

    /*
     * Выполняет сборку стилей для указанного домена
     * @params: domain_id - id домена,
     *          colors - объект с переменными less, которые переопределяются при сборке стилей
     **/
    domain.setStyleTheme = function(params){
      return $http.post(ApiUri + '/companies/domains/setStyleTheme',params);
    };

    return domain;
  });

/**
 * Created by Елена on 07.07.2016.
 */
angular.module('web')
  .factory('Settings', function($http, ApiUri){
    var settings = {};

    settings.list = function(params){
      return $http.get(ApiUri + '/settings',{params:params});
    };

    settings.load = function(params){
      return $http.get(ApiUri + '/settings/item',{params:params});
    };

    settings.create = function(item){
      return $http.post(ApiUri + '/settings/create',item);
    };

    settings.update = function(item){
      return $http.post(ApiUri + '/settings/update',item);
    };

    return settings;
  });

/**
 * Created by Елена on 16.03.2017.
 */
angular.module('web')
  .factory('Sensor', function($http, ApiUri){
    var item = {};

    item.load = function(id){
      return $http.get(ApiUri + '/companies/sensor/item',{params:{id:id}});
    };

    item.cnt = function(params){
      return $http.get(ApiUri + '/companies/sensor/cnt',{params:params});
    };

    item.list = function(params){
      return $http.get(ApiUri + '/companies/sensor/list',{params:params});
    };

    item.update = function(item){
      return $http.post(ApiUri + '/companies/sensor/update',item);
    };

    item.calibration = function(params){
      return $http.post(ApiUri + '/companies/sensor/calibration',params);
    };

    item.calibrationItem = function(params){
      return $http.post(ApiUri + '/companies/sensor/calibration/item',params);
    };

    item.setStatus = function(params){
      return $http.post(ApiUri + '/companies/sensor/setStatus',params);
    };

    item.setStatuses = function(params){
      return $http.post(ApiUri + '/companies/sensor/setStatuses',params);
    };

    item.listExport = function(params){
      return $http({method: 'GET', url: ApiUri + '/companies/sensor/list', responseType: "arraybuffer", params:params});
    };

    return item;
  });

/**
 * Created by Елена on 24.05.2016.
 */
angular.module('web')
  .factory('Reestr', function($http, ApiUri){
    var item = {};

    item.cnt = function(params){
      return $http.get(ApiUri + '/owners/cnt',{params:params});
    };

    item.list = function(params){
      return $http.get(ApiUri + '/owners',{params:params});
    };

    item.load = function(id){
      return $http.get(ApiUri + '/owners/item',{params:{id:id}});
    };

    item.loadLogin = function(params){
      return $http.get(ApiUri + '/owners/item',{params:params});
    };

    item.create = function(item){
      return $http.post(ApiUri + '/owners/create',item);
    };

    item.update = function(item){
      return $http.post(ApiUri + '/owners/update',item);
    };

    item.changePass = function(params){
      return $http.post(ApiUri + '/owners/changePass',params);
    };

    item.delete = function(id){
      return $http.post(ApiUri + '/owners/delete',{id:id});
    };

    item.params = function(params){
      return $http.get(ApiUri + '/reestr/params',{params:params});
    };

    return item;
  });

/**
 * Created by Елена on 31.08.2016.
 */

angular.module('web')
  .factory('Message', function($http, ApiUri){
    var worker = {};

    worker.list = function(params){
      return $http.get(ApiUri + '/messages',{params:params});
    };

    worker.load = function(id){
      return $http.get(ApiUri + '/messages/item',{params:{id:id}});
    };

    worker.create = function(item){
      return $http.post(ApiUri + '/messages/create',item);
    };

    worker.update = function(item){
      return $http.post(ApiUri + '/messages/update',item);
    };

    worker.changePass = function(params){
      return $http.post(ApiUri + '/messages/changePass',params);
    };

    worker.delete = function(id){
      return $http.post(ApiUri + '/messages/delete',{id:id});
    };

    return worker;
  });

/**
 * Created by Елена on 24.05.2016.
 */
angular.module('web')
  .factory('Flat', function($http, ApiUri){
    var flat = {};

    flat.cnt = function(params){
      return $http.get(ApiUri + '/flats/cnt',{params:params});
    };

    flat.list = function(params){
      return $http.get(ApiUri + '/flats',{params:params});
    };

    flat.load = function(id){
      return $http.get(ApiUri + '/flats/item',{params:{id:id}});
    };

    flat.loadLogin = function(params){
      return $http.get(ApiUri + '/flats/item',{params:params});
    };

    flat.create = function(item){
      return $http.post(ApiUri + '/flats/create',item);
    };

    flat.create_multiple = function(params){
      return $http.post(ApiUri + '/flats/create_multiple',params);
    };

    flat.update = function(item){
      return $http.post(ApiUri + '/flats/update',item);
    };

    flat.changePass = function(params){
      return $http.post(ApiUri + '/flats/changePass',params);
    };

    flat.delete = function(id){
      return $http.post(ApiUri + '/flats/delete',{id:id});
    };

    return flat;
  });

/**
 * Created by Елена on 20.06.2016.
 */
angular.module('web')
  .factory('Counter', function($http, ApiUri){
    var counter = {};

    counter.list = function(params){
      return $http.get(ApiUri + '/counters',{params:params});
    };

    counter.listTypes = function(params){
      return $http.get(ApiUri + '/counters/types',{params:params});
    };

    counter.listModels = function(params){
      return $http.get(ApiUri + '/counters/models',{params:params});
    };

    counter.load = function(id){
      return $http.get(ApiUri + '/counters/item',{params:{id:id}});
    };

    counter.loadParams = function(params){
      return $http.get(ApiUri + '/counters/item/params',{params:params});
    };

    counter.create = function(item){
      return $http.post(ApiUri + '/counters/create',item);
    };

    counter.create_multiple = function(params){
      return $http.post(ApiUri + '/counters/create_multiple',params);
    };

    counter.update = function(item){
      return $http.post(ApiUri + '/counters/update',item);
    };

    counter.delete = function(id){
      return $http.post(ApiUri + '/counters/delete',{id:id});
    };

    return counter;
  });

/**
 * Created by Елена on 26.08.2016.
 */
angular.module('web')
  .factory('Feedback', function($http, ApiUri){
    var feedback = {};

    feedback.cnt = function(params){
      return $http.get(ApiUri + '/feedback/cnt',{params:params});
    };

    feedback.list = function(params){
      return $http.get(ApiUri + '/feedback/items',{params:params});
    };

    feedback.load = function(id){
      return $http.get(ApiUri + '/feedback/item',{params:{id:id}});
    };

    feedback.create = function(item){
      return $http.post(ApiUri + '/feedback/create',item);
    };

    feedback.update = function(item){
      return $http.post(ApiUri + '/feedback/update',item);
    };

    feedback.updateRead = function(item){
      return $http.post(ApiUri + '/feedback/update/read',item);
    };

    feedback.delete = function(item){
      return $http.post(ApiUri + '/feedback/delete',item);
    };

    return feedback;
  });

/**
 * Created by Елена on 28.06.2016.
 */
angular.module('web')
  .factory('CounterStats', function($http, ApiUri){
    var counter_stats = {};

    counter_stats.cnt = function(params){
      return $http.get(ApiUri + '/counters/stats/cnt',{params:params});
    };

    counter_stats.list = function(params){
      return $http.get(ApiUri + '/counters/stats',{params:params});
    };

    counter_stats.totalList = function(params){
      return $http.get(ApiUri + '/counters/stats/total',{params:params});
    };

    counter_stats.listStatuses = function(params){
      return $http.get(ApiUri + '/counters/stats/statuses',{params:params});
    };

    counter_stats.changeStatus = function(params){
      return $http.post(ApiUri + '/counters/stats/update/change_status',params);
    };

    return counter_stats;
  });

/**
 * Created by Елена on 16.03.2017.
 */
angular.module('web')
  .factory('Control', function($http, ApiUri){
    var item = {};

    item.list = function(params){
      return $http.get(ApiUri + '/companies/control/list',{params:params});
    };

    item.send = function(params){
      return $http.post(ApiUri + '/companies/control/send',params);
    };

    item.listSimple = function(params){
      return $http.get(ApiUri + '/control/simple/list',{params:params});
    };

    item.sendSimple = function(params){
      return $http.post(ApiUri + '/control/simple/send',params);
    };

    return item;
  });

/**
 * Created by Елена on 08.05.2018.
 */
angular.module('web')
  .factory('Alerts', function($http, ApiUri){
    var item = {};

    item.list = function(params){
      return $http.get(ApiUri + '/alert/list',{params:params});
    };

    item.cnt = function(params){
      return $http.get(ApiUri + '/alert/cnt',{params:params});
    };

    return item;
  });

/**
 * Created by Елена on 23.05.2016.
 */
angular.module('web')
  .factory('Address', function($http, ApiUri){
    var address = {};

    address.list = function(params){
      return $http.get(ApiUri + '/addresses',{params:params});
    };

    address.load = function(id){
      return $http.get(ApiUri + '/addresses/item',{params:{id:id}});
    };

    // общее к-во голосов по адресу
    address.totalNumVotes = function(params){
      return $http.get(ApiUri + '/addresses/totalNumVotes',{params:params});
    };

    address.update = function(item){
      return $http.post(ApiUri + '/addresses/update',item);
    };

    address.updateImage = function(params){
      return $http.post(ApiUri + '/addresses/update/image',params);
    };

    return address;
  });

(function() {
  'use strict';

  angular
    .module('web')
    .controller('WorkersController', WorkersController);

  /** @ngInject */
  function WorkersController($state, $log, dialogs, User, Worker) {
    var vm = this;
    vm.title = 'Список сотрудников';

    var init = function(){
      Worker.list({company_id:User.data.company_id})
        .success(function(result){
          vm.items = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.delete = function(item){
      //проверям что удаляем не авторизованного пользователя
      if(item.id == User.data.id){
        dialogs.error('Возникли следующие ошибки', 'Невозможно удалить текущего авторизованного пользователя');
      } else {
        var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить сотрудника "'+item.name+'"?');
        dlg.result.then(function(){
          Worker.delete(item.id)
            .success(function(){
              init();
            })
            .error(function() {
              $log.debug('error');
            });
        },function(){});
      }
    };

    init();
  }
})();

/**
 * Created by Елена on 24.04.2017.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('WorkersPermitionsController', WorkersPermitionsController);

  function WorkersPermitionsController($state, $log, $stateParams, dialogs, customDialogs, Worker) {
    var vm = this;

    var initWorker = function(id){
      Worker.load(parseInt(id))
        .success(function (result) {
          vm.worker = result;
          //список прав сотрудника
          initWorkerPermitions(vm.worker.id);

          //список всех путей из route
          vm.states = [];
          var states = $state.get();
          for (var i=0;i<states.length;i++){
            // выводим если у state не стоит признак abstract и не указано, что доступ всем разрешен (toState.data.accessAll)
            if(!states[i].abstract && (angular.isUndefined(states[i].data) || (angular.isDefined(states[i].data) && !states[i].data.accessAll))){
              vm.states.push(states[i]);
            }
          }
        })
        .error(function () {
          vm.error = "Карточка сотрудника не найдена";
        });
    };

    //список прав сотрудника
    var initWorkerPermitions = function(worker_id){
      Worker.listPermitions({worker_id:parseInt(worker_id)})
        .success(function (result) {
          vm.worker.states = {};
          for (var i=0;i<result.length;i++){
            vm.worker.states[result[i].state] = result[i].state;
          }

          //если выбраны все права, ставим отметку (checked) что выбраны все
          if(result.length == vm.states.length){
            vm.selectAll = true;
          } else {
            vm.selectAll = false;
          }
        })
        .error(function () {
          vm.error = "Ошибка при получении прав сотрудника";
        });
    };

    if (angular.isNumber($stateParams.id)) {
      initWorker($stateParams.id);
    } else {
      vm.error = "Карточка сотрудника не найдена";
    }

    //вкл./выкл. всех прав в списке
    vm.toggleAll = function(){
      if(vm.selectAll){
        vm.dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите добавить все права сотруднику "'+vm.worker.name+'"?');
        vm.dlg.result.then(function() {
          for (var i=0;i<vm.states.length;i++){
            vm.worker.states[vm.states[i].name] = vm.states[i].name;
          }
          vm.send();
        })
      } else {
        vm.dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить все права у сотрудника "'+vm.worker.name+'"?');
        vm.dlg.result.then(function() {
          for (var i=0;i<vm.states.length;i++){
            vm.worker.states[vm.states[i].name] = false;
          }
          vm.send();
        })
      }
    };

    vm.send = function () {
      if (!vm.form.$invalid) {
        Worker.setPermitions({worker_id:vm.worker.id,states:vm.worker.states})
          .success(function () {
            customDialogs.success();

            initWorkerPermitions(vm.worker.id);
          })
          .error(function (errors) {
            $log.error(errors);
            vm.error = 'Ошибка при сохранении прав доступа';
          });
      }
    };

  }

})();

/**
 * Created by Елена on 23.05.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('WorkersFormController', WorkersFormController);

  function WorkersFormController($state, $log, $stateParams, customDialogs, Validation, User, Worker) {
    var vm = this;
    vm.item = {
      active: true,
      company_id: User.data.company_id
    };

    var initWorker = function (id) {
      Worker.load(id)
        .success(function (result) {
          vm.item = result;
        })
        .error(function () {
          $log.debug('error');
        });
    };

    if (angular.isNumber($stateParams.id)) {
      initWorker($stateParams.id);
    }

    vm.send = function () {
      if (vm.item.id) {
        updateWorker();
      } else {
        createWorker();
      }
    };

    //Генерируется пароль
    vm.generatePassword = function () {
      vm.item.password = vm.password = vm.re_password = User.generatePassword();
    };

    vm.changePass = function () {
      if (!vm.formPass.$invalid) {
        var params = {
          id:vm.item.id,
          password:vm.password,
          re_password:vm.re_password
        };
        Worker.changePass(params)
          .success(function () {
            //чистка полей формы
            vm.password = null;
            vm.re_password = null;

            //приводим форму к первоначальному статусу
            vm.formPass.$setPristine();
            vm.formPass.$setUntouched();

            customDialogs.success('Пароль успешно изменен');
          })
          .error(function (errors) {
            Validation.parseErrors(vm.formPass, errors);
          });
      }
    };

    var createWorker = function () {
      if (!vm.form.$invalid) {
        Worker.create(vm.item)
          .success(function (id) {
            //добавляем право на просмотр общей информации
            Worker.setPermitions({worker_id:id,states:{home:'home'}})
              .success(function () {
                $state.go('workers');
              })
              .error(function (errors) {
                $log.error(errors);
                vm.error = 'Ошибка при сохранении прав доступа';
              });
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updateWorker = function () {
      if (!vm.form.$invalid) {
        Worker.update(vm.item)
          .success(function () {
            initWorker(vm.item.id);
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

  }

})();

/**
 * Created by Елена on 10.08.2018
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('VotingResultFormController', VotingResultFormController);

  /** @ngInject */
  function VotingResultFormController($window, $stateParams, $log, moment, customDialogs, Validation, Address, Voting, Reestr) {
    var vm = this;
    vm.indexTab = 0;
    vm.now = moment();
    vm.item = {
      active: true
    }

    vm.send = function () {
      if (vm.item.id) {
        update();
      } else {
        create();
      }
    }

    // Загружает данные
    var init = function (voting_id,owner_id) {
      Voting.loadResult({owner_id:owner_id,voting_id:voting_id})
        .success(function (results) {
          vm.item = results[0];
          vm.item.answers = {};
          angular.forEach(results,function (result) {
            vm.item.answers[result.question_id] = result.answer_id;
          })
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных';
        })
    }

    // Загружает варианты ответов
    var initAnswers = function () {
      Voting.answers()
        .success(function (result) {
          vm.answers = result;
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке ответов для голосования'
        })
    }

    // Загружает данные по голосованию
    var initVoting = function (id) {
      Voting.load(id)
        .success(function (result) {
          vm.voting = result;
          initQuestions();
          initAddress(vm.voting.address_id);
          initOwners(vm.voting.address_id);

          // если в get-парметре указан id, загружаем данные
          if(angular.isNumber($stateParams.owner_id)){
            init(vm.voting.id, $stateParams.owner_id);
          }

        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных по голосованию';
        })
    }

    // Загружает адрес
    var initAddress = function (id) {
      Address.load(id)
        .success(function (result) {
          vm.address = result;
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных по голосованию';
        })
    }

    // подгружаем список собственников
    var initOwners = function (address_id) {
      Reestr.list({address_id: address_id})
        .success(function (result) {
          vm.owners = result;
          if(vm.item.owner_id){
            vm.owner = vm.owners.find(function(item){return item.id === vm.item.owner_id});
          }
        })
        .error(function () {
          $log.debug('error');
        });
    }

    // вопросы голосования
    var initQuestions = function(){
      Voting.questions({voting_id:vm.voting.id})
        .success(function (result) {
          vm.questions = result;
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке вопросов голосования'
        })
    }

    var create = function () {
      vm.form.error = '';
      if (!vm.form.$invalid) {
        Voting.createResult(vm.item)
          .success(function () {
            $window.history.back();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    }

    var update = function () {
      vm.form.error = '';
      if (!vm.form.$invalid) {
        Voting.updateResult(vm.item)
          .success(function () {
            init(vm.voting.id,vm.item.owner_id);
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          })
      }
    }

    // если в get-парметре указан voting_id
    if(angular.isNumber($stateParams.voting_id)){
      vm.item.voting_id = $stateParams.voting_id;
      initVoting(vm.item.voting_id);
    }

    initAnswers();
  }
})();

/**
 * Created by Елена on 16.08.2018
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('VotingQuestionFormController', VotingQuestionFormController);

  /** @ngInject */
  function VotingQuestionFormController($window, $stateParams, moment, customDialogs, Validation, Address, Voting) {
    var vm = this;
    vm.indexTab = 0;
    vm.now = moment();
    vm.item = {
      active: true
    }

    vm.send = function () {
      if (vm.item.id) {
        update();
      } else {
        create();
      }
    }

    // Загружает данные
    var init = function (id) {
      Voting.loadQuestion(id)
        .success(function (result) {
          if(result){
            vm.item = result;
            initVoting(vm.item.voting_id);
          }
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных';
        })
    }

    // Загружает данные по голосованию
    var initVoting = function (id) {
      Voting.load(id)
        .success(function (result) {
          vm.voting = result;
          initAddress(vm.voting.address_id);
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных по голосованию';
        })
    }

    // Загружает данные по голосованию
    var initAddress = function (id) {
      Address.load(id)
        .success(function (result) {
          vm.address = result;
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных по голосованию';
        })
    }

    var create = function () {
      vm.form.error = '';
      if (!vm.form.$invalid) {
        Voting.createQuestion(vm.item)
          .success(function () {
            $window.history.back();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    }

    var update = function () {
      vm.form.error = '';
      if (!vm.form.$invalid) {
        Voting.updateQuestion(vm.item)
          .success(function () {
            init(vm.item.id);
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          })
      }
    }

    // если в get-парметре указан voting_id
    if(angular.isNumber($stateParams.voting_id)){
      vm.item.voting_id = $stateParams.voting_id;
      initVoting(vm.item.voting_id);
    }

    // если в get-парметре указан id, загружаем данные
    if(angular.isNumber($stateParams.id)){
      init($stateParams.id);
    }
  }
})();

/**
 * Created by Елена on 30.07.2018
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('VotingFormController', VotingFormController);

  /** @ngInject */
  function VotingFormController($window, $state, $stateParams, $log, dialogs, moment, customDialogs, Validation, Address, Voting) {
    var vm = this;
    vm.indexTab = 0;
    vm.openResult = false;
    vm.openFormResult = false;
    vm.now = new Date();
    vm.item = {
      active: true
    }
    // для списка проголосовавших
    vm.page = 1;

    vm.setIndex = function(index){
      // для истории переходов
      $state.go('voting.item',{id:vm.item.id,index:index},{notify:false});

      // если открыт раздел Результаты
      if(index === 1){
        // результаты голосования
        getVotingResults()
      }

      // если открыт раздел Список проголосовавших
      if(index === 2){
        vm.getVotingResultOwners()
      }

      // если открыт раздел Вопросы
      if(index === 3){
        getVotingQuestions()
      }
    }

    // список адресов
    Address.list()
      .success(function(result){
        vm.addresses = result;
      })
      .error(function() {
        $log.debug('error');
      })

    // параметры реестра для селектов
    Voting.params()
      .success(function(result){
        vm.params = {};
        angular.forEach(result, function (item) {
          if(!vm.params[item['type']]){
            vm.params[item['type']] = [];
          }
          vm.params[item['type']].push(item);
        })
      })
      .error(function() {
        $log.debug('error');
      })

    vm.send = function () {
      vm.error = vm.form.error = '';

      var params = Object.assign({}, vm.item);
      params.tm_start = (params.tm_start ? moment(new Date(params.tm_start)).format('YYYY-MM-DD 00:00:00') : '');
      params.tm_end = (params.tm_end ? moment(new Date(params.tm_end)).format('YYYY-MM-DD 23:59:59') : '');

      if (vm.item.id) {
        update(params);
      } else {
        create(params);
      }
    }

    vm.setVotingStatus = function () {
      vm.form.error = "";

      if (!vm.form.$invalid) {
        var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены? После запуска голосование невозможно будет редактировать');
        dlg.result.then(function () {
          // проверяем что вопросы созданы
          if(!vm.questions.length){
            vm.form.error = "Перед запуском необходимо добавить вопросы голосования"
          } else {
            // перед запуском у всех жильцов должен быть заполнен параметр К-во голосов
            Voting.validateNumVotes({voting_id:vm.item.id})
              .success(function (response) {
                if (response.length) {
                  vm.errorOwners = response;
                  vm.form.error = "Необходимо заполнить количество голосов для жильцов ";
                } else {
                  vm.item.status = 1;
                  // считаем общее к-во голосов по адресу и сохраняем в голосовании для дальнейшего подсчета результатов
                  Address.totalNumVotes({address_id: vm.item.address_id})
                    .success(function(result){
                      var params = Object.assign({}, vm.item);
                      params.tm_start = (params.tm_start ? moment(new Date(params.tm_start)).format('YYYY-MM-DD 00:00:00') : '');
                      params.tm_end = (params.tm_end ? moment(new Date(params.tm_end)).format('YYYY-MM-DD 23:59:59') : '');
                      params.num_votes = result;

                      Voting.update(params)
                        .success(function () {
                          init(vm.item.id);
                          customDialogs.success();
                        })
                        .error(function (errors) {
                          vm.item.status = 0;
                          Validation.parseErrors(vm.form, errors);
                        })
                    })
                    .error(function() {
                      vm.form.error = "Ошибка при получении количества голосов по указанному адресу"
                    })
                }
              })
              .error(function () {
                vm.form.error = "Ошибка при проверке данных голосования"
              })
          }
        })
      }
    }

    // Удаление ответа собственника на голосование
    vm.deleteResult = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить ответ собственника "кв. ' + item.flat + ' - ' + item.contacts.name + '?');
      dlg.result.then(function () {
        Voting.deleteResult(item.result_id)
          .success(function () {
            vm.getVotingResultOwners();
          })
          .error(function () {
            vm.error = 'Ошибка при удалении ответа';
          });
      });
    }

    // Удаление ответа собственника на голосование
    vm.deleteQuestion = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить вопрос "' + item.name + '?');
      dlg.result.then(function () {
        Voting.deleteQuestion(item.id)
          .success(function () {
            getVotingQuestions();
          })
          .error(function () {
            vm.error = 'Ошибка при удалении ответа';
          });
      });
    }

    // Протокол результатов голосования
    vm.protocol = function () {
      $window.location = '/api/voting/protocol?id='+vm.item.id;

      /*
        var url;
        Voting.protocol({id:vm.item.id})
        .success(function (data) {
          //месяц и год принятия показаний счетчиков это след месяц от указанного в форме (текущий месяц в программе Бонус)
          vm.fileName = 'protocol.docx';
          vm.fileBlob = new Blob([data],{type:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
          if($window.navigator.msSaveOrOpenBlob) {
            vm.msSaveOrOpenBlob = true;
          } else {
            url = $window.URL || $window.webkitURL;
            vm.fileUrl = url.createObjectURL(vm.fileBlob);
          }
        })
        .error(function () {
          vm.error = 'Ошибка при формировании протокола';
        });
      */

    }

    //скачивание файла для IE11
    vm.msDownloadFile = function(blob, fileName){
      $window.navigator.msSaveOrOpenBlob(blob, fileName);
    };

    // Загружает данные
    var init = function (id) {
      Voting.load(id)
        .success(function (result) {
          // копируем объект, чтобы не переопределялись параметры
          vm.item = Object.assign({}, result);
          vm.item.tm_start = moment(vm.item.tm_start).format('YYYY-MM-DD');
          vm.item.tm_end = moment(vm.item.tm_end).format('YYYY-MM-DD');

          // если открыт раздел Список проголосовавших
          if($stateParams.index === 2){
            // результаты голосования
            vm.getVotingResultOwners()
          }

          // вопросы голосования
          getVotingQuestions()

          // открывает кнопку "Добавить ответ от жильца"
          // если текущая дата меньше даты окончания
          if(moment(result.tm_start).isBefore(vm.now) && moment(vm.now).isBefore(result.tm_end)){
            vm.openFormResult = true;
          }

          // открывает раздел "Результаты"
          // если текущая дата больше даты старта
          if(result.status === 1 && moment(result.tm_start).isBefore(vm.now)){
            vm.openResult = true;
          }
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке данных по голосованию'
        })
    }

    var create = function (params) {
      if (!vm.form.$invalid) {
        Voting.create(params)
          .success(function(id) {
            init(id);
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    }

    var update = function (params) {
      if (!vm.form.$invalid) {
        Voting.update(params)
          .success(function () {
            init(vm.item.id);
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          })
      }
    }

    // вопросы голосования
    var getVotingQuestions = function(){
      Voting.questions({voting_id:vm.item.id})
        .success(function (result) {
          vm.questions = result;

          // если открыт раздел Результаты
          if($stateParams.index === 1){
            // результаты голосования
            getVotingResults()
          }
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке вопросов голосования'
        })
    }

    // результаты голосования
    var getVotingResults = function(){
      angular.forEach(vm.questions, function(question){
        Voting.result({question_id:question.id})
          .success(function (result) {
            question.result = result
          })
          .error(function () {
            vm.error = 'Ошибка при загрузке результатов голосования'
          })
      })

      // количество проголосовавших
      Voting.resultCnt({id:vm.item.id})
        .success(function (result) {
          vm.cnt_owners = result;
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке количества проголосовавших'
        })
    }

    // список проголосовавших
    vm.getVotingResultOwners = function(){
      //лимит для списка жильцов
      vm.ownerParams = {voting_id:vm.item.id, limit: 10};
      vm.ownerParams.offset = (vm.ownerParams.limit * (vm.page - 1));

      // количество проголосовавших
      Voting.resultCnt({id:vm.item.id})
        .success(function (result) {
          vm.cnt_owners = result;

          Voting.resultOwners(vm.ownerParams)
            .success(function (result) {
              vm.item.result_owners = result;
            })
            .error(function () {
              vm.error = 'Ошибка при загрузке списка проголосовавших'
            })
        })
        .error(function () {
          vm.error = 'Ошибка при загрузке количества проголосовавших'
        })
    }

    // если в get-парметре указан index
    if(angular.isNumber($stateParams.index)){
      vm.indexTab = $stateParams.index;
    }

    // если в get-парметре указан address_id
    if(angular.isNumber($stateParams.address_id)){
      vm.item.address_id = $stateParams.address_id;
    }

    // если в get-парметре указан id, загружаем данные
    if(angular.isNumber($stateParams.id)){
      init($stateParams.id);
    }

  }
})();

/**
 * Created by Елена on 30.07.2018
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('VotingController', VotingController);

  /** @ngInject */
  function VotingController($stateParams, $log, dialogs, Address, Voting) {
    var vm = this;
    vm.title = 'Список голосований';
    vm.now = new Date();
    vm.items = [];
    //лимит для списка жильцов
    vm.findParams = {
      limit: 10
    }
    vm.page = 1;

    //если в get-парметре указан address_id
    if(angular.isNumber($stateParams.address_id)){
      vm.findParams.address_id = $stateParams.address_id;
    }

    vm.init = function () {
      Address.list()
        .success(function (result) {
          vm.addresses = result;
          if(vm.addresses.length && !vm.findParams.address_id){
            vm.findParams.address_id = vm.addresses[0].id;
          }
          vm.initVotings();
        })
        .error(function () {
          $log.debug('error');
        });
    }

    vm.initVotings = function () {
      vm.findParams.offset = (vm.findParams.limit * (vm.page - 1));

      Voting.cnt(vm.findParams)
        .success(function (result_cnt) {
          vm.cntItems = result_cnt;

          Voting.list(vm.findParams)
            .success(function (result) {
              vm.items = result;
            })
            .error(function () {
              $log.debug('error');
            })
        })
        .error(function () {
          $log.debug('error');
        })
    }

    vm.delete = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить голосование "' + item.name + '?');
      dlg.result.then(function () {
        Voting.delete(item.id)
          .success(function () {
            vm.init();
          })
          .error(function () {
            $log.debug('error');
          });
      });
    }

    vm.init()
  }
})();

/**
 * Created by Елена on 25.08.2017.
 */

(function() {
  'use strict';

  angular
    .module('web')

    //подключаем модуль для загрузки данных через iframe
    .filter('trustAsResourceUrl', function($sce) {
      return function(val) {
        return $sce.trustAsResourceUrl(val);
      }
    })

    .controller('VideoController', VideoController);

  /** @ngInject */
  function VideoController($state, $timeout, $log, moment, Video) {
    var vm = this,
        tm = moment(new Date()).add(10,'h').format('X');
    //tm (timestamp) -  время-период для отображения видео (добавляем 10 часов, видео доступно 10 часов)
    var initCameras = function(){
      Video.list()
        .success(function(items){
          vm.cameras = {};
          angular.forEach(items,function(item){
            vm.cameras[item.cam_id] = item;
          });
          angular.forEach(vm.cameras,function(camera){
              camera.isPlaying = 0;
              //запрос на rtmp поток
              Video.rtmpSecureKey({camera_id: camera.cam_id, tm: tm})
                .success(function (result) {
                  camera.srcs = [];
                  if (result.key) {
                    camera.srcs.push('rtmp://' + camera.cam_rtmp_server_ip + ':' + camera.cam_rtmp_server_port + '/hls/cam' + camera.cam_id + '?e=' + tm + '&st=' + result.key);
                    camera.srcs.push('https://' + camera.cam_rtmp_server_host + '/hls/cam' + camera.cam_id + '/index.m3u8' + '?e=' + tm + '&st=' + result.key + '&id=' + camera.cam_id);
                    camera.player = new Clappr.Player({
                      sources: camera.srcs,
                      mediacontrol: {seekbar: "#E113D3", buttons: "#66B2FF"},
                      mute: true,
                      autoPlay: true,
                      parentId: "#cam" + camera.group__id + camera.cam_id,
                      playbackNotSupportedMessage: 'Insys CCTV, no signal',
                      rtmpConfig: {
                        swfPath: 'https://video2.profintel.ru/video/RTMP.swf',
                        scaling: 'letterbox',
                        playbackType: 'live',
                        bufferTime: 2,
                        startLevel: 0
                      },
                      hideMediaControl: true
                    });

                    //Events http://clappr.github.io/classes/Events.html
                    camera.player.once(Clappr.Events.PLAYER_READY, function () {
                      // camera.player.play();
                      $timeout(function () {
                        camera.isPlaying = 1;
                      },1000);
                      // console.log("cameraEVENT: PLAYER_READY");
                    });
                    camera.player.on(Clappr.Events.PLAYER_TIMEUPDATE , function () {
                      if($state.current.name != "video"){
                        camera.player.stop();
                        camera.player.destroy();
                      }
                      // console.log("cameraEVENT: CONTAINER_TIMEUPDATE ");
                    });
                  }
                })
                .error(function (error) {
                  $log.error('error', error);
                });
          });
        })
        .error(function(error) {
          $log.error('error', error);
        });
    };

    initCameras();

  }
})();

/**
 * Created by Елена on 31.08.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('TechniciansController', TechniciansController);

  /** @ngInject */
  function TechniciansController($state, $log, dialogs, User, Technician) {
    var vm = this;

    var init = function(){
      Technician.list({company_id:User.data.company_id})
        .success(function(result){
          vm.items = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.delete = function(item){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить специалиста "'+item.name+'" и все заявки по этому специалисту?');
      dlg.result.then(function(){
        Technician.delete(item.id)
          .success(function(){
            $state.go($state.current, {}, {reload: true});
          })
          .error(function() {
            $log.debug('error');
          });
      },function(){});
    };

    init();
  }
})();

/**
 * Created by Елена on 31.08.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('TechniciansFormController', TechniciansFormController);

  function TechniciansFormController($state, $log, $stateParams, customDialogs, Validation, User, Address, Technician) {
    var vm = this;
    vm.item = {
      company_id: User.data.company_id
    };

    //Загружает данные по специалисту
    var initTechnician = function (id) {
      Technician.load(id)
        .success(function (result) {
          vm.item = result;
        })
        .error(function () {
          $log.debug('error Technician.load');
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initTechnician($stateParams.id);
    }

    vm.send = function () {
      if (vm.item.id) {
        updateTechnician();
      } else {
        createTechnician();
      }
    };

    var createTechnician = function () {
      if (!vm.form.$invalid) {
        Technician.create(vm.item)
          .success(function () {
            $state.go('technicians');
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updateTechnician = function () {
      if (!vm.form.$invalid) {
        Technician.update(vm.item)
          .success(function () {

            //приводим форму к первоначальному статусу
            vm.form.$setPristine();
            vm.form.$setUntouched();

            initTechnician(vm.item.id);

            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

  }

})();

/**
 * Created by Елена on 26.08.2016.
 */

(function() {
  'use strict';

  angular
    .module('web')
    .controller('TechOrderFormController', TechOrderFormController);

  /** @ngInject */
  function TechOrderFormController($rootScope, $stateParams, $log, moment, customDialogs, Validation, User, TechOrder, Worker, Mail) {
    var vm = this;
    vm.title = 'Вопрос - ответ';
    vm.item = {
      company_id: User.data.company_id
    };
    //необязательные параметры формы смены статуса
    vm.status = {
      comment: null
    };
    vm.error = '';

    //список статусов
    var initStatuses = function(){
      TechOrder.listStatuses()
        .success(function(result){
          vm.statuses = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    // список сотрудников
    var initWorkers = function(){
      vm.workers = [{id:null,name:'не указано'}];
      Worker.list({company_id:User.data.company_id})
        .success(function(result){
          vm.workers = vm.workers.concat(result);
        })
        .error(function() {
          $log.debug('error');
        });
    };

    //Загружает данные по заявке
    var initTechOrder = function (id) {
      TechOrder.load(id)
        .success(function (result) {
          vm.item = result;
          vm.item.date = moment(new Date(vm.item.date)).format('YYYY-MM-DD HH:mm:ss');
          vm.status.status_id =vm.item.status_id;

          //список статусов
          initStatuses();
          //список сотрудников
          initWorkers();
          //история статусов
          initOrderStatuses();

          //ставим отметку "Просмотрено", если ее нет
          if(!result.read_company){
            TechOrder.updateRead({id:result.id,read_company:true})
              .success(function() {
                //к-во непрочитанных сообщений в разделе
                TechOrder.cnt({company_id:User.data.company_id,read_company: false})
                  .success(function(result_cnt){
                    $rootScope.newMsg.tech_orders = result_cnt;
                  })
                  .error(function() {
                    vm.form.error = 'Ошибка при загрузке количества сообщений';
                  });
              })
              .error(function (errors) {
                Validation.parseErrors(vm.form, errors);
              });
          }
        })
        .error(function (error) {
          vm.error = 'Ошибка при запросе данных заявки';
          $log.debug(error);
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initTechOrder($stateParams.id);
    } else {
      vm.error = 'Ошибка при запросе данных заявки';
    }

    //значение worker_id по умолчанию
    vm.clearWorkerId = function(){
      $log.debug('clearWorkerId', vm.item.worker_id);
      vm.item.worker_id = null;
    };

    vm.send = function () {
      if (vm.item.id) {
        updateTechOrder();
      }
    };

    var updateTechOrder = function () {
      vm.form.error = '';
      if (!vm.form.$invalid) {
        vm.item.date = moment(new Date(vm.item.date)).format('YYYY-MM-DD HH:mm:ss');
        TechOrder.update(vm.item)
          .success(function () {
            //приводим форму к первоначальному статусу
            vm.form.$setPristine();
            vm.form.$setUntouched();

            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    // Загружает историю статусов
    var initOrderStatuses = function () {
      //список статусов текущего заказа
      TechOrder.listOrderStatuses({order_id:vm.item.id})
        .success(function(result){
          vm.order_statuses = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.changeStatus = function () {
      if (!vm.form.$invalid) {
        if (vm.status.status_id == vm.item.status_id) {
          vm.form.error = 'Выбранный статус заявки совпадает с текущим';
        } else {
          vm.status.order_id = vm.item.id;
          //записываем в историю статус
          TechOrder.createOrderStatus(vm.status)
            .success(function () {
              //приводим форму к первоначальному статусу
              vm.form.$setPristine();
              vm.form.$setUntouched();

              // меняем статус у заявки
              vm.item.status_id = vm.status.status_id;
              //ставим отметку "Не просмотрено" для жильца
              vm.item.read_flat = false;
              updateTechOrder();

              // отправляем уведомление на email
              sendMail();
              initOrderStatuses();
            })
            .error(function (errors) {
              Validation.parseErrors(vm.form, errors);
            });
        }
      }
    };

    var sendMail = function(){
      if(vm.item.flat_email){
        TechOrder.loadStatus(vm.status.status_id)
          .success(function (status) {
            var message = '<h3>Заявка #'+vm.item.id+'</h3>' +
              '<table border="0" cellspacing="0" cellpadding="5" style="font-size:14px; color:#666;">' +
                '<tr><td><strong>Адрес</strong></td><td>'+ vm.item.address +'</td></tr>' +
                '<tr><td><strong>Специалист</strong></td><td>'+ vm.item.technician +(vm.item.worker ? " ("+vm.item.worker+") " : "")+'</td></tr>' +
                '<tr><td><strong>Комментарий</strong></td><td>'+ vm.item.comment +'</td></tr>' +
                '<tr><td colspan="2">&nbsp;</td></tr>' +
                '<tr><td><strong>Дата прихода специалиста</strong></td><td>'+moment(new Date(vm.item.date)).format('DD.MM.YYYY HH:mm') +'</td></tr>' +
                '<tr><td><strong>Статус заявки</strong></td><td>'+status.name+'</td></tr>' +
                (vm.status.comment ? '<tr><td><strong>Комментарий статуса</strong></td><td>'+vm.status.comment+'</td></tr>' : '') +
              '</table>';
            Mail.send({
                senderName: User.data.company.name,
                email: vm.item.flat_email,
                subject: 'Смена статуса заявки на вызов специалиста от '+User.data.company.name,
                message: message
              })
              .success(function() {
                customDialogs.success('Уведомление на email успешно отправлено');
              })
              .error(function (error) {
                vm.form.error = 'Ошибка при отправке уведомления о смене статуса на email';
                $log.error(error);
              });
          })
          .error(function (error) {
            vm.form.error = 'Ошибка при запросе данных статуса';
            $log.error(error);
          });
      }
    }
  }
})();

/**
 * Created by Елена on 26.08.2016.
 */

(function() {
  'use strict';

  angular
    .module('web')
    .controller('TechOrderController', TechOrderController);

  /** @ngInject */
  function TechOrderController($log, dialogs, User, Address, Flat, TechOrder, Technician) {
    var vm = this;
    vm.address = [];
    //лимит списка
    vm.limit = 30;
    vm.page = 1;

    vm.init = function(){
      TechOrder.cnt({company_id:User.data.company_id,deleted_company: false})
        .success(function(result_cnt){
          vm.cnt_items = result_cnt;

          var params = {
            company_id:      User.data.company_id,
            deleted_company: false,
            limit:           vm.limit,
            offset:          (vm.limit * (vm.page - 1))
          };

          //загружаем данные
          TechOrder.list(params)
            .success(function(result){
              vm.items = result;
              angular.forEach(result,function(item){
                //данные по статусу
                TechOrder.loadStatus(item.status_id)
                  .success(function(data){
                    item.status = data;
                  })
                  .error(function (error) {
                    vm.error = 'Ошибка при загрузке данных статуса';
                    $log.error(error);
                  });
                //данные по специалисту
                Technician.load(item.tech_id)
                  .success(function(data){
                    item.tech = data;
                  })
                  .error(function (error) {
                    vm.error = 'Ошибка при загрузке данных специалиста';
                    $log.error(error);
                  });
                //подгружаем данные по квартире жильца
                Flat.load(item.flat_id)
                  .success(function(data){
                    item.flat = data;
                    //подгружаем данные по адресу жильца
                    Address.load(data.address_id)
                      .success(function(data){
                        item.address = data;
                      })
                      .error(function (error) {
                        vm.error = 'Ошибка при загрузке данных';
                        $log.error(error);
                      });
                  })
                  .error(function (error) {
                    vm.error = 'Ошибка при загрузке данных';
                    $log.error(error);
                  });
              })
            })
            .error(function (error) {
              vm.error = 'Ошибка при загрузке данных';
              $log.error(error);
            });
        })
        .error(function(error) {
          vm.error = 'Ошибка при загрузке количества сообщений';
          $log.error(error);
        });
    };

    vm.init();

    //Обновляет вопрос с отметкой удалено в списке пользователя
    vm.delete = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить вопрос "'+item.question+'"?');
      dlg.result.then(function(){
        //если вопрос удален у квартиры, то удаляем строку из базы
        if(item.deleted_company){
          //иначе обновляем строку с отметкой удалено в списке пользователя
          TechOrder.delete(item)
            .success(function(){
              vm.init();
            })
            .error(function(error) {
              vm.error = 'Ошибка при удалении';
              $log.error(error);
            });
        } else {
          //иначе обновляем строку с отметкой удалено в списке пользователя
          item.deleted_flat = true;
          TechOrder.update(item)
            .success(function(){
              vm.init();
            })
            .error(function(error) {
              vm.error = 'Ошибка при удалении';
              $log.error(error);
            });
        }
      },function(){});
    };
  }
})();

/**
 * Created by Елена on 19.10.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('ImportController', ImportController);

  /** @ngInject */
  function ImportController($rootScope,$cookies,$log,ApiUri,User,Company,Address,Flat,Domain,Upload,File,Sync,Validation) {
    var vm = this;
    vm.title = "Загрузка данных по квартирам";
    //смотрим в куках загруженный файл, на случай перезагрузки страницы до завершения импорта
    vm.currentFile = $cookies.get("fileImport['file']");
    //статус "Файл не загружен"
    vm.preUpload = false;
    vm.limit = 100; //лимит обрабатываемых объектов за текущий сеанс
    vm.offset = parseInt($cookies.get("fileImport['offset']")); //порядковый номер элемента, с которого начинать текущий сеанс импорта
    //% загрузки данных
    vm.progressImport = 0;
    //тип прогресбара
    vm.progressImportType = 'success';
    //список типов загрузки
    vm.types = [
      {value:'receipts',name:'Данные квартир с квитанциями'},
      {value:'counters',name:'Данные счетчиков'}
    ];
    //Загрузка данных по домену
    var initDomain = function(){
      Domain.load({company_id:User.data.company_id})
        .success(function(result){
          vm.domain = result;
        })
        .error(function (error) {
          vm.error = 'Ошибка при загрузке домена';
          $log.error(error);
        });
    };

    //Загрузка списка адресов компании
    var initAddresses = function(){
      //список адресов
      Address.list()
        .success(function(result){
          vm.addresses = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.preUploadFile = function (file, errFiles) {
      clearform();
      if(errFiles.length){
        angular.forEach(errFiles,function(error){
          vm.form.file.$setValidity('server', false);
          vm.form.file.msg = error;
        })
      } else {
        if(file){
          //статус "Файл загружен"
          vm.preUpload = true;
          vm.currentFile = file.name;
        }
      }
    };

    vm.import = function(){
      //блокируем кнопку Загрузить
      $rootScope.loading = true;

      if(!vm.address_id){
        clearform();
        vm.form.error = "Не указан адрес";
        return false;
      }
      if(!vm.type){
        clearform();
        vm.form.error = "Не указан тип загрузки";
        return false;
      }
      //если выбран новый файл, загружаем на сервер
      if(vm.preUpload){
        Upload.upload({
          url: ApiUri + '/upload',
          data: {file: vm.file, domain_id:vm.domain.id}
        }).then(function (resp) {
          //указываем что поле валидно
          vm.form.file.$setValidity('server', true);
          vm.form.file.msg = '';

          vm.file = resp.data.file;
          vm.currentFile = vm.file;

          //записываем путь в куки; удаляются куки после импорта всех данных
          $cookies.put("fileImport['file']", vm.currentFile);
          $cookies.put("fileImport['offset']", 0);
          vm.offset = 0;
          importProcess(vm.limit,vm.offset);
        }, function (resp) {
          clearform();
          vm.form.file.$setValidity('server', false);
          vm.form.file.msg = 'Ошибка при загрузке файла на сервер';
          $log.debug('Error status: ' + resp.status);
        });
      } else {
        importProcess(vm.limit,vm.offset);
      }
    };

    /**
     *  Процесс импорта данных
     *  @params: limit - лимит обрабатываемых объектов за текущий сеанс
     *           offset - порядковый номер элемента, с которого начинать текущий сеанс импорта
     */
    var importProcess = function(limit,offset){
      vm.form.error = vm.form.success = "";
      if(!vm.currentFile){
        clearform();
        vm.form.error = "Не найден файл";
        return false;
      }
      if(!vm.type){
        clearform();
        vm.form.error = "Не указан тип загрузки";
        return false;
      }
      if(!vm.type){
        clearform();
        vm.form.error = "Не указан тип загрузки";
        return false;
      }
      Sync.importFromBonus({limit:limit, offset:offset, file:vm.currentFile, type:vm.type, address_id:vm.address_id})
        .success(function(){
          vm.form.success = "Импорт успешно завершен";
          clearform();
        })
        .error(function (errors) {
          clearform();
          Validation.parseErrors(vm.form, errors);
          $log.error(errors);
        });
    };

    /**
     * Чистит параметры формы импорта,
     * удаляет загруженный файл
     */
    var clearform = function(){
      vm.form.error = "";
      //разблокируем кнопку Загрузить
      $rootScope.loading = false;

      if(vm.currentFile){
        File.unlink(vm.currentFile);
      }

      $cookies.remove("fileImport['file']");
      $cookies.remove("fileImport['offset']");
      vm.currentFile = '';

      vm.form.file.$setValidity('server', true);
      vm.form.file.msg = '';

      //% загрузки данных
      vm.progressImport = 0;
    };

    initDomain();
    initAddresses();
  }
})();

/**
 * Created by Елена on 14.11.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('ExportController', ExportController);

  /** @ngInject */
  function ExportController($window,$log,moment,Month,User,Address,Domain,Sync) {
    var vm = this;
    vm.title = "Выгрузка данных с показаниями";
    //список месяцев для выбора в форме
    vm.months = Month.list();
    vm.now = moment();
    // месяц по умолчанию
    vm.month = vm.now.get('month');
    // год по умолчанию
    vm.year = vm.now.get('year');
    //формируем список годов для выгрузки (последние 5 лет)
    vm.years = [];
    for(var i = 0; i < 5; i++) {
      vm.years.push(vm.now.get('year') - i);
    }

    //Загрузка данных по домену
    var initDomain = function(){
      Domain.load({company_id:User.data.company_id})
        .success(function(result){
          vm.domain = result;
        })
        .error(function (error) {
          vm.error = 'Ошибка при загрузке домена';
          $log.error(error);
        });
    };

    //Загрузка списка адресов компании
    var initAddresses = function(){
      //список адресов
      Address.list()
        .success(function(result){
          vm.addresses = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    var s2ab = function(s) {
      var buf, view;

      buf = new ArrayBuffer(s.length);
      view = new Uint8Array(buf);
      for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

    //формирует xml файл с данными по показаниям счетчиков
    vm.export = function () {
      var url;
      vm.msSaveOrOpenBlob = vm.fileXMLUrl = vm.fileXLSXUrl = null;

      if(!vm.address_id){
        vm.form.error = "Не указан адрес";
      } else {
        vm.form.error = "";
        // Экспорт в xml файл для программы Бонус
        Sync.exportToBonus({address_id:vm.address_id, month:vm.month, year:vm.year})
          .success(function(data){
            //месяц и год принятия показаний счетчиков это след месяц от указанного в форме (текущий месяц в программе Бонус)
            vm.fileXMLName = moment().set('year', vm.year).set('month', vm.month).format('YYYY-MM')+'.xml';
            vm.fileXMLblob = new Blob([data], { type: 'text/xml' });
            if($window.navigator.msSaveOrOpenBlob) {
              vm.msSaveOrOpenBlob = true;
            } else {
              url = $window.URL || $window.webkitURL;
              vm.fileXMLUrl = url.createObjectURL(vm.fileXMLblob);
            }
          })
          .error(function (errors) {
            vm.form.error = errors['validationErrors'][0].msg;
            $log.error(errors);
          });

        Sync.exportToOneC({address_id:vm.address_id, month:vm.month, year:vm.year})
          .success(function(data){
            //месяц и год принятия показаний счетчиков это след месяц от указанного в форме (текущий месяц в программе Бонус)
            vm.fileOneCXMLName = moment().set('year', vm.year).set('month', vm.month).format('YYYY-MM')+'.xml';
            vm.fileOneCXMLblob = new Blob([data], { type: 'text/xml' });
            if($window.navigator.msSaveOrOpenBlob) {
              vm.msSaveOrOpenBlob = true;
            } else {
              url = $window.URL || $window.webkitURL;
              vm.fileOneCXMLUrl = url.createObjectURL(vm.fileOneCXMLblob);
            }
          })
          .error(function (errors) {
            vm.form.error = errors['validationErrors'][0].msg;
            $log.error(errors);
          });


        // Экспорт в xlsx файл
        Sync.exportToExcel({address_id:vm.address_id, month:vm.month, year:vm.year})
          .success(function(data){
            //месяц и год принятия показаний счетчиков это след месяц от указанного в форме (текущий месяц в программе Бонус)
            vm.fileXLSXName = moment().set('year', vm.year).set('month', vm.month).format('YYYY-MM')+'.xlsx';
            vm.fileXLSXblob = new Blob([s2ab(data)],{type:"application/octet-stream"});
            if($window.navigator.msSaveOrOpenBlob) {
              vm.msSaveOrOpenBlob = true;
            } else {
              url = $window.URL || $window.webkitURL;
              vm.fileXLSXUrl = url.createObjectURL(vm.fileXLSXblob);
            }
          })
          .error(function (errors) {
            vm.form.error = errors['validationErrors'][0].msg;
            $log.error(errors);
          })
      }
    };

    //скачивание файла для IE11
    vm.msDownloadFile = function(blob, fileName){
      $window.navigator.msSaveOrOpenBlob(blob, fileName);
    };

    //чистим путь к скачиванию файла
    vm.clearUrl = function(){
      vm.fileUrl = vm.fileName  = "";
    };

    initDomain();
    initAddresses();
  }
})();

/**
 * Created by Елена on 15.07.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('StructureFormController', StructureFormController);

  /** @ngInject */
  function StructureFormController($state, $stateParams, $log, moment, dialogs, customDialogs, Validation, ApiUri, User, Structure, Upload, File, Lightbox) {
    var vm = this;
    vm.title = 'Структура сайта';
    vm.aliasTranslit = true;
    vm.images = [];
    vm.item = {
      parent_id:null,
      component_id:1,
      h1:null,
      content:null,
      title:null,
      keywords:null,
      description:null,
      is_main:false,
      in_menu:false,
      active:true
    };
    vm.error = '';

    if(User.data.domain){
      vm.trumbowygOptions = {
        plugins:{
          // Add imagur parameters to upload plugin
          uploadImage: {
            serverPath: ApiUri + '/upload',
            data:[{name:'domain_id',value:User.data.domain.id},{name:'domain',value:User.data.domain.domain}],
            fileFieldName: 'file',
            urlPropertyName: 'file',
            statusPropertyName: 'file'
          },
          uploadFile: {
            serverPath: ApiUri + '/upload',
            data:[{name:'domain_id',value:User.data.domain.id},{name:'domain',value:User.data.domain.domain}],
            fileFieldName: 'file',
            urlPropertyName: 'file',
            statusPropertyName: 'file'
          }
        },
        lang: 'ru',
        fullscreenable: true,
        semantic: true,
        closable: true,
        svgPath:'/images/icons.svg',
        btnsDef: {
          // Customizables dropdowns
          image: {
            dropdown: ['insertImage', 'uploadImage'],
            ico: 'insertImage'
          },
          linkUpload: {
            dropdown: ['createLink', 'uploadFile', 'unlink'],
            ico: 'link'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'],
          ['formatting'],
          'btnGrp-design',
          ['foreColor', 'backColor'],
          ['linkUpload'],
          ['image'],
          'btnGrp-justify',
          'btnGrp-lists',
          ['preformatted'],
          ['horizontalRule'],
          ['fullscreen']
        ]
      };
      vm.item.domain_id = User.data.domain.id;
    } else {
      vm.error = "Ошибка при загрузке домена";
    }

    //Загружает данные по странице
    var listComponents = function () {
      //список типов счетчиков для фильтра
      Structure.listComponents()
        .success(function(result){
          vm.components = result;
        })
        .error(function(error) {
          vm.error = 'Ошибка при получении списка компонентов';
          $log.error(error);
        });
    };

    var initPage = function (id) {
      Structure.load(id)
        .success(function (result) {
          vm.item = result;
          //проверяем алиас такой же как наименование или нет
          vm.checkAliasTranslit();
          //данные по родительской странице
          if(vm.item.parent_id){
            initParentPage(vm.item.parent_id);
          }
          //преобразуем пути к изображениям
          setListImages();
          //список типов счетчиков для фильтра
          listComponents();
        })
        .error(function (error) {
          vm.error = 'Ошибка при запросе данных страницы';
          $log.debug(error);
        });
    };

    //Загружает данные по родительской странице
    var initParentPage = function (id) {
      Structure.load(id)
        .success(function (result) {
          vm.parent = result;
        })
        .error(function (error) {
          vm.error = 'Ошибка при запросе данных родительской страницы';
          $log.debug(error);
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initPage($stateParams.id);
    }

    //загружаем родительскую страницу, если указан parent_id
    if(angular.isNumber($stateParams.parent_id)){
      initParentPage($stateParams.parent_id);
    }

    vm.send = function () {
      if (vm.item.id) {
        updatePage();
      } else {
        createPage();
      }
    };

    var setMainPage = function(){
      Structure.setMainPage(vm.item)
        .success(function () {
          customDialogs.success();
          $state.go('site.structure.item',{id:vm.item.id});
        })
        .error(function (error) {
          vm.error = 'Ошибка при смене главной страницы';
          $log.debug(error);
        });
    };

    var createPage = function () {
      if (!vm.form.$invalid) {
        //запрос на максимальный order для сортировки страниц
        Structure.getOrderNum({domain_id:vm.item.domain_id})
          .success(function (result) {
            vm.item.path = vm.item.alias;
            if(vm.parent){
              vm.item.parent_id = vm.parent.id;
              vm.item.path = vm.parent.path +'/'+ vm.item.path;
            }
            vm.item.order_num = parseInt(result.order_num);
            Structure.create(vm.item)
              .success(function (id) {
                vm.item.id = id;
                //если указано, что "Главная страница", меняем главную страницу для домена
                if(vm.item.is_main){
                  setMainPage();
                } else {
                  customDialogs.success();
                  $state.go('site.structure.item',{id:id});
                }
              })
              .error(function (errors) {
                Validation.parseErrors(vm.form, errors);
              });
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updatePage = function () {
      if (!vm.form.$invalid) {
        vm.item.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
        vm.item.path = vm.item.alias;
        if(vm.parent){
          vm.item.parent_id = vm.parent.id;
          vm.item.path = vm.parent.path + '/' + vm.item.path;
        }
        Structure.update(vm.item)
          .success(function () {

            //приводим форму к первоначальному статусу
            vm.form.$setPristine();
            vm.form.$setUntouched();

            //если указано, что "Главная страница", меняем главную страницу для домена
            if(vm.item.is_main){
              setMainPage();
            } else {
              customDialogs.success();
            }

          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    //записывает пути к изображениям для отображения в html
    //сделано т.к. изображения хранятся в другом проекте
    var setListImages = function(){
      vm.images = [];
      angular.forEach(vm.item.images,function(item){
        vm.images.push({url:ApiUri + '/upload/getImage?image='+item.url, thumbUrl:ApiUri + '/upload/getImage?image='+item.thumbUrl});
      })
    };

    // Загрузка файла на сервер
    vm.upload = function (file) {
      //ресайзим изображение для загрузки на сервер оригинала и миниатюры
      Upload.resize(file, 0, 200, 1.0).then(function(resizedFile){
        Upload.upload({
          url: ApiUri + '/upload',
          data: {domain_id:vm.item.domain_id, file: file, thumb:resizedFile}
        }).then(function (resp) {
          if(!vm.item.images) vm.item.images = [];
          //добавляем изображение в массив изображений страницы
          vm.item.images.push({url: resp.data.file, thumbUrl:resp.data.thumb});
          //преобразуем объект в строку в формате json и обновляем в базе изображения страницы
          Structure.updateImages({id:vm.item.id,images:angular.toJson(vm.item.images,true)})
            .success(function () {
              //преобразуем пути к изображениям
              setListImages();
              customDialogs.success();
            })
            .error(function (errors) {
              Validation.parseErrors(vm.form, errors);
            });
        }, function (resp) {
          vm.form.images.$setValidity('server', false);
          vm.form.images.msg = 'Ошибка при загрузке файла';
          $log.debug('Error status: ' + resp.status);
        });
      }, function (resp) {
        vm.form.images.$setValidity('server', false);
        vm.form.images.msg = 'Ошибка при формировании миниатюры';
        $log.error('Error status: ' + resp.status);
      });
    };

    // Загрузка нескольких файлов
    vm.uploadFiles = function (files) {
      if (files && files.length) {
        angular.forEach(files,function(file){
          vm.upload(file);
        });
      }
    };

    vm.deleteImage = function(index){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить файл?');
      dlg.result.then(function(){
        File.unlink(vm.item.images[index].url);
        File.unlink(vm.item.images[index].thumbUrl);
        //удаляем изображение из массива изображений страницы
        vm.item.images.splice(index,1);
        //преобразуем объект в строку в формате json и обновляем в базе изображения страницы
        Structure.updateImages({id:vm.item.id,images:angular.toJson(vm.item.images,true)})
          .success(function () {
            //преобразуем пути к изображениям
            setListImages();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      });
    };

    vm.openLightboxModal = function (index) {
      Lightbox.openModal(vm.images, index);
    };

    //проверяет алиас такой же как наименование или нет,
    // используется при смене наименования
    vm.checkAliasTranslit = function() {
      if(vm.item.alias == translit(vm.item.name)){
        vm.aliasTranslit = true;
      } else {
        vm.aliasTranslit = false;
      }
    };

    //формирование алиаса от наименования
    vm.nameTranslit = function() {
      if(vm.aliasTranslit){
        vm.item.alias = translit(vm.item.name);
      }
    };

    var translit = function(str) {
      var result = '';

      var ru = [
        'а', 'б', 'в', 'г', 'д', 'е', 'ё',  'ж',  'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п', 'р', 'с', 'т', 'у', 'ф', 'х',
        'ц', 'ч',  'ш',  'щ',   'ы', 'э', 'ю',  'я',  '-', '_', ' ', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
        'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'
      ];
      var en = [
        'a', 'b', 'v', 'g', 'd', 'e', 'jo', 'zh', 'z', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'r', 's', 't', 'u', 'f', 'kh',
        'c', 'ch', 'sh', 'shh', 'y', 'e', 'ju', 'ja', '-', '_', '-', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
        'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'
      ];

      for (var i in str) {
        var index = ru.indexOf(str[i].toLowerCase());
        if (index != -1) {
          result += en[index];
        }
      }

      return result;
    }
  }
})();

/**
 * Created by Елена on 14.07.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('StructureController', StructureController)
    //создаем шаблон строки раздела структуры, для неограниченной вложенности
    .run(function($templateCache) {
      $templateCache.put('structureItem.html', '' +
        '<div class="wrapper-buttons clearfix">' +
          '<div role="button" ui-sref="site.structure.item({id:item.id})" class="text-overflow col-sm-10 col-xs-8"' +
                '>{{item.name}}</div>' +
            '<div class="buttons text-right col-sm-2 col-xs-4 h5 m-a-0">' +
              '<a href class="p-r" ui-sref="site.structure.item({parent_id:item.id})"><i class="fa fa-plus"></i></a>' +
              '<a href class="p-r" ui-sref="site.structure.item({id:item.id})"><i class="fa fa-pencil"></i></a>' +
              '<a href ng-click="structure.delete(item)"><span class="fa fa-remove"></span></a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div id="structureList{{item.id}}" ng-sortable="{ animation: 150 }">' +
          '<div class="p-l-lg p-t clearfix" ng-repeat="item in item.childs" ng-include="\'structureItem.html\'"' +
        '</div>'
      );
  });

  /** @ngInject */
  function StructureController($state, $log, dialogs, User, Domain, Structure, File) {
    var vm = this;
    vm.title = 'Структура сайта';
    vm.error = '';
    vm.items = [];

    Domain.load({company_id:User.data.company_id})
      .success(function(result){
        //загружаем список страниц
        Structure.list({domain_id:result.id,parent_id:0})
          .success(function(result){
            vm.items = result;
            structureChildsLoad(result);
          })
          .error(function (error) {
            vm.error = 'Ошибка при загрузке структуры';
            $log.error(error);
          });
      })
      .error(function (error) {
        vm.error = 'Ошибка при загрузке домена';
        $log.error(error);
      });

    var structureChildsLoad = function(items){
      angular.forEach(items,function(item){
        Structure.list({domain_id:item.domain_id,parent_id:item.id})
          .success(function(childs){
            item['childs'] = childs;
            if(childs){
              structureChildsLoad(childs);
            }
          })
          .error(function (error) {
            vm.error = 'Ошибка при загрузке дочерних разделов';
            $log.error(error);
          });
      });
    };

    vm.delete = function(item){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить раздел "'+item.name+'"?');
      dlg.result.then(function(){
        Structure.delete(item.id)
          .success(function(){
            //удаляем изображения из галереи страницы
            angular.forEach(item.images,function(image){
              File.unlink(image.url);
              File.unlink(image.thumbUrl);
            });
            $state.go($state.current, {}, {reload: true});
          })
          .error(function(error) {
            vm.error = 'Ошибка при удалении раздела';
            $log.error(error);
          });
      },function(){});
    };

    /*
    Sortable.create(structureList, {
      store: {
        // Получение сортировки (вызывается при инициализации)
        get: function (sortable) {
          var order = localStorage.getItem(sortable.options.group);
          $log.debug('Sortable get',order);
          return order ? order.split('|') : [];
        },

        // Сохранение сортировки (вызывается каждый раз при её изменении)
        set: function (sortable) {
          var order = sortable.toArray();
          $log.debug('Sortable set',order);
          localStorage.setItem(sortable.options.group, order.join('|'));
        }
      }
    });
    */
  }
})();

/**
 * Created by Елена on 14.07.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('SiteController', SiteController);

  /** @ngInject */
  function SiteController() {
    var vm = this;
    vm.title = 'Управление сайтом';
    vm.error = '';

  }
})();

/**
 * Created by Елена on 14.07.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('DomainFormController', DomainFormController);

  //путь для изображений
  //var prefixPath = '../../../tsgSites/www';
  //var prefixPath = '';

  /** @ngInject */
  function DomainFormController($log, moment, customDialogs, ApiUri, User, Upload, Validation, Theme, Domain, File) {
    var vm = this;
    vm.title = 'Настройки сайта';
    vm.error = '';

    //параметрты всплывашки с выбором цвета
    vm.optionsColorPicker = {
      preferredFormat: "hex3",
      chooseText: "ok",
      cancelText: "отмена",
      showInput: true,
      showInitial: true,
      showAlpha: false,
      allowEmpty: true,
      showPalette: true,
      replacerClassName: 'custom-colorpicker',
      palette: [
        ["#000","#444","#666","#999","#ccc","#eee","#f3f3f3","#fff"],
        ["#f00","#f90","#ff0","#0f0","#0ff","#00f","#90f","#f0f"],
        ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
        ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
        ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
        ["#c00","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
        ["#900","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
        ["#600","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
      ]
    };

    var initDomain = function(){
      Domain.load({company_id:User.data.company_id})
        .success(function(result){
          vm.item = result;
          //текущий лого, используется при удалении файла
          vm.currentLogo = vm.item.logo;
          if(vm.item.logo){
            vm.logo = ApiUri + '/upload/getImage?image='+vm.item.logo.thumb;
          }
          initThemes();
        })
        .error(function (error) {
          vm.error = 'Ошибка при загрузке домена';
          $log.error(error);
        });
    };

    //Список шаблонов сайта
    var initThemes = function(){
      Theme.list({active:true})
        .success(function (result) {
          vm.themes = result;
        })
        .error(function (error) {
          vm.error = 'Ошибка при формировании списка шаблонов для сайта';
          $log.error(error);
        });
    };

    // Загрузка логотипа на сервер
    vm.uploadLogo = function () {
      vm.form.logo.$setValidity('server', true);
      vm.form.logo.msg = '';
      //ресайзим изображение для загрузки на сервер оригинала и миниатюры
      Upload.resize(vm.logo, 100, 100, 0.9).then(function(resizedFile){
        Upload.upload({
          url: ApiUri + '/upload',
          data: {file: vm.logo, thumb:resizedFile, domain_id:vm.item.id}
        }).then(function (resp) {
          //указываем что поле валидно
          vm.form.logo.$setValidity('server', true);

          //обновляем данные, если указан id
          if(vm.item.id){
            vm.item.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
            vm.item.logo = resp.data;
            updateLogo();
          }
        }, function (resp) {
          vm.form.logo.$setValidity('server', false);
          vm.form.logo.msg = 'Ошибка при загрузке файла на сервер';
          $log.debug('Error status: ' + resp.status);
        });
      }, function (resp) {
        vm.form.logo.$setValidity('server', false);
        vm.form.logo.msg = 'Ошибка при формировании миниатюры';
        $log.debug('Error status: ' + resp.status);
      });
    };

    vm.preUploadLogo = function (file, errFiles) {
      vm.form.logo.$setValidity('server', true);
      vm.form.logo.msg = '';
      if(errFiles.length){
        angular.forEach(errFiles,function(error){
          vm.form.logo.$setValidity('server', false);
          vm.form.logo.msg = error;
        })
      } else {
        if(file){
          //удаляем старый лого
          if(vm.currentLogo){
            File.unlink(vm.currentLogo.file);
            File.unlink(vm.currentLogo.thumb);
          }

          vm.logo = file;
          //если форма редактирования
          if(vm.item.id){
            vm.uploadLogo();
          }
        }
      }
    };

    //Обновляет данные по логотипу в базе
    var updateLogo = function(){
      Domain.updateLogo({id:vm.item.id,logo:vm.item.logo,updated_at:vm.item.updated_at})
        .success(function () {
          //приводим форму к первоначальному статусу
          vm.form.$setPristine();
          vm.form.$setUntouched();
          vm.form.$setUntouched();

          initDomain();

          customDialogs.success();
        })
        .error(function (errors) {
          Validation.parseErrors(vm.form, errors);
        });
    };

    //Удаляет файл лого и обновляет данные в базе
    vm.deleteLogo = function(){
      if(vm.currentLogo){
        File.unlink(vm.currentLogo.file);
        File.unlink(vm.currentLogo.thumb);
        vm.item.logo = vm.logo = null;
        updateLogo();
      }
    };

    vm.updateDomain = function () {
      if (!vm.form.$invalid) {
        vm.item.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
        Domain.update(vm.item)
          .success(function () {
            //приводим форму к первоначальному статусу
            vm.form.$setPristine();
            vm.form.$setUntouched();

            //запускаем сборку стилей с указанными цветами
            Domain.setStyleTheme({theme_id:vm.item.theme_id,domain_id:vm.item.id,colors:vm.item.colors});

            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    initDomain();
  }
})();

/**
 * Created by Елена on 07.07.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($log, customDialogs, User, Settings) {
    var vm = this;
    vm.title = 'Настройки';
    vm.error = '';
    //настройки по показаниям счетчиков
    vm.items = {
      day_start: {
        company_id:User.data.company_id,
        section:'counter_stats',
        system_name:'day_start',
        name:'Число месяца для начала принятия показаний',
        active:true
      },
      day_end: {
        company_id:User.data.company_id,
        section:'counter_stats',
        system_name:'day_end',
        name:'Число месяца для окончания принятия показанй',
        active:true
      }
    };

    //загружаем настройки по показаниям счетчиков
    Settings.list({company_id:User.data.company_id,section:'counter_stats'})
      .success(function(result){
        angular.forEach(result,function(item){
          vm.items[item.system_name]['value'] = parseInt(item.value);
        })
      })
      .error(function (error) {
        vm.error = 'Ошибка при запросе списка настроек';
        $log.error(error);
      });

      vm.send = function () {
        if (!vm.form.$invalid) {
          //перебираем параметры и перезаписываем их в базе
          angular.forEach(vm.items,function(item){
            Settings.load({company_id:item.company_id,section:item.section,system_name:item.system_name}).success(function(result){
                //если настройка существует - обновляем, иначе создаем
                if(result){
                  Settings.update(item).success(function(){
                    customDialogs.success();
                  }).error(function(error){
                    vm.error = 'Ошибка при обновлении настройки';
                    $log.error(error);
                  });
                } else {
                  Settings.create(item).success(function(){
                    customDialogs.success();
                  }).error(function(error){
                    vm.error = 'Ошибка при добавлении настройки';
                    $log.error(error);
                  });
                }
              })
              .error(function (error) {
                vm.error = 'Ошибка при запросе данных настройки';
                $log.error(error);
              });
          });
        }
      };
  }
})();

/**
 * Created by Елена on 04.12.2017.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('SensorsFormController', SensorsFormController);

  /** @ngInject */
  function SensorsFormController($stateParams, $log, customDialogs, User, Sensor, Worker, Validation) {
    var vm = this;
    vm.item = {};

    var initSensor = function(id){
      Sensor.load(id)
        .success(function (result) {
          vm.item = result;
          initWorkers();
        })
        .error(function (error) {
          vm.error = error.error;
        });
    };

    var initWorkers = function(){
      Worker.list({company_id:User.data.company_id})
        .success(function(result){
          vm.workers = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.updateSensor = function(){
      if(!vm.form.$invalid) {
        Sensor.update(vm.item)
          .success(function () {
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    if(angular.isNumber($stateParams.id)){
      initSensor($stateParams.id);
    }
  }
})();

/**
 * Created by Елена on 31.08.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('SensorsController', SensorsController);

  /** @ngInject */
  function SensorsController($stateParams, $log, customDialogs, Address, User, Sensor, Validation) {
    var vm = this;
    vm.title = 'Мониторинг';
    //для is-open в uib-accordion
    vm.openIndex = [];

    //список адресов организации
    Address.list()
      .success(function(result_address){
        vm.addresses = [];
        angular.forEach(result_address,function(address,key){
          //если в get-парметре указан address_id, открываем блок объектов управления для указанного адреса
          if((angular.isNumber($stateParams.address_id) && $stateParams.address_id == address.id) || result_address.length == 1){
            vm.openIndex[key] = true;
          }

          vm.addresses[key] = address;

          vm.initSensorsObjects(address);
        });
      })
      .error(function() {
        $log.debug('error');
      });

    vm.initSensorsObjects = function(address){
      Sensor.list({company_id:User.data.company_id, address_id:address.id})
        .success(function(result){
          address.sensorsList = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    //обновление статусов по всем датчикам компании
    vm.setStatuses = function(address){
      Sensor.setStatuses({company_id:User.data.company_id})
        .success(function(){
          customDialogs.success();

          vm.initSensorsObjects(address);
        })
        .error(function(errors) {
          Validation.parseErrors(vm.form, errors);
        });
    };

  }
})();

/**
 * Created by Елена on 16.07.2018
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('ReestrFormController', ReestrFormController);

  /** @ngInject */
  function ReestrFormController($state, $log, $stateParams, $window, customDialogs, ApiUri, Validation, User, Mail, Flat, Address, Reestr, Upload, File) {
    var vm = this;
    vm.indexTab = 0;
    vm.item = {
      active: true
    }

    vm.setIndex = function (index) {
      $state.go('reestr.item', {id: vm.item.id, index: index}, {notify: false});
    }

    //список адресов
    Address.list()
      .success(function (result) {
        vm.addresses = result;
      })
      .error(function () {
        $log.debug('error');
      })

    //параметры реестра для селектов
    Reestr.params()
      .success(function (result) {
        vm.reestrParams = {};
        angular.forEach(result, function (item) {
          if (!vm.reestrParams[item['type']]) {
            vm.reestrParams[item['type']] = [];
          }
          vm.reestrParams[item['type']].push(item);
        })
      })
      .error(function () {
        $log.debug('error');
      })

    //Загружает данные
    var initOwner = function (id) {
      Reestr.load(id)
        .success(function (result) {
          vm.item = result;
          // список квартир по адресу
          vm.loadFlats();
        })
        .error(function () {
          $log.debug('error Reestr.load');
        })
    }

    vm.send = function () {
      if (vm.item.id) {
        updateOwner();
      } else {
        createOwner();
      }
    }

    //Генерируется пароль
    vm.generatePassword = function () {
      vm.password = vm.re_password = User.generatePassword();
      //приводим форму к первоначальному статусу
      if (vm.formPass) {
        vm.formPass.$setValidity();
      }
    }

    vm.changePass = function () {
      if (!vm.formPass.$invalid) {
        var params = {
          id: vm.item.id,
          password: vm.password,
          re_password: vm.re_password
        }
        Reestr.changePass(params)
          .success(function () {
            //отправляем реквизиты на email, если он указан
            if (vm.item.login) {
              sendMail();
            } else {
              //чистка полей формы
              vm.password = null;
              vm.re_password = null;
            }

            //приводим форму к первоначальному статусу
            vm.formPass.$setPristine();
            vm.formPass.$setUntouched();

            customDialogs.success('Пароль успешно изменен');
          })
          .error(function (errors) {
            Validation.parseErrors(vm.formPass, errors);
          })
      }
    }

    // Загружает список квартир, когда выбран адрес
    vm.loadFlats = function () {
      vm.flats = [];
      if (vm.item.address_id) {
        // загружаем список кваритир
        Flat.list({address_id: vm.item.address_id})
          .success(function (flats) {
            vm.flats = flats;
          })
          .error(function () {
            $log.debug('error');
          })
      }
    }

    //если в get-парметре указан index
    if (angular.isNumber($stateParams.index)) {
      vm.indexTab = $stateParams.index;
    }

    //если в get-парметре указан address_id
    if (angular.isNumber($stateParams.address_id)) {
      vm.item.address_id = $stateParams.address_id;
      vm.loadFlats();
    }

    //если в get-парметре указан flat_id
    if (angular.isNumber($stateParams.flat_id)) {
      vm.item.flat_id = $stateParams.flat_id;
    }

    //если в get-парметре указан id, загружаем данные
    if (angular.isNumber($stateParams.id)) {
      initOwner($stateParams.id);
    }

    var createOwner = function () {
      if (!vm.form.$invalid) {
        vm.item.password = vm.password;
        vm.item.re_password = vm.re_password;
        if (vm.preEgrn) {
          uploadEgrn().then(function () {
            Reestr.create(vm.item)
              .success(function () {
                $window.history.back();
              })
              .error(function (errors) {
                Validation.parseErrors(vm.form, errors);
              })
          }).catch(function (err) {
            $log.debug('Error status: ' + err.status);
          })
        } else {
          Reestr.create(vm.item)
            .success(function () {
              $window.history.back();
            })
            .error(function (errors) {
              Validation.parseErrors(vm.form, errors);
            })
        }
      }
    }

    var updateOwner = function () {
      if (!vm.form.$invalid) {

        if (vm.preEgrn) {
          uploadEgrn().then(function () {
            Reestr.update(vm.item)
              .success(function () {
                //приводим форму к первоначальному статусу
                vm.form.$setPristine();
                vm.form.$setUntouched();

                initOwner(vm.item.id);

                customDialogs.success();
              })
              .error(function (errors) {
                Validation.parseErrors(vm.form, errors);
              });
          }).catch(function (err) {
            $log.debug('Error status: ' + err.status);
          })
        } else {
          Reestr.update(vm.item)
            .success(function () {
              //приводим форму к первоначальному статусу
              vm.form.$setPristine();
              vm.form.$setUntouched();

              initOwner(vm.item.id);

              customDialogs.success();
            })
            .error(function (errors) {
              Validation.parseErrors(vm.form, errors);
            });
        }

      }
    }

    var uploadEgrn = function () {
      return new Promise(function (resolve, reject) {
        Upload.upload({
          url: ApiUri + '/upload/file',
          data: {file: vm.preEgrn}
        }).then(function (resp) {
          //удаляем старый файл
          if (vm.item.reestr.egrn) {
            File.unlink({path: '../web/src' + vm.item.reestr.egrn});
          }

          //указываем что поле валидно
          vm.form.egrn.$setValidity('server', true);
          vm.item.reestr.egrn = resp.data.file;
          vm.preEgrn = null;

          resolve();
        }, function (err) {
          vm.form.egrn.$setValidity('server', false);
          vm.form.egrn.msg = 'Ошибка при загрузке файла на сервер';

          reject(err);
        });
      })
    }

    // Отправляет реквизиты на email жильца
    var sendMail = function () {
      if (vm.item.login) {
        var message = '<p>Вы являетесь зарегистрированным пользователем личного кабинета ' + User.data.company.name + '</p>' +
          '<strong>Реквизиты доступа к личному кабинету</strong>' +
          '<table border="0" cellspacing="0" cellpadding="5" style="font-size:14px; color:#666;">' +
          '<tr><td><a href="https://my.indom.profintel.ru/#/login">https://my.indom.profintel.ru/#/login</a></tr>' +
          '<tr><td><strong>Логин</strong></td><td>' + vm.item.login + '</td></tr>' +
          '<tr><td><strong>Пароль</strong></td><td>' + vm.item.password + '</td></tr>' +
          '</table>';
        Mail.send({
          senderName: User.data.company.name,
          email: vm.item.login,
          subject: 'Реквизиты входа в личный кабинет ' + User.data.company.name,
          message: message
        })
          .success(function () {
            //чистка полей формы
            vm.password = null;
            vm.re_password = null;

            customDialogs.success('Реквизиты на email успешно отправлены');
          })
          .error(function (error) {
            vm.form.error = 'Ошибка при отправке email сообщения';
            $log.error(error);
          })
      }
    }
  }

})();

/**
 * Created by Елена on 16.07.2018
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('ReestrController', ReestrController);

  /** @ngInject */
  function ReestrController($stateParams, $log, dialogs, Address, Reestr) {
    var vm = this;
    vm.title = 'Реестр жильцов';
    vm.items = [];
    //лимит для списка жильцов
    vm.findParams = {
      limit: 10
    };
    vm.page = 1;

    //если в get-парметре указан address_id
    if(angular.isNumber($stateParams.address_id)){
      vm.findParams.address_id = $stateParams.address_id;
    }

    vm.init = function () {
      Address.list()
        .success(function (result) {
          vm.addresses = result;
          if(vm.addresses.length && !vm.findParams.address_id){
            vm.findParams.address_id = vm.addresses[0].id;
          }
          vm.initReestr();
        })
        .error(function () {
          $log.debug('error');
        });
    };

    vm.initReestr = function () {
      vm.findParams.offset = (vm.findParams.limit * (vm.page - 1));

      Reestr.cnt(vm.findParams)
        .success(function (result_cnt) {
          vm.cntItems = result_cnt;

          Reestr.list(vm.findParams)
            .success(function (result) {
              vm.items = result;
            })
            .error(function () {
              $log.debug('error');
            });
        })
        .error(function () {
          $log.debug('error');
        });
    };

    vm.delete = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить собственника "' + (item.contacts ? item.contacts.name : '') + '" из кв. ' + item.flat +'?');
      dlg.result.then(function () {
        Reestr.delete(item.id)
          .success(function () {
            vm.init();
          })
          .error(function () {
            $log.debug('error');
          });
        });
    };

    vm.init();
  }
})();

/**
 * Created by Елена on 31.08.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('MessagesFormController', MessagesFormController);

  function MessagesFormController($log, $stateParams, customDialogs, Validation, User, Address, Flat, Message, Mail) {
    var vm = this;
    vm.item = {
      active: true,
      company_id: User.data.company_id,
      flat_id: null
    };

    //список адресов компании
    Address.list()
      .success(function(result){
        vm.addresses = result;
      })
      .error(function() {
        $log.debug('error');
      });

    //формирует список кваритир, после выбора адреса
    vm.initFlats = function(){
      //сбрасываем список квартир
      vm.flats = [];
      //сбрасываем выбор квартиры
      vm.item.flat_id = null;
      if(vm.item.address_id) {
        //список квартир с учетом выбранного адреса
        Flat.list({address_id: vm.item.address_id})
          .success(function (result) {
            vm.flats = result;
          })
          .error(function () {
            $log.debug('error');
          });
      }
    };

    var initMessage = function(id){
      Message.load(id)
        .success(function (result) {
          vm.item = result;
          vm.initFlats();
        })
        .error(function () {
          $log.debug('error');
        });
    };

    if (angular.isNumber($stateParams.id)) {
      initMessage($stateParams.id);
    }

    //если не указан id, проверяем в get-парметре company_id
    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные по сотруднику
      Message.load($stateParams.id)
        .success(function (result) {
          vm.item = result;
        })
        .error(function () {
          $log.debug('error');
        });
    }

    vm.send = function () {
      if (vm.item.id) {
        updateMessage();
      } else {
        createMessage();
      }
    };

    var createMessage = function () {
      if (!vm.form.$invalid) {
        Message.create(vm.item)
          .success(function() {
            customDialogs.success();
            //отправляем на email уведомление
            sendMail();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updateMessage = function () {
      if (!vm.form.$invalid) {
        Message.update(vm.item)
          .success(function () {
            customDialogs.success();
            //отправляем на email уведомление
            sendMail();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var sendMail = function(){
      vm.mailStats = [];
      //если указана кваритира, отправляем на email квартиры
      if(vm.item.flat_id){
        Flat.load(vm.item.flat_id)
          .success(function (item) {
            if(item.email){
              var emailParams = {
                senderName: User.data.company.name,
                email:item.email,
                subject: 'Уведомление от '+User.data.company.name,
                message: vm.item.message
              };
              Mail.send(emailParams)
                .success(function() {
                  item.statusSend = "успешно";
                  vm.mailStats = vm.mailStats.concat(item);
                })
                .error(function (error) {
                  item.statusSend = "ошибка";
                  vm.mailStats = vm.mailStats.concat(item);
                  $log.error(error);
                });
            } else {
              item.statusSend = "ошибка";
              vm.mailStats = vm.mailStats.concat(item);
            }
          })
          .error(function (error) {
            $log.error(error);
          });
      } else {
        //если кваритира не указана, то отправляем по всем квартирам, указанного адреса
        angular.forEach(vm.flats,function(item){
          if(item.email){
            var emailParams = {
              senderName: User.data.company.name,
              email: item.email,
              subject: 'Уведомление от '+User.data.company.name,
              message: vm.item.message
            };

            Mail.send(emailParams)
              .success(function () {
                item.statusSend = "успешно";
                vm.mailStats = vm.mailStats.concat(item);
              })
              .error(function (error) {
                item.statusSend = "ошибка";
                vm.mailStats = vm.mailStats.concat(item);
                $log.error(error);
              });
          }
        });
      }
    };

  }

})();

/**
 * Created by Елена on 31.08.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('MessagesController', MessagesController);

  /** @ngInject */
  function MessagesController($log, dialogs, User, Message) {
    var vm = this;
    vm.title = 'Персональные уведомления';

    var init = function(){
      Message.list({company_id:User.data.company_id})
        .success(function(result){
          vm.items = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.delete = function(item){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить сотрудника "'+item.name+'"?');
      dlg.result.then(function(){
        Message.delete(item.id)
          .success(function(){
            init();
          })
          .error(function() {
            $log.debug('error');
          });
      },function(){});
    };

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('web')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {


  }
})();

(function() {
  'use strict';

  angular
    .module('web')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, $cookies, $location, $window, ApiUri, User, Worker) {
    var vm = this;
    vm.user = User;
    vm.requizites = {email: '', password: ''};

    // User.errorOauthEss - ошибка при oauthESS
    // User.oauthStatus - статус авторизации
    if(User.errorOauthEss){
      vm.error = User.errorOauthEss;
      //один раз показываем ошибку, затем чистим ее
      User.clearParamOauthEss('error');
    }

    vm.login = function(){
      if(!vm.login_form.$invalid){
        User.login(vm.requizites.email, vm.requizites.password,
          function(result){
            vm.error = '';
            if(result.error){
              vm.error = result.error;
            } else {
              //обновляем ip адрес пользователя
              Worker.changeIp();

              //если указан url для переадресации
              if($cookies.get('redirectAuthUrl') && $cookies.get('redirectAuthUrl')!== '/login'){
                $location.url($cookies.get('redirectAuthUrl'));
              } else {
                //иначе переадресация по умолчанию
                $state.go('home');
              }
            }
          });
      }
    };

    vm.oauth = function(){
      $window.location = ApiUri+'/auth/oauth';
    };

    vm.sendOauthFlat = function(){
      if(!vm.oauthFlatForm.$invalid){
        $window.location = ApiUri+'/auth/oauth?flat='+vm.oauth.flat;
      }
    };
  }
})();

/**
 * Created by Елена on 19.10.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('FlatsImportController', FlatsImportController);

  function FlatsImportController($state, $log, $stateParams, customDialogs, Validation, User, Address, Flat) {
    var vm = this;
    vm.item = {
      active: true
    };

    //список адресов
    Address.list({company_id:User.data.company_id})
      .success(function(result){
        vm.addresses = result;
      })
      .error(function() {
        $log.debug('error');
      });

    //если в get-парметре указан address_id
    if(angular.isNumber($stateParams.address_id)){
      vm.item.address_id = $stateParams.address_id;
    }

    //Загружает данные по квартире
    var initFlat = function (id) {
      Flat.load(id)
        .success(function (result) {
          vm.item = result;
        })
        .error(function () {
          $log.debug('error Flat.load');
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initFlat($stateParams.id);
    }

    vm.send = function () {
      if (vm.item.id) {
        updateFlat();
      } else {
        createFlat();
      }
    };

    var createFlat = function () {
      if (!vm.form.$invalid) {
        vm.item.password = vm.password;
        vm.item.re_password = vm.re_password;
        Flat.create(vm.item)
          .success(function () {
            $state.go('flats',{address_id:vm.item.address_id});
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updateFlat = function () {
      if (!vm.form.$invalid) {
        //если пароль не задан, отправляем на данные для смены пароля
        if(!vm.item.password){
          var params = {
            id: vm.item.id,
            password: vm.password,
            re_password: vm.re_password
          };
          Flat.changePass(params)
            .success(function () {
              //чистка полей формы
              vm.password = null;
              vm.re_password = null;

              Flat.update(vm.item)
                .success(function () {

                  //приводим форму к первоначальному статусу
                  vm.form.$setPristine();
                  vm.form.$setUntouched();

                  initFlat(vm.item.id);

                  customDialogs.success();
                })
                .error(function (errors) {
                  Validation.parseErrors(vm.form, errors);
                });
            })
            .error(function (errors) {
              Validation.parseErrors(vm.formPass, errors);
            });
        } else {
          Flat.update(vm.item)
            .success(function () {

              customDialogs.success();
            })
            .error(function (errors) {
              Validation.parseErrors(vm.form, errors);
            });
        }
      }
    };

    //Генерируется пароль
    vm.generatePassword = function () {
      vm.password = vm.re_password = User.generatePassword();
      //приводим форму к первоначальному статусу
      vm.formPass.$setValidity();
    };

    vm.changePass = function () {
      if (!vm.formPass.$invalid) {
        var params = {
          id: vm.item.id,
          password: vm.password,
          re_password: vm.re_password
        };
        Flat.changePass(params)
          .success(function () {
            //чистка полей формы
            vm.password = null;
            vm.re_password = null;

            //приводим форму к первоначальному статусу
            vm.formPass.$setPristine();
            vm.formPass.$setUntouched();

            customDialogs.success('Пароль успешно изменен');
          })
          .error(function (errors) {
            Validation.parseErrors(vm.formPass, errors);
          });
      }
    };

  }

})();

/**
 * Created by Елена on 24.05.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('FlatsFormController', FlatsFormController);

  function FlatsFormController($state, $log, $stateParams, dialogs, customDialogs, Validation, User, Address, Flat, Reestr, Mail) {
    var vm = this;
    vm.indexTab = 0;
    vm.item = {
      active: true
    };

    //если в get-парметре указан index
    if(angular.isNumber($stateParams.index)){
      vm.indexTab = $stateParams.index;
    }

    vm.setIndex = function(index){
      $state.go('flats.item',{id:vm.item.id,index:index},{notify:false});
    };

    //список адресов
    Address.list()
      .success(function(result){
        vm.addresses = result;
      })
      .error(function() {
        $log.debug('error');
      });

    //если в get-парметре указан address_id
    if(angular.isNumber($stateParams.address_id)){
      vm.item.address_id = $stateParams.address_id;
    }

    //Загружает данные по квартире
    var initFlat = function (id) {
      Flat.load(id)
        .success(function (result) {
          vm.item = result;
          // загружаем список жильцов
          initOwners();
        })
        .error(function () {
          $log.debug('error Flat.load');
        });
    };

    //Загружает данные по жильцам
    var initOwners = function () {
      Reestr.list({address_id:vm.item.address_id,flat_id:vm.item.id})
        .success(function (result) {
          vm.item.owners = result;
        })
        .error(function () {
          $log.debug('error');
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initFlat($stateParams.id);
    }

    vm.send = function () {
      if (vm.item.id) {
        updateFlat();
      } else {
        createFlat();
      }
    };

    vm.deleteOwner = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить собственника "' + (item.contacts ? item.contacts.name : '') + '" из кв. ' + item.flat +'?');
      dlg.result.then(function () {
        Reestr.delete(item.id)
          .success(function () {
            initOwners();
          })
          .error(function () {
            $log.debug('error');
          });
      });
    };

    var createFlat = function () {
      if (!vm.form.$invalid) {
        Flat.create(vm.item)
          .success(function () {
            $state.go('flats',{addres_id:vm.item.addres_id});
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var updateFlat = function () {
      if (!vm.form.$invalid) {
        Flat.update(vm.item)
          .success(function () {

            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    //Генерируется пароль
    vm.generatePassword = function () {
      vm.password = vm.re_password = User.generatePassword();
      //приводим форму к первоначальному статусу
      vm.formPass.$setValidity();
    };

    vm.changePass = function () {
      if (!vm.formPass.$invalid) {
        var params = {
          id: vm.item.id,
          password: vm.password,
          re_password: vm.re_password
        };
        Flat.changePass(params)
          .success(function () {
            //отправляем реквизиты на email, если он указан
            if(vm.item.email){
              sendMail();
            } else {
              //чистка полей формы
              vm.password = null;
              vm.re_password = null;
            }

            //приводим форму к первоначальному статусу
            vm.formPass.$setPristine();
            vm.formPass.$setUntouched();

            customDialogs.success('Пароль успешно изменен');
          })
          .error(function (errors) {
            Validation.parseErrors(vm.formPass, errors);
          });
      }
    };

    // Отправляет реквизиты на email жильца
    var sendMail = function(){
      if(vm.item.email){
        var message = '<p>Вы являетесь зарегистрированным пользователем личного кабинета '+User.data.company.name+'</p>' +
          '<strong>Реквизиты доступа к личному кабинету</strong>' +
          '<table border="0" cellspacing="0" cellpadding="5" style="font-size:14px; color:#666;">' +
          '<tr><td><a href="http://tsg-client.mesto.biz/">http://tsg-client.mesto.biz/</a></tr>' +
          '<tr><td><strong>Логин</strong></td><td>'+ vm.item.id +'</td></tr>' +
          '<tr><td><strong>Пароль</strong></td><td>'+ vm.password +'</td></tr>' +
          '</table>';
        Mail.send({
            senderName: User.data.company.name,
            email: vm.item.email,
            subject: 'Реквизиты входа в личный кабинет '+User.data.company.name,
            message: message
          })
          .success(function() {
            //чистка полей формы
            vm.password = null;
            vm.re_password = null;

            customDialogs.success('Реквизиты на email успешно отправлены');
          })
          .error(function (error) {
            vm.form.error = 'Ошибка при отправке email сообщения';
            $log.error(error);
          });
      }
    }
  }

})();

/**
 * Created by Елена on 24.05.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('FlatsController', FlatsController);

  /** @ngInject */
  function FlatsController($stateParams, $log, dialogs, Address, Flat, Reestr) {
    var vm = this;
    vm.title = 'Жилой фонд';
    //для is-open в uib-accordion
    vm.openIndex = [];
    vm.page = 1;
    //лимит для списка квартир
    vm.findParams = {limit: 10};

    var init = function(){
      Address.list()
        .success(function(result_address){
          vm.addresses = result_address;
          if(vm.addresses.length){
            vm.findParams.address_id = vm.addresses[0].id;
            vm.address = vm.addresses[0];
            vm.initFlats();
          }
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.initFlats = function() {
      vm.findParams.offset = (vm.findParams.limit * (vm.page - 1));

      Flat.cnt(vm.findParams)
        .success(function(result_cnt){
          vm.address.cnt_flats = result_cnt;

          Flat.list(vm.findParams)
            .success(function(result_flats){
              vm.address.flats = result_flats;

              // загружаем список жильцов по адресу
              Reestr.list({address_id:vm.findParams.address_id})
                .success(function(owners){
                  angular.forEach(vm.address.flats, function (flat) {
                    flat.owners = owners.filter(function(owner){ return owner.flat_id === flat.id});
                  })
                })
                .error(function() {
                  $log.debug('error');
                })
            })
            .error(function() {
              $log.debug('error');
            });
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.find = function(key,address_id) {
      vm.addresses[key].page = 1;
      var params = {
        address_id:address_id,
        name:(vm.name ? vm.name[key] : ''),
        contact_face:(vm.contact_face ? vm.contact_face[key] : ''),
        phone:(vm.phone ? vm.phone[key] : ''),
        email:(vm.email ? vm.email[key] : '')
      };
      Flat.cnt(params)
        .success(function(result_cnt){
          vm.addresses[key]['cnt_flats'] = result_cnt;
          vm.initFlats(key,address_id);
        })
        .error(function() {
          $log.debug('error');
        });
    };

    vm.delete = function(item){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить "'+item.name+'"?');
      dlg.result.then(function(){
        Flat.delete(item.id)
          .success(function(){
            init();
          })
          .error(function() {
            $log.debug('error');
          });
      },function(){});
    };

    init();
  }
})();

/**
 * Created by Елена on 21.06.2016.
 */

(function () {
  'use strict';

  angular
    .module('web')
    .controller('CountersFormController', CountersFormController);

  function CountersFormController($window, $log, $stateParams, moment, customDialogs, Validation, Counter, Sensor) {
    var vm = this;
    vm.item = {
      active: true
    };
    vm.sensor = {
      dev_eui: '',
      port_num: ''
    };

    //Загружает данные по квартире
    var init = function (id) {
      Counter.load(id)
        .success(function (result) {
          vm.item = result;
          vm.item.status_date = new Date(vm.item.status_date).setHours(new Date(vm.item.status_date).getHours() + 5)
          if (vm.item.calibration){
            vm.item.calibration = moment(vm.item.calibration).format('DD.MM.YYYY');
          }
          if(angular.isNumber($stateParams.address_id)){
            vm.item.address_id = $stateParams.address_id;
          }
        })
        .error(function () {
          $log.debug('error Counter.load');
        });
    };

    //список типов счетчиков
    Counter.listTypes()
      .success(function(result){
        vm.types = result;
      })
      .error(function() {
        $log.debug('error');
      });

    //список моделей счетчиков
    Counter.listModels()
      .success(function(result){
        vm.models = result;
      })
      .error(function() {
        $log.debug('error');
      });

    //если в get-парметре указан id, загружаем данные счетчика
    if(angular.isNumber($stateParams.id)){
      init($stateParams.id);
    }

    //если в get-парметре указан flat_id, указываем id квартиры для добавления счечика
    if(angular.isNumber($stateParams.flat_id)){
      vm.item.flat_id = $stateParams.flat_id;
    }

    //если в get-парметре указан flat_id, указываем id адреса для добавления датчика к счетчику
    if(angular.isNumber($stateParams.address_id)){
      vm.item.address_id = $stateParams.address_id;
    }

    vm.send = function () {
      vm.form.error = '';
      if (vm.item.id) {
        update();
      } else {
        create();
      }
    };

    var create = function () {
      if (!vm.form.$invalid) {
        Counter.create(vm.item)
          .success(function(){
            $window.history.back();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var update = function () {
      if (!vm.form.$invalid) {
        Counter.update(vm.item)
          .success(function () {
            customDialogs.success();

            init(vm.item.id);
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    /**
    * Получает к-во импульсов по датчику по API датчика
    */
    vm.setStatusSensor = function(){
      vm.form.error = '';
      Sensor.setStatus({id:vm.item.sensor_id})
        .success(function(){
          customDialogs.success();
          console.log('fwefewfw')
          init(vm.item.id);
        })
        .error(function(errors) {
          Validation.parseErrors(vm.form, errors);
        });
    };

    //
    vm.sendCalibration = function () {
      vm.form.error = '';
      if (!vm.formCalibration.$invalid) {
        Sensor.calibrationItem({sensor_id:vm.item.sensor_id,value:vm.item.new_value})
          .success(function(){
            customDialogs.success();
            
            init(vm.item.id);
          })
          .error(function(errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    
    }
  }

})();

/**
 * Created by Елена on 24.05.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('CountersController', CountersController);

  /** @ngInject */
  function CountersController($state, $stateParams, $log, dialogs, Counter) {
    var vm = this;

    //смотрим get-парметр id (квартиры)
    if(angular.isNumber($stateParams.id)){
      //загружаем данные по счетчикам квартиры
      Counter.list({flat_id:$stateParams.id})
        .success(function(result){
          vm.listCounters = result;
        })
        .error(function () {
          $log.debug('error Counter.list');
        });
    }

    vm.delete = function(item){
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить "'+item.name+'"?');
      dlg.result.then(function(){
        Counter.delete(item.id)
          .success(function(){
            $state.go($state.current, {}, {reload: true});
          })
          .error(function() {
            $log.debug('error');
          });
      },function(){});
    };
  }
})();

/**
 * Created by Елена on 26.08.2016.
 */

(function() {
  'use strict';

  angular
    .module('web')
    .controller('FeedbackFormController', FeedbackFormController);

  /** @ngInject */
  function FeedbackFormController($rootScope, $stateParams, $log, customDialogs, Validation, User, Feedback, Flat, Mail) {
    var vm = this;
    vm.title = 'Вопрос - ответ';
    vm.item = {};
    vm.error = '';

    //Загружает данные по вопросу
    var initFeedback = function (id) {
      Feedback.load(id)
        .success(function (result) {
          vm.item = result;
          //ставим отметку "Просмотрено", если ее нет
          if(!result.read_company){
            Feedback.updateRead({id:result.id,read_company:true})
              .success(function() {
                //к-во непрочитанных сообщений в разделе "Вопрос-Ответ"
                Feedback.cnt({company_id:User.data.company_id,read_company: false})
                  .success(function(result_cnt){
                    $rootScope.newMsg.feedback = result_cnt;
                  })
                  .error(function() {
                    vm.form.error = 'Ошибка при загрузке количества сообщений';
                  });
              })
              .error(function (errors) {
                Validation.parseErrors(vm.form, errors);
              });
          }
        })
        .error(function (error) {
          vm.error = 'Ошибка при запросе данных вопроса';
          $log.debug(error);
        });
    };

    if(angular.isNumber($stateParams.id)){
      //если в get-парметре указан id, загружаем данные
      initFeedback($stateParams.id);
    }

    vm.send = function () {
      if (!vm.form.$invalid) {
        Feedback.update(vm.item)
          .success(function () {
            //приводим форму к первоначальному статусу
            vm.form.$setPristine();
            vm.form.$setUntouched();

            customDialogs.success();

            sendMail();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    var sendMail = function(){
      //отправляем ответ на email квартиры
      Flat.load(vm.item.flat_id)
        .success(function (item) {
          if(item.email){
            Mail.send({
                senderName: User.data.company.name,
                email:item.email,
                subject: 'Ответ на вопрос от '+User.data.company.name,
                message: "<h5>"+vm.item.question+"</h5><p><strong>Ответ:</strong> "+vm.item.answer+"</p>"
              })
              .success(function() {
                customDialogs.success('Сообщение на email успешно отправлено');
              })
              .error(function (error) {
                vm.form.error = 'Ошибка при отправке сообщения на email';
                $log.error(error);
              });
          }
        })
        .error(function (error) {
          $log.error(error);
        });
    };
  }
})();

/**
 * Created by Елена on 26.08.2016.
 */

(function() {
  'use strict';

  angular
    .module('web')
    .controller('FeedbackController', FeedbackController);

  /** @ngInject */
  function FeedbackController($log, dialogs, User, Address, Flat, Feedback) {
    var vm = this;
    vm.address = [];
    //лимит списка
    vm.limit = 30;
    vm.page = 1;

    vm.init = function(){
      Feedback.cnt({company_id:User.data.company_id,deleted_company: false})
        .success(function(result_cnt){
          vm.cnt_items = result_cnt;

          var params = {
            company_id:      User.data.company_id,
            deleted_company: false,
            limit:           vm.limit,
            offset:          (vm.limit * (vm.page - 1))
          };

          //загружаем данные
          Feedback.list(params)
            .success(function(result){
              vm.items = result;
              angular.forEach(result,function(item){
                //подгружаем данные по квартире жильца
                Flat.load(item.flat_id)
                  .success(function(data){
                    item.flat = data;
                    //подгружаем данные по адресу жильца
                    Address.load(data.address_id)
                      .success(function(data){
                        item.address = data;
                      })
                      .error(function (error) {
                        vm.error = 'Ошибка при загрузке данных';
                        $log.error(error);
                      });
                  })
                  .error(function (error) {
                    vm.error = 'Ошибка при загрузке данных';
                    $log.error(error);
                  });
              })
            })
            .error(function (error) {
              vm.error = 'Ошибка при загрузке данных';
              $log.error(error);
            });
        })
        .error(function(error) {
          vm.error = 'Ошибка при загрузке количества сообщений';
          $log.error(error);
        });
    };

    vm.init();

    //Обновляет вопрос с отметкой удалено в списке компании
    vm.delete = function (item) {
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите удалить вопрос "'+item.question+'"?');
      dlg.result.then(function(){
        //если вопрос удален у квартиры, то удаляем строку из базы
        if(item.deleted_flat){
          //иначе обновляем строку с отметкой удалено в списке компании
          Feedback.delete(item)
            .success(function(){
              vm.init();
            })
            .error(function(error) {
              vm.error = 'Ошибка при удалении';
              $log.error(error);
            });
        } else {
          //иначе обновляем строку с отметкой удалено в списке компании
          item.publish = false;
          item.deleted_company = true;
          Feedback.update(item)
            .success(function(){
              vm.init();
            })
            .error(function(error) {
              vm.error = 'Ошибка при удалении';
              $log.error(error);
            });
        }
      },function(){});
    };
  }
})();

/**
 * Created by Елена on 28.06.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('CounterStatsController', CounterStatsController);

  /** @ngInject */
  function CounterStatsController($log, moment, dialogs, Address, User, Counter, CounterStats, Settings) {
    var params, vm = this;
    vm.settings = [];
    vm.now = moment();
    vm.title = 'История показаний приборов учета';
    vm.page = 1;
    vm.limit = 20;

    //список типов счетчиков для фильтра
    Counter.listTypes()
      .success(function (result) {
        vm.types = result;
      })
      .error(function (error) {
        vm.error = 'Ошибка при получении списка видов показаний';
        $log.error(error);
      });
    //список адресов счетчиков для фильтра
    Address.list({company_id: User.data.company_id})
      .success(function (result_address) {
        if (!result_address) {
          vm.error = 'Список адресов пуст';
        } else {
          vm.addresses = result_address;
          vm.address_id = result_address[0].id;
          vm.companySettings();
        }
      })
      .error(function (error) {
        vm.error = 'Ошибка при получении списка адресов';
        $log.error(error);
      });
    //список статусов счетчиков для фильтра
    CounterStats.listStatuses()
      .success(function (result) {
        vm.statuses = result;
      })
      .error(function (error) {
        vm.error = 'Ошибка при получении списка статусов';
        $log.error(error);
      });

    vm.companySettings = function () {
      //загружаем настройки по показаниям счетчиков, чтобы указать дату старта
      Settings.list({company_id: User.data.company_id, section: 'counter_stats'})
        .success(function (result) {
          angular.forEach(result, function (item) {
            if (item.system_name === 'day_start') {
              vm.day_start = parseInt(item.value);
            }
            if (item.system_name === 'day_end') {
              vm.day_end = parseInt(item.value);
            }
          });
          if (vm.day_start && vm.day_end) {
            // формируем даты для сравнения
            // по умолчанию дату старта и дату окончания смотрим по текущему месяцу
            vm.date_start = moment(vm.now).set('date', vm.day_start).format('YYYY-MM-DD');
            vm.date_end = moment(vm.now).set('date', vm.day_end).format('YYYY-MM-DD');

            //если день старта больше чем день окончания вычисляем полные даты старта и окончания
            if (vm.day_start > vm.day_end) {
              //если текущий день больше дня старта, значит день старта в текущем месяце
              //а день окончания в след. месяце
              if (vm.now.get('date') >= vm.day_start) {
                //берем getMonth, т.к. setMonth меняет с 0
                vm.date_end = moment(vm.date_end).set('month',vm.now.get('month') + 1).format('YYYY-MM-DD');
              } else {
                //если текущий день меньше дня старта, значит день старта в предыдущем месяце
                //а день окончания в текущем месяце
                //берем getMonth, т.к. setMonth меняет с 0
                vm.date_start = moment(vm.date_start).set('month',vm.now.get('month') - 1).format('YYYY-MM-DD');
              }
            }
          }
          vm.initStats();
        })
        .error(function (error) {
          vm.error = 'Ошибка при запросе списка настроек';
          $log.error(error);
        });
    };

    vm.initStats = function () {
      vm.error = '';

      //параметры фильтра
      params = {
        address_id: vm.address_id,
        flat_name: vm.flat_name,
        type_id: vm.type_id,
        status_id: vm.status_id,
        date_start: (vm.date_start ? moment(vm.date_start).format('YYYY-MM-DD 00:00:00') : ''),
        date_end: (vm.date_end ? moment(vm.date_end).format('YYYY-MM-DD 23:59:59') : ''),
        limit: vm.limit,
        offset: (vm.limit * (vm.page - 1))
      };

      CounterStats.totalList(params)
        .success(function (result) {
          vm.totalList = result;
        })
        .error(function (error) {
          vm.error = 'Ошибка при получении общедомовой статистики показаний';
          $log.error(error);
        });

      //данные по показаниям
      CounterStats.cnt(params)
        .success(function (result_cnt) {
          vm.cnt_stats = result_cnt;
          CounterStats.list(params)
            .success(function (result_stats) {
              vm.stats = result_stats;
            })
            .error(function (error) {
              vm.error = 'Ошибка при получении статистики показаний';
              $log.error(error);
            });
        })
        .error(function (error) {
          vm.error = 'Ошибка при получении статистики показаний';
          $log.error(error);
        });
    };

    vm.find = function () {
      vm.page = 1;
      vm.initStats();
    };

    //Меняет статус показаний со статуса "Сдан" на "Принят к рассчету"
    vm.changeStatus = function () {
      //если период для подачи показаний окончен
      var dlg = dialogs.confirm('Необходимо подтверждение', 'Вы уверены что хотите принять показания к рассчету?');
      dlg.result.then(function () {
        CounterStats.changeStatus({address_id: vm.address_id})
          .success(function () {
            vm.initStats();
          })
          .error(function (error) {
            vm.error = 'Ошибка при изменении статуса показаний';
            $log.error(error);
          });
      }, function () {
      });
    };

  }
})();

/**
 * Created by Елена on 04.04.2018.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('ControlSimpleController', ControlSimpleController);

  /** @ngInject */
  function ControlSimpleController($state, $stateParams, $log, $timeout, $interval, $filter, Control) {
    var vm = this;
    vm.metaTitle = 'Ключевская, 15';
    vm.title = 'Ключевская, 15';
    vm.hash = $stateParams.hash;

    //Загружает список объектов управления
    vm.initControlObjects = function(){
      Control.listSimple({hash: vm.hash})
        .success(function(result){
          vm.controllList = result;

          //запускаем проверку статусов по всем объектам
          $timeout(function(){
            checkStatusesControll(result);
          }, 1000);
          //с интервалом запускаем проверку статусов по всем объектам
          vm.intervalStatus = $interval(function(){
            checkStatusesControll(result);
          },5000);
        })
        .error(function(error) {
          vm.error = 'Ошибка при получении списка объектов управления';
          $log.error(error);
        });
    };

    //проверка статусов объектов управления
    var checkStatusesControll = function(controllList){
      for(var i=0;i<controllList.length;i++){
        //проверяем, если есть ссылка для запроса статуса
        if($filter('inArray')(controllList[i].links, 'status')){
          vm.sendAction(controllList[i],'status');
        }
      }
    };

    vm.sendAction = function(controlItem, action){
      //если ушли со страницы, останавливаем запросы с интервалом
      if($state.current.name != "control-simple"){
        $interval.cancel(vm.intervalStatus); return false;
      }

      //не отправляем повтороный запрос пока не получили статус
      if(controlItem.status == 'load') return false;

      //статус toggle - меняем состояние (открыто / закрыто)
      if(action == 'toggle'){
        controlItem.label = 'default';
        if(controlItem.status == 'open'){
          vm.sendAction(controlItem, 'close');
        }
        if(controlItem.status == 'close'){
          vm.sendAction(controlItem, 'open');
        }
      } else {
        // console.log('sendSimple csrfToken',vm.csrfToken);
        Control.sendSimple({id:controlItem.id,action: action,hash:vm.hash})
          .success(function(response){
            var result = response.result;
            if(action == 'status'){
              //парсим ответ для отображения статуса
              if(result.indexOf('io_result') !== -1){
                result = result.replace('io_result(','').split(',');
                if(result[0] == "'ok'" && typeof(result[2]) != "undefined"){
                  result[2] = parseInt(result[2]);
                  //статус "Открыто"
                  if(result[2] == 0){
                    controlItem.status = 'close';
                    controlItem.label = 'danger';
                  }
                  //статус "Закрыто"
                  if(result[2] == 1){
                    controlItem.status = 'open';
                    controlItem.label = 'success';
                  }
                }
              }
            } else {
              controlItem.status = 'load';
              if(result == 'Incorrect action'){
                vm.error = 'Ошибка подключения к объекту управления';
              }
              $timeout(function(){
                controlItem.status = '';
                vm.sendAction(controlItem, 'status');
              }, 3000)
            }
          })
          .error(function(error) {
            vm.error = 'Ошибка выполнения запроса';
            $log.error(error);
          });
      }

    };

    vm.initControlObjects();
  }
})();

/**
 * Created by Елена on 16.03.2017.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('ControlController', ControlController);

  /** @ngInject */
  function ControlController($state, $stateParams, $log, $timeout, $interval, $filter, ApiUri, User, Address, Control) {
    var vm = this;
    vm.title = 'Управление доступом';
    //для is-open в uib-accordion
    vm.openIndex = [];

    //список адресов организации
    Address.list()
      .success(function(result_address){
        vm.addresses = [];
        angular.forEach(result_address,function(address,key){
          //если в get-парметре указан address_id, открываем блок объектов управления для указанного адреса
          if((angular.isNumber($stateParams.address_id) && $stateParams.address_id == address.id) || result_address.length == 1){
            vm.openIndex[key] = true;
          }

          if(address.image){
            address.image.file = ApiUri + '/upload/getImage?image='+address.image.file;
            address.image.thumb = ApiUri + '/upload/getImage?image='+address.image.thumb;
          }

          vm.addresses[key] = {
            item: address,
            page: 1,
            cnt_flats: 0,
            flats: []
          };
          vm.initControlObjects(address);
        });
      })
      .error(function() {
        $log.debug('error');
      });

    //Загружает список объектов управления для указанного адреса
    vm.initControlObjects = function(address){
      Control.list({company_id:User.data.company_id, address_id:address.id})
        .success(function(result){
          address.controllList = result;

          //запускаем проверку статусов по всем объектам
          checkStatusesControll(result);
          //с интервалом запускаем проверку статусов по всем объектам
          vm.intervalStatus = $interval(function(){
            checkStatusesControll(result);
          },5000);
        })
        .error(function(error) {
          vm.error = 'Ошибка при получении списка объектов управления';
          $log.error(error);
        });
    };

    //проверка статусов объектов управления
    var checkStatusesControll = function(controllList){
      for(var i=0;i<controllList.length;i++){
        //проверяем, если есть ссылка для запроса статуса
        if($filter('inArray')(controllList[i].links, 'status')){
          vm.sendAction(controllList[i],'status');
        }
      }
    };

    vm.sendAction = function(controlItem, action){
      //если ушли со страницы, останавливаем запросы с интервалом
      if($state.current.name != "control"){
        $interval.cancel(vm.intervalStatus); return false;
      }

      //не отправляем повтороный запрос пока не получили статус
      if(controlItem.status == 'load') return false;

      //статус toggle - меняем состояние (открыто / закрыто)
      if(action == 'toggle'){
        controlItem.label = 'default';
        if(controlItem.status == 'open'){
          vm.sendAction(controlItem, 'close');
        }
        if(controlItem.status == 'close'){
          vm.sendAction(controlItem, 'open');
        }
      } else {
        Control.send({id:controlItem.id,action: action})
          .success(function(response){
            var result = response.result;
            if(action == 'status'){
              //парсим ответ для отображения статуса
              if(result.indexOf('io_result') !== -1){
                result = result.replace('io_result(','').split(',');
                if(result[0] == "'ok'" && typeof(result[2]) != "undefined"){
                  result[2] = parseInt(result[2]);
                  //статус "Открыто"
                  if(result[2] == 0){
                    controlItem.status = 'close';
                    controlItem.label = 'danger';
                  }
                  //статус "Закрыто"
                  if(result[2] == 1){
                    controlItem.status = 'open';
                    controlItem.label = 'success';
                  }
                }
              }
            } else {
              controlItem.status = 'load';
              if(result == 'Incorrect action'){
                vm.error = 'Ошибка подключения к объекту управления';
              }
              $timeout(function(){
                controlItem.status = '';
                vm.sendAction(controlItem, 'status');
              }, 3000)
            }
          })
          .error(function(error) {
            vm.error = 'Ошибка выполнения запроса';
            $log.error(error);
          });
      }

    };
  }
})();

/**
 * Created by Елена on 08.05.2018.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('AlertsController', AlertsController);

  /** @ngInject */
  function AlertsController($log, Alerts) {
    var vm = this;
    vm.title = 'Предупреждения';

    Alerts.list()
      .success(function(result){
        if(!result){
          vm.error = 'Список адресов пуст';
        } else {
          vm.items = result;
        }
      })
      .error(function(error) {
        vm.error = 'Ошибка при получении даных';
        $log.error(error);
      });
  }
})();

/**
 * Created by Елена on 23.05.2016.
 */
(function () {
  'use strict';

  angular
    .module('web')
    .controller('AddressesFormController', AddressesFormController);

  function AddressesFormController($log, $stateParams, customDialogs, moment, Validation, User, Address, ApiUri, File, Upload) {
    var vm = this;
    vm.count_flats = 0;
    vm.item = {
      company_id: User.data.company_id
    };

    var initAddress = function(id){
      Address.load(id)
        .success(function (result) {
          vm.item = result;
          if(vm.item.image && vm.item.image.file){
            //текущее изображение, используется при удалении файла
            vm.currentImage = vm.item.image;
            vm.image = ApiUri + '/upload/getImage?image='+vm.item.image.thumb;
          }
        })
        .error(function () {
          $log.debug('error');
        });
    };

    if (angular.isNumber($stateParams.id)) {
      initAddress($stateParams.id);
    } else {
      vm.error = "Адрес не найден.";
    }

    vm.send = function () {
      if (vm.item.id) {
        updateAddress();
      } else {
        vm.error = "Адрес не найден.";
      }
    };

    var updateAddress = function () {
      if (!vm.form.$invalid) {
        Address.update(vm.item)
          .success(function () {
            customDialogs.success();
          })
          .error(function (errors) {
            Validation.parseErrors(vm.form, errors);
          });
      }
    };

    // Загрузка изображения на сервер
    vm.uploadImage = function () {
      vm.form.image.$setValidity('server', true);
      vm.form.image.msg = '';
      //ресайзим изображение для загрузки на сервер оригинала и миниатюры
      Upload.resize(vm.image, 100, 100, 0.9).then(function(resizedFile){
        Upload.upload({
          url: ApiUri + '/upload',
          data: {file: vm.image, thumb:resizedFile, domain_id:vm.item.id}
        }).then(function (resp) {
          //указываем что поле валидно
          vm.form.image.$setValidity('server', true);

          //обновляем данные, если указан id
          if(vm.item.id){
            vm.item.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
            vm.item.image = resp.data;
            updateImage();
          }
        }, function (resp) {
          vm.form.image.$setValidity('server', false);
          vm.form.image.msg = 'Ошибка при загрузке файла на сервер';
          $log.debug('Error status: ' + resp.status);
        });
      }, function (resp) {
        vm.form.image.$setValidity('server', false);
        vm.form.image.msg = 'Ошибка при формировании миниатюры';
        $log.debug('Error status: ' + resp.status);
      });
    };

    vm.preUploadImage = function (file, errFiles) {
      vm.form.image.$setValidity('server', true);
      vm.form.image.msg = '';
      if(errFiles.length){
        angular.forEach(errFiles,function(error){
          vm.form.image.$setValidity('server', false);
          vm.form.image.msg = error;
        })
      } else {
        if(file){
          //удаляем старое изображение
          if(vm.currentImage){
            File.unlink(vm.currentImage.file);
            File.unlink(vm.currentImage.thumb);
          }

          vm.image = file;

          //если форма редактирования
          if(vm.item.id){
            vm.uploadImage();
          }
        }
      }
    };

    //Обновляет данные по изображению в базе
    var updateImage = function(){
      Address.updateImage({id:vm.item.id,image:vm.item.image,updated_at:vm.item.updated_at})
        .success(function () {
          //приводим форму к первоначальному статусу
          vm.form.$setPristine();
          vm.form.$setUntouched();
          vm.form.$setUntouched();

          initAddress(vm.item.id);

          customDialogs.success();
        })
        .error(function (errors) {
          Validation.parseErrors(vm.form, errors);
        });
    };

    //Удаляет файл изображения и обновляет данные в базе
    vm.deleteImage = function(){
      if(vm.currentImage){
        File.unlink(vm.currentImage.file);
        File.unlink(vm.currentImage.thumb);
        vm.item.image = vm.image = null;
        updateImage();
      }
    };
  }

})();

/**
 * Created by Елена on 23.05.2016.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('AddressesController', AddressesController);

  /** @ngInject */
  function AddressesController($state, $log, dialogs, User, Address) {
    var vm = this;
    vm.title = 'Список адресов';

    var init = function(){
      Address.list()
        .success(function(result){
          vm.items = result;
        })
        .error(function() {
          $log.debug('error');
        });
    };

    init();
  }
})();

/**
 * Created by Елена on 04.12.2017.
 */
(function() {
  'use strict';

  angular
    .module('web')
    .controller('AddressesSensorsСalibrationController', AddressesSensorsСalibrationController);

  /** @ngInject */
  function AddressesSensorsСalibrationController($stateParams, $log, Validation, User, Address, Sensor, FileSaver, Blob) {
    var vm = this;
    //параметры калибровки
    vm.sensors = {};
    vm.result = {};

    vm.page = 1;
    vm.limit = 20;
    vm.exportExcel = 0;

    //параметры фильтра
    vm.params = {
      company_id:     User.data.company_id,
      // тип датчика (impulse - передает показания)
      type:           'impulse',
      // тип передаваемых данных с модема (impulse - передает импульсы, value - передает значение)
      type_value:     'impulse',
      address_id:     (vm.address_id ? vm.address_id : $stateParams.address_id),
      limit:          vm.limit,
      offset:         0
    };

    //список адресов счетчиков для фильтра
    Address.list()
      .success(function(result_address){
        if(!result_address){
          vm.error = 'Список адресов пуст';
        } else {
          vm.addresses = result_address;
          vm.address_id = result_address[0].id;
          vm.exportExcel = 0;
          vm.init();
        }
      })
      .error(function(error) {
        vm.error = 'Ошибка при получении списка адресов';
        $log.error(error);
      });

    vm.init = function() {
      vm.params.offset = (vm.limit * (vm.page - 1));

      Sensor.cnt(vm.params)
        .success(function(result_cnt){
          vm.cnt = result_cnt;
          Sensor.list(vm.params)
            .success(function(result_items){
              vm.items = result_items;
            })
            .error(function(error) {
              vm.error = 'Ошибка при получении данных';
              $log.error(error);
            });
        })
        .error(function(error) {
          vm.error = 'Ошибка при получении данных';
          $log.error(error);
        });
    };

    vm.find = function() {
      vm.params.exportExcel = 0;
      vm.page = 1;
      vm.init();
    };

    vm.export = function(){
      vm.params.exportExcel = 1;
      vm.params.limit = 0;
      vm.params.offset = 0;

      Sensor.listExport(vm.params)
        .success(function(response){
          var blob = new Blob([response], { type: 'application/vnd.ms-excel;charset=charset=utf-8' });
          FileSaver.saveAs(blob, 'КалибровкаДатчиков.xlsx');
        })
        .error(function(errors) {
          Validation.parseErrors(vm.form, errors);
        })
    };

    vm.send = function(){
      vm.form.error = '';
      vm.result = {};
      if(vm.sensors){
        Sensor.calibration({sensors:vm.sensors})
          .success(function(result){
            vm.init();
            //  записываем результат
            angular.forEach(result, function(item) {
              if(item && item.sensor_id){
                vm.result[item.sensor_id] = item;
              }
            });
          })
          .error(function(errors) {
            Validation.parseErrors(vm.form, errors);
          })
      } else {
        vm.form.error = "Укажите показания по приборам учета"
      }
    };

  }
})();

/**
 * Created by Елена on 15.02.16.
 */

//Валидация форм
angular.module('web')
  .factory('Validation', function($document){
    var validation = {};

    /**
     *  Обработка ошибок с API
     *  @param form - объект формы
     *         errors.validationErrors - массив с ошибками, сформированный модулем express-validator
     */
    validation.parseErrors = function(form,errors){
      if(errors && errors.validationErrors){
        angular.forEach(errors.validationErrors, function(item){
          //если сообщений для одного поля несколько, показываем их по порядку
          if(form[item.param]) {
            if(!form[item.param].$invalid) {
              //устанавливает для формы и поля $invalid = true
              form[item.param].$setValidity('server', false);
              //текст ошибки
              form[item.param].msg = item.msg;
            }

            //возвращает $invalid = false
            //чтобы форму можно было отправить после изменения полей
            $document.on('change keyup', form[item.param], function(){
              form[item.param].$setValidity('server', true);
            })
          } else {
            form.error = item.msg;
          }
        })
      } else {
        form.error = 'Неизвестная ошибка';
      }
    };

    return validation;
  });

/**
 * Created by dimon on 25.01.16.
 */

// Отвечает за работу с пользователем
angular.module('web')
  .factory('User', function($rootScope, $log, $state, $http, dialogs, ApiUri, Feedback, TechOrder, Video, Sensor, Alerts){

    var user = {};

    // признак, что юзер авторизован
    user.authorized = false;
    // Информация о пользователе
    user.data = {};

    // login_process - признак, что идет процесс авторизации
    user.login_process = false;

    // user_loading - признак, что идет загрузка информации о пользователе
    user.user_loading = false;

    // load_promise - promise объект загрузки информации пользователя
    user.load_promise = null;

    // метод авторизации
    user.login = function(email, password, callback) {
      user.login_process = true;
      $http.post(ApiUri + '/auth/login', {
          email: email,
          password: password
        })
        .success(function(result){
          user.load();
          if (callback) {
            callback(result);
          }
        })
        .error(function(result){
          user.login_process = false;
          if (callback) {
            callback(result);
          }
        });
    };

    user.logout = function() {
      $http.get(ApiUri + '/auth/logout')
        .success(function(){
          user.data = {};
          user.authorized = false;
          $rootScope.$broadcast('UserLoggedOut');
        });
    };

    user.registration = function( user ) {
      return $http.post(ApiUri + '/auth/registration', user);
    };

    // Обновляет информацию о пользователе (кроме пароля)
    user.updateInfo = function(item) {
      return $http.post(ApiUri + '/user/updateInfo',
        item);
    };

    // Генерирует валидный пароль
    user.generatePassword = function() {
      return Math.random().toString(36).slice(-8);
    };

    // Изменяет пароль текущего пользователя
    user.changePassword = function(item) {
      return $http.post(ApiUri + '/user/changePassword', item);
    };

    // запрос информации о пользователе
    user.load = function(callback){
      // Делаем только один единовременный запрос. Для остальных возвращаем существующий promise
      if (!user.load_promise) {
        user.load_promise = $http.get(ApiUri + '/auth/user')
          .success(function(userdata){

            user.load_promise = null;
            user.authorized = true;
            user.data = userdata;
            user.login_process = false;

            //Переменная содержит к-во непрочитанных сообщений в разных разделах
            user.data.newMsg = {
              alerts:0,
              feedback:0,
              tech_orders:0
            };
            //к-во предупреждений
            Alerts.cnt()
              .success(function(result_cnt){
                user.data.newMsg.alerts = result_cnt;
              })
              .error(function(error) {
                $log.error('Ошибка при загрузке предупреждений: '+error);
              });
            //к-во непрочитанных сообщений в разделе "Вопрос-Ответ"
            Feedback.cnt({company_id:userdata.company_id,read_company: false})
              .success(function(result_cnt){
                user.data.newMsg.feedback = result_cnt;
              })
              .error(function(error) {
                $log.error('Ошибка при загрузке количества сообщений в разделе Вопрос-Ответ: '+error);
              });
            //к-во непрочитанных сообщений в разделе "Вызов специалиста"
            TechOrder.cnt({company_id:userdata.company_id,read_company: false})
              .success(function(result_cnt){
                user.data.newMsg.tech_orders = result_cnt;
              })
              .error(function(error) {
                $log.error('Ошибка при загрузке количества сообщений в разделе Заявки: '+error);
              });
            //  Список камер клиента
            Video.list()
              .success(function(result){
                user.data.company.cameras = result;
              })
              .error(function(error) {
                $log.error('error', error);
              });

            Sensor.list({company_id:userdata.company_id})
              .success(function(result){
                user.data.sensors = result;
              })
              .error(function(error) {
                $log.error('error', error);
              });
          })
          .error(function(error){
            if(error.errorOauthEss){
              user.errorOauthEss = error.errorOauthEss;
            }
            if(error.statusOauthEss){
              user.statusOauthEss = error.statusOauthEss;
            }
            user.authorized = false;
            user.load_promise = null;
            if (callback) {
              callback(user);
            }
          });
      }
      return user.load_promise;
    };
    user.load();

    user.oauth = function(params){
      return $http.get(ApiUri + '/auth/oauth',{params:params});
    };

    //чистим парметры oauth
    user.clearParamOauthEss = function(param){
      if(param == 'error'){
        user.errorOauthEss = null;
      }
      if(param == 'status'){
        user.statusOauthEss = null;
      }
      return $http.get(ApiUri + '/auth/clearParamOauthEss',{params:{param:param}});
    };
    return user;
  });

/**
 * Created by Елена on 14.11.2016.
 */
angular.module('web')
  .factory('Month', function(){

    var item = {};

    item.list = function() {
      return [
        {id: 1, name: 'Январь'},
        {id: 2, name: 'Февраль'},
        {id: 3, name: 'Март'},
        {id: 4, name: 'Апрель'},
        {id: 5, name: 'Май'},
        {id: 6, name: 'Июнь'},
        {id: 7, name: 'Июль'},
        {id: 8, name: 'Август'},
        {id: 9, name: 'Сентябрь'},
        {id: 10, name: 'Октябрь'},
        {id: 11, name: 'Ноябрь'},
        {id: 12, name: 'Декабрь'}
      ];
    };

    return item;
  });

/**
 * Created by Елена on 31.08.2016.
 */
angular.module('web')
  .factory('Mail', function($http, $log, ApiUri){
    var item = {};

    //отправление сообщения на email
    item.send = function(params){
      return $http.post(ApiUri + '/mail/send',params);
    };

    return item;
  });

/**
 * Created by Елена on 15.08.2016.
 */
angular.module('web')
  .factory('File', function($http, $log, Upload, ApiUri){
    var file = {};

    //удаление файла с сервера
    file.unlink = function(params){
      if(angular.isString(params)){
        params = {file: params}
      }
      return $http.post(ApiUri + '/upload/unlink',params);
    };

    //удаление директории с сервера
    file.rmdir = function(dir){
      return $http.post(ApiUri + '/upload/rmdir',{dir: dir});
    };

    return file;
  });

/**
 * Created by Елена on 21.04.16.
 */

//Сервис для кастомных диалоговых окон
angular.module('web')

  //настройки директивы диалоговых окон
  .config(['dialogsProvider','$translateProvider',function(dialogsProvider,$translateProvider){
    dialogsProvider.useBackdrop('static');
    dialogsProvider.useEscClose(false);
    dialogsProvider.useCopy(false);
    dialogsProvider.setSize('md');

    $translateProvider.translations('ru',{
      DIALOGS_ERROR: "Ошибка",
      DIALOGS_ERROR_MSG: "Произошла неизвестная ошибка.",
      DIALOGS_CLOSE: "Закрыть",
      DIALOGS_PLEASE_WAIT: "Пожалуйста подождите",
      DIALOGS_PLEASE_WAIT_ELIPS: "Пожалуйста подождите...",
      DIALOGS_PLEASE_WAIT_MSG: "Пожалуйста подождите завершения операции.",
      DIALOGS_PERCENT_COMPLETE: "% Выполнения",
      DIALOGS_NOTIFICATION: "Уведомление",
      DIALOGS_NOTIFICATION_MSG: "",
      DIALOGS_CONFIRMATION: "Необходимо подтверждение",
      DIALOGS_CONFIRMATION_MSG: "Вы уверены?",
      DIALOGS_OK: "Ok",
      DIALOGS_YES: "Да",
      DIALOGS_NO: "Отмена"
    });
    $translateProvider.preferredLanguage('ru');
  }])

  .factory('customDialogs', function(dialogs){
    var modal = {};

    //Открывает окно с сообщением и автоматически закрывает через 700 мс
    modal.success = function(msg){
      dialogs.create('/dialogs/success.html','DialogsSuccessController',
        {msg: (msg ? msg : 'Изменения успешно сохранены')},
        {size:'sm', keyboard: true, backdrop: false, windowClass: 'modal-success'});
    };

    return modal;
  })

  //контроллер для диалогового окна с сообщением об успешном завершении события
  .controller('DialogsSuccessController', function($scope, $timeout, data){
    $scope.msg = data.msg;

    $timeout(function(){
      $scope.$destroy();
    },700);
  })

  .run(['$templateCache',function($templateCache){
    $templateCache.put('/dialogs/success.html','<div class="progress m-a-0"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" style="width: 100%">{{msg}}</div></div>');
  }]);

/**
 * Created by Елена on 12.02.2016.
 */
angular.module('web')
  .factory('Company', function($rootScope, $state, $http, $log, dialogs, ApiUri){
    var company = {};
    // load_promise - promise объект загрузки информации
    company.load_promise = null;

    company.load = function(id){
      return $http.get(ApiUri + '/companies/item',{params:{id:id}});
    };

    company.update = function(item){
      return $http.post(ApiUri + '/companies/update',item);
    };

    return company;
  });

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {

  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  function getDecimals(n) {
    n = n + '';
    var i = n.indexOf('.');
    return (i == -1) ? 0 : n.length - i - 1;
  }

  function getVF(n, opt_precision) {
    var v = opt_precision;

    if (angular.isUndefined(v)) {
      v = Math.min(getDecimals(n), 3);
    }

    var base = Math.pow(10, v);
    var f = ((n * base) | 0) % base;
    return {v: v, f: f};
  }

  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "\u0414\u041f",
        "\u041f\u041f"
      ],
      "DAY": [
        "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435",
        "\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
        "\u0432\u0442\u043e\u0440\u043d\u0438\u043a",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043f\u044f\u0442\u043d\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043e\u0442\u0430"
      ],
      "ERANAMES": [
        "\u0434\u043e \u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0430 \u0425\u0440\u0438\u0441\u0442\u043e\u0432\u0430",
        "\u043e\u0442 \u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0430 \u0425\u0440\u0438\u0441\u0442\u043e\u0432\u0430"
      ],
      "ERAS": [
        "\u0434\u043e \u043d. \u044d.",
        "\u043d. \u044d."
      ],
      "FIRSTDAYOFWEEK": 0,
      "MONTH": [
        "\u044f\u043d\u0432\u0430\u0440\u044c",
        "\u0444\u0435\u0432\u0440\u0430\u043b\u044c",
        "\u043c\u0430\u0440\u0442",
        "\u0430\u043f\u0440\u0435\u043b\u044c",
        "\u043c\u0430\u0439",
        "\u0438\u044e\u043d\u044c",
        "\u0438\u044e\u043b\u044c",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c",
        "\u043e\u043a\u0442\u044f\u0431\u0440\u044c",
        "\u043d\u043e\u044f\u0431\u0440\u044c",
        "\u0434\u0435\u043a\u0430\u0431\u0440\u044c"
      ],
      "SHORTDAY": [
        "\u0432\u0441",
        "\u043f\u043d",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043f\u0442",
        "\u0441\u0431"
      ],
      "SHORTMONTH": [
        "\u044f\u043d\u0432.",
        "\u0444\u0435\u0432\u0440.",
        "\u043c\u0430\u0440.",
        "\u0430\u043f\u0440.",
        "\u043c\u0430\u044f",
        "\u0438\u044e\u043d.",
        "\u0438\u044e\u043b.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043d\u0442.",
        "\u043e\u043a\u0442.",
        "\u043d\u043e\u044f\u0431.",
        "\u0434\u0435\u043a."
      ],
      "STANDALONEMONTH": [
        "\u044f\u043d\u0432\u0430\u0440\u044c",
        "\u0444\u0435\u0432\u0440\u0430\u043b\u044c",
        "\u043c\u0430\u0440\u0442",
        "\u0430\u043f\u0440\u0435\u043b\u044c",
        "\u043c\u0430\u0439",
        "\u0438\u044e\u043d\u044c",
        "\u0438\u044e\u043b\u044c",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c",
        "\u043e\u043a\u0442\u044f\u0431\u0440\u044c",
        "\u043d\u043e\u044f\u0431\u0440\u044c",
        "\u0434\u0435\u043a\u0430\u0431\u0440\u044c"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d MMMM y '\u0433'.",
      "longDate": "d MMMM y '\u0433'.",
      "medium": "d MMM y '\u0433'. H:mm:ss",
      "mediumDate": "d MMM y '\u0433'.",
      "mediumTime": "H:mm:ss",
      "short": "dd.MM.yy H:mm",
      "shortDate": "dd.MM.yy",
      "shortTime": "H:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "\u20bd",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": "\u00a0",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "\u00a0\u00a4",
          "posPre": "",
          "posSuf": "\u00a0\u00a4"
        }
      ]
    },
    "id": "ru",
    "localeID": "ru",
    "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {    return PLURAL_CATEGORY.ONE;  }  if (vf.v == 0 && i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 12 || i % 100 > 14)) {    return PLURAL_CATEGORY.FEW;  }  if (vf.v == 0 && i % 10 == 0 || vf.v == 0 && i % 10 >= 5 && i % 10 <= 9 || vf.v == 0 && i % 100 >= 11 && i % 100 <= 14) {    return PLURAL_CATEGORY.MANY;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function() {
  'use strict';

  angular
    .module('web')
    .factory('authHttpResponseInterceptor',function($q, $location, $cookies, $injector){
      // Интерцептор, в случае получения ошибки 401 перекидывает клиента на страницу логина
      return {
        responseError: function(rejection) {
          var stateService = $injector.get('$state');
          if (rejection.status === 401) {
            // console.log('Response Error 401',stateService);
            if ($location.path() !== '/registration' && $location.path() !== '/control-simple') {
              // записываем в куки путь с которого пришли, для переадресации после авторизации
              $cookies.put('redirectAuthUrl', $location.url(), {path: '/'});
              stateService.go('login');
            }
          }
          return $q.reject(rejection);
        }
      }
    })
    .config(function($httpProvider){
      $httpProvider.interceptors.push('authHttpResponseInterceptor');
    })
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $window, $state, $http, User) {
    $rootScope.user = User;

    //проверка прав доступа, права пользователя хранятся в User.data.states
    $rootScope.role = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      // если у state не стоит признак, что доступ всем разрешен (toState.data.accessAll), проверяем права доступа
      // если не суперпользователь и в списке прав нет текущего state, отправляем на страницу с ошибкой прав доступа
      console.log(toState, User.data.states)
      console.log((angular.isUndefined(toState.data) || (angular.isDefined(toState.data) && !toState.data.accessAll)) && !User.data.superuser && (!User.data.states || User.data.states.indexOf(toState.name) === -1))
      if ((angular.isUndefined(toState.data) || (angular.isDefined(toState.data) && !toState.data.accessAll)) && !User.data.superuser && (!User.data.states || User.data.states.indexOf(toState.name) === -1)) {
        event.preventDefault();
        $state.go('accessdenied');
      }

    });

    $rootScope.logout = function(){
      User.logout();
      $state.go('login');
    };

    $rootScope.goBack = function() {
      $window.history.back();
    };

    //определяем что пользователь зашел с мобильного
    $rootScope.mobileCheck = mobileCheck($window);

    $http.get('errorList.json')
      .then(function(response){
        $rootScope.errorList = response.data;
      });

    $rootScope.loading = false;
  }

  /**
   *  Определяет пользователь с мобильного или с ПК зашел
   *  @return boolean
   */
  function mobileCheck($window){
    var mobile = false;
    (function(a){
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) mobile = true;
    })
    (navigator.userAgent||navigator.vendor||$window.opera);
    console.log((navigator.userAgent||navigator.vendor||$window.opera));
    return mobile;
  }
})();

(function() {
  'use strict';

  angular
    .module('web')
    .config(routerConfig);

  var checkLogin = function(User){
    return User.load();
  };

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        data: {
          //доступ всем разрешен
          accessAll: true
        },
        views: {
          'container': {
            templateUrl: 'app/pages/login/login.html',
            controller: 'LoginController',
            controllerAs: 'LoginController'
          }
        }
      })
      .state('control-simple', {
        url: '/control-simple?{hash}',
        description:'Управление объектами дома Ключевская, 15',
        data: {
          //доступ всем разрешен
          accessAll: true
        },
        views: {
          'container': {
            controller: 'ControlSimpleController',
            controllerAs: 'control',
            templateUrl: 'app/pages/control/views/content_simple.html'
          }
        }
      })
      .state('main', {
        abstract: true,
        resolve:{user:checkLogin},
        views: {
          'container': {
            templateUrl: 'app/views/layout_main.html'
          },
          'menu@main': {
            templateUrl: 'app/views/menu.html'
          }
        }
      })
      .state('accessdenied', {
        parent: 'main',
        url: '/accessdenied',
        data: {
          //доступ всем разрешен
          accessAll: true
        },
        views: {
          'content@main': {
            templateUrl: 'app/views/accessdenied.html'
          }
        }
      })
      .state('home', {
        parent: 'main',
        url: '/',
        description:'Просмотр общей информации',
        views: {
          'content@main': {
            templateUrl: 'app/pages/main/views/content.html',
            controller: 'MainController',
            controllerAs: 'main'
          }
        }
      })
      .state('video', {
        parent: 'main',
        url: '/video',
        description:'Видеонаблюдение',
        views: {
          'content@main': {
            templateUrl: 'app/pages/video/views/content.html',
            controller: 'VideoController',
            controllerAs: 'video'
          }
        }
      })
      .state('workers', {
        parent: 'main',
        url: '/workers',
        description:'Просмотр списка сотрудников',
        views: {
          'content@main': {
            templateUrl: 'app/pages/workers/views/content.html',
            controller: 'WorkersController',
            controllerAs: 'workers'
          }
        }
      })
      .state('workers.item', {
        url: '/item?{id:int}',
        description:'Добавление / Редактирование данных сотрудника',
        views: {
          'content@main': {
            controller: 'WorkersFormController',
            controllerAs: 'worker',
            templateUrl: 'app/pages/workers/views/form_item.html'
          }
        }
      })
      .state('workers.permitions', {
        url: '/permitions?{id:int}',
        description:'Назначение прав доступа сотрудникам',
        views: {
          'content@main': {
            controller: 'WorkersPermitionsController',
            controllerAs: 'permitions',
            templateUrl: 'app/pages/workers/views/permitions.html'
          }
        }
      })
      .state('addresses', {
        parent: 'main',
        url: '/addresses',
        description:'Просмотр списка адресов',
        views: {
          'content@main': {
            templateUrl: 'app/pages/addresses/views/content.html',
            controller: 'AddressesController',
            controllerAs: 'addresses'
          }
        }
      })
      .state('addresses.sensors', {
        url: '/sensors?{address_id:int}',
        description:'Список датчиков на счетчиках квартир в доме',
        views: {
          'content@main': {
            controller: 'AddressesSensorsController',
            controllerAs: 'sensors',
            templateUrl: 'app/pages/addresses/views/form_sensors.html'
          }
        }
      })
      .state('addresses.sensors.calibration', {
        url: '/calibration',
        description:'Калибровка датчиков на счетчиках квартир в доме',
        views: {
          'content@main': {
            controller: 'AddressesSensorsСalibrationController',
            controllerAs: 'calibration',
            templateUrl: 'app/pages/addresses/views/calibration_sensors.html'
          }
        }
      })
      .state('addresses.item', {
        url: '/item?{id:int}',
        description:'Редактирование адреса',
        views: {
          'content@main': {
            controller: 'AddressesFormController',
            controllerAs: 'address',
            templateUrl: 'app/pages/addresses/views/form_item.html'
          }
        }
      })
      .state('flats', {
        parent: 'main',
        url: '/flats?{address_id:int}',
        description:'Просмотр списка квартир',
        views: {
          'content@main': {
            templateUrl: 'app/pages/flats/views/content.html',
            controller: 'FlatsController',
            controllerAs: 'flats'
          }
        }
      })
      .state('flats.item', {
        url: '/item?{id:int}{index:int}',
        description:'Добавление / Редактирование квартиры',
        views: {
          'content@main': {
            controller: 'FlatsFormController',
            controllerAs: 'flat',
            templateUrl: 'app/pages/flats/views/form_flat.html'
          }
        }
      })
      .state('flats.counter', {
        url: '/counter?{flat_id:int}{id:int}',
        description:'Добавление / Редактирование счетчика',
        views: {
          'content@main': {
            controller: 'CountersFormController',
            controllerAs: 'counter',
            templateUrl: 'app/pages/flats/views/form_counter.html'
          }
        }
      })
      .state('counter_stats', {
        parent: 'main',
        url: '/counters/stats',
        description:'Просмотр показаний приборов учета',
        views: {
          'content@main': {
            templateUrl: 'app/pages/counter_stats/views/content.html',
            controller: 'CounterStatsController',
            controllerAs: 'counter_stats'
          }
        }
      })
      .state('settings', {
        parent: 'main',
        url: '/settings',
        description:'Редактирование настроек приборов учета',
        views: {
          'content@main': {
            templateUrl: 'app/pages/settings/views/content.html',
            controller: 'SettingsController',
            controllerAs: 'settings'
          }
        }
      })
      .state('site', {
        parent: 'main',
        url: '/site',
        description:'Просмотр меню раздела "Управление сайтом"',
        views: {
          'content@main': {
            templateUrl: 'app/pages/site/views/content.html',
            controller: 'SiteController',
            controllerAs: 'site'
          }
        }
      })
      .state('site.domain', {
        url: '/domain',
        description:'Редактирование настроек домена',
        views: {
          'content@main': {
            templateUrl: 'app/pages/site/views/form_domain.html',
            controller: 'DomainFormController',
            controllerAs: 'domain'
          }
        }
      })
      .state('site.structure', {
        url: '/structure',
        description:'Просмотр структуры сайта',
        views: {
          'content@main': {
            templateUrl: 'app/pages/site/views/structure.html',
            controller: 'StructureController',
            controllerAs: 'structure'
          }
        }
      })
      .state('site.structure.item', {
        url: '/item?{parent_id:int}{id:int}',
        description:'Добавление / Редактирование страниц сайта',
        views: {
          'content@main': {
            templateUrl: 'app/pages/site/views/form_structure.html',
            controller: 'StructureFormController',
            controllerAs: 'structure'
          }
        }
      })
      .state('feedback', {
        parent: 'main',
        url: '/feedback',
        description:'Просмотр списка вопросов от жильцов',
        views: {
          'content@main': {
            templateUrl: 'app/pages/feedback/views/content.html',
            controller: 'FeedbackController',
            controllerAs: 'feedback'
          }
        }
      })
      .state('feedback.item', {
        url: '/item?{id:int}',
        description:'Добавление / Редактирование ответа на вопросы от жильцов',
        views: {
          'content@main': {
            templateUrl: 'app/pages/feedback/views/form_feedback.html',
            controller: 'FeedbackFormController',
            controllerAs: 'feedback'
          }
        }
      })
      .state('tech_orders', {
        parent: 'main',
        url: '/tech_orders',
        description:'Просмотр списка заявок на вызов специалиста',
        views: {
          'content@main': {
            templateUrl: 'app/pages/tech_orders/views/content.html',
            controller: 'TechOrderController',
            controllerAs: 'order'
          }
        }
      })
      .state('tech_orders.item', {
        url: '/item?{id:int}',
        description:'Редактирование заявки на вызов специалиста',
        views: {
          'content@main': {
            templateUrl: 'app/pages/tech_orders/views/form_order.html',
            controller: 'TechOrderFormController',
            controllerAs: 'order'
          }
        }
      })
      .state('technicians', {
        parent: 'main',
        url: '/technicians',
        description:'Просмотр списка специалистов',
        views: {
          'content@main': {
            templateUrl: 'app/pages/technicians/views/content.html',
            controller: 'TechniciansController',
            controllerAs: 'technician'
          }
        }
      })
      .state('technicians.item', {
        url: '/item?{id:int}',
        description:'Добавление / Редактирование данных специалиста',
        views: {
          'content@main': {
            templateUrl: 'app/pages/technicians/views/form_technician.html',
            controller: 'TechniciansFormController',
            controllerAs: 'technician'
          }
        }
      })
      .state('messages', {
        parent: 'main',
        url: '/messages',
        description:'Просмотр списка уведомлений',
        views: {
          'content@main': {
            templateUrl: 'app/pages/messages/views/content.html',
            controller: 'MessagesController',
            controllerAs: 'messages'
          }
        }
      })
      .state('messages.item', {
        url: '/item?{id:int}',
        description:'Добавление / Редактирование уведомления',
        views: {
          'content@main': {
            templateUrl: 'app/pages/messages/views/form_message.html',
            controller: 'MessagesFormController',
            controllerAs: 'message'
          }
        }
      })
      .state('sync', {
        parent: 'main',
        url: '/sync?{address_id:int}',
        description:'Просмотр меню синхронизации данных',
        views: {
          'content@main': {
            controller: '',
            controllerAs: '',
            templateUrl: 'app/pages/sync/views/content.html'
          }
        }
      })
      .state('sync.import', {
        url: '/import',
        description:'Загрузка данных по квитанциям и приборам учета',
        views: {
          'content@main': {
            controller: 'ImportController',
            controllerAs: 'sync',
            templateUrl: 'app/pages/sync/views/form_import.html'
          }
        }
      })
      .state('sync.export', {
        url: '/export?{id:int}',
        description:'Выгрузка данных с показаниями приборов учета',
        views: {
          'content@main': {
            controller: 'ExportController',
            controllerAs: 'sync',
            templateUrl: 'app/pages/sync/views/form_export.html'
          }
        }
      })
      .state('control', {
        parent: 'main',
        url: '/control?{address_id:int}',
        description:'Управление объектами дома (шлагбаумы, ворота)',
        views: {
          'content@main': {
            controller: 'ControlController',
            controllerAs: 'control',
            templateUrl: 'app/pages/control/views/content.html'
          }
        }
      })
      .state('sensors', {
        parent: 'main',
        url: '/sensors?{address_id:int}',
        description:'Мониторинг дома (датчики)',
        views: {
          'content@main': {
            controller: 'SensorsController',
            controllerAs: 'sensor',
            templateUrl: 'app/pages/sensors/views/content.html'
          }
        }
      })
      .state('sensors.item', {
        parent: 'sensors',
        url: '/item?{id:int}',
        description:'Редактирование датчика дома',
        views: {
          'content@main': {
            controller: 'SensorsFormController',
            controllerAs: 'sensor',
            templateUrl: 'app/pages/sensors/views/form_sensor.html'
          }
        }
      })
      .state('alerts', {
        parent: 'main',
        url: '/alerts',
        description:'Просмотр предупреждений',
        views: {
          'content@main': {
            controller: 'AlertsController',
            controllerAs: 'alerts',
            templateUrl: 'app/pages/alerts/views/content.html'
          }
        }
      })
      .state('reestr', {
        parent: 'main',
        url: '/reestr?{address_id:int}',
        description:'Реестр собственников',
        views: {
          'content@main': {
            controller: 'ReestrController',
            controllerAs: 'reestr',
            templateUrl: 'app/pages/reestr/views/content.html'
          }
        }
      })
      .state('reestr.item', {
        url: '/item?{id:int}{index:int}{flat_id:int}',
        description:'Добавление / Редактирование данных собственника',
        views: {
          'content@main': {
            controller: 'ReestrFormController',
            controllerAs: 'reestr',
            templateUrl: 'app/pages/reestr/views/form_item.html'
          }
        }
      })
      .state('voting', {
        parent: 'main',
        url: '/voting?{address_id:int}',
        description:'Список голосований',
        views: {
          'content@main': {
            controller: 'VotingController',
            controllerAs: 'voting',
            templateUrl: 'app/pages/voting/views/content.html'
          }
        }
      })
      .state('voting.item', {
        url: '/item?{id:int}{index:int}',
        description:'Добавление / Редактирование данных голосования',
        views: {
          'content@main': {
            controller: 'VotingFormController',
            controllerAs: 'voting',
            templateUrl: 'app/pages/voting/views/form_voting.html'
          }
        }
      })
      .state('voting.question', {
        url: '/question?{voting_id:int}{id:int}',
        description:'Добавление / Редактирование вопроса на голосование',
        views: {
          'content@main': {
            controller: 'VotingQuestionFormController',
            controllerAs: 'voting',
            templateUrl: 'app/pages/voting/views/form_question.html'
          }
        }
      })
      .state('voting.result', {
        url: '/result?{voting_id:int}{owner_id:int}',
        description:'Добавление / Редактирование ответа на голосование',
        views: {
          'content@main': {
            controller: 'VotingResultFormController',
            controllerAs: 'voting',
            templateUrl: 'app/pages/voting/views/form_result.html'
          }
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */

(function() {
  'use strict';

  angular
    .module('web')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('ApiUri', '/api')

})();

(function() {
  'use strict';

  angular
    .module('web')

    // настраиваемый элемент формы
    .directive('formElement', function() {
      return {
        templateUrl:"app/views/form/item.html",
        transclude: true,
        scope:{
          id:"@",
          name:"@",
          title:"@",
          class:"@",
          helpHide:"@",
          helpMsg:"@",
          form:"=",
          formItem:"="
        },
        link: function(scope) {
          // текущий элемент формы из массива form
          if(scope.form){
            scope.scopeformItem = scope.form[scope.name];
          }
        }
      }
    })

    /**
     * Фильтр для шаблонов
     * проверяет наличие в массиве элемента по значению
     * @params: array - массив
     *          needle - значение, для поиска в массиве
     */
    .filter('inArray', function() {
      return function (array, needle) {
        return array.indexOf(needle) >= 0;
      };
    })

    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

angular.module("web").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/404.html","<h1>404</h1>");
$templateCache.put("app/views/accessdenied.html","<h3>Доступ запрещен.</h3>");
$templateCache.put("app/views/layout_main.html","<!-- Левое меню --><div id=sidebar><div ui-view=menu></div></div><div id=container><!-- Основной контент --><div id=content class=\"container-fluid clearfix\"><div class=\"col-lg-9 p-x-0\"><div ui-view=content></div></div></div></div><div id=sheet-loading ng-show=loading></div>");
$templateCache.put("app/views/menu.html","<div id=menu><div class=\"visible-lg visible-md\"><div class=\"text-uppercase logo-title h4\"><a href ui-sref=home>Личный кабинет</a></div><div class=\"user_info p-t-md\"><div>{{ user.data.company.name }}</div><div>{{ user.data.name }}</div></div></div><div class=\"visible-xs visible-sm\"><div class=\"p-a-md clearfix\"><div class=\"flex flex-center navbar-header\"><div class=col-xs-10><a href ui-sref=home class=text-default>{{ user.data.company.name }}<br>{{ user.data.name }}</a></div><div class=col-xs-2><button type=button class=\"navbar-toggle h3 m-a-0 p-a-0\" ng-click=\"isNavCollapsed = !isNavCollapsed\"><i class=\"fa fa-bars\"></i></button></div></div></div></div><div class=\"collapse navbar-collapse p-a-0\" uib-collapse=isNavCollapsed ng-init=\"(mobileCheck ? (mobileCheck ? isNavCollapsed = true : \'\') : \'\')\"><ul class=\"nav nav-pills nav-stacked\"><li ng-show=user.data.newMsg.alerts><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=alerts ui-sref-active=active class=active><i class=\"fa fa-exclamation\"></i><span>Предупреждения</span> &nbsp;<label ng-show=user.data.newMsg.alerts class=\"label label-info\">{{user.data.newMsg.alerts}}</label></a></li><li ng-show=user.data.company.cameras.length><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=video ui-sref-active=active><i class=\"fa fa-video-camera\"></i><span>Видеонаблюдение</span></a></li><li ng-show=user.data.control.length><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=control ui-sref-active=active class=active><i class=\"fa fa-building-o\"></i><span>Управление доступом</span></a></li><li ng-show=user.data.sensors.length><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=sensors ui-sref-active=active class=active><i class=\"fa fa-signal\"></i><span>Мониторинг</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=site ui-sref-active=active class=active><i class=\"fa fa-sitemap\"></i><span>Управление сайтом</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=workers ui-sref-active=active class=active><i class=\"fa fa-user\"></i><span>Сотрудники</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=flats ui-sref-active=active class=active><i class=\"fa fa-building-o\"></i><span>Жилой фонд</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=voting ui-sref-active=active class=active><i class=\"fa fa-file-text\"></i><span>Голосование</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=counter_stats ui-sref-active=active class=active><i class=\"fa fa-table\"></i><span>Показания приборов учета</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href=/monitor/ ><i class=\"fa fa-table\"></i><span>Мониторинг показаний</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href=http://85.12.197.248:3600><i class=\"fa fa-table\"></i><span>Общедомовой учет</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=settings ui-sref-active=active class=active><i class=\"fa fa-cogs\"></i><span>Настройки приборов учета</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=sync ui-sref-active=active class=active><i class=\"fa fa-download\"></i><span>Импорт / Экспорт</span></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=feedback ui-sref-active=active class=active><i class=\"fa fa-comments-o\"></i> <span>Вопрос-ответ</span> &nbsp;<label ng-show=\"(user.data.newMsg.feedback > 0)\" class=\"label label-info\">{{user.data.newMsg.feedback}}</label></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=tech_orders ui-sref-active=active class=active><i class=\"fa fa-phone\"></i> <span>Заявки</span> &nbsp;<label ng-show=\"(user.data.newMsg.tech_orders > 0)\" class=\"label label-info\">{{user.data.newMsg.tech_orders}}</label></a></li><li><a ng-click=\"(mobileCheck ? isNavCollapsed = true : \'\')\" href ui-sref=messages ui-sref-active=active class=active><i class=\"fa fa-envelope-o\"></i><span>Уведомления</span></a></li><li><a href class=btn-logout ng-click=logout()><i class=\"fa fa-power-off\"></i><span>ВЫХОД</span></a></li></ul></div></div>");
$templateCache.put("app/views/menu_top.html","<div id=menu-top class=clearfix><ul class=\"nav nav-pills pull-left\"><li role=presentation><a href=#>История изменений</a></li><li role=presentation><a href=#>Публичная оферта</a></li></ul></div>");
$templateCache.put("app/pages/login/login.html","<div id=login class=center-block><h2 class=m-x>Вход</h2><form class=\"well m-x\" ng-submit=LoginController.login() name=LoginController.login_form novalidate><div class=\"row m-b-lg\"><div class=\"col-sm-10 col-sm-offset-1 col-xs-12\"><a href ng-click=LoginController.oauth() class=\"btn btn-block btn-info-light\"><img class=m-r-md src=/images/insys_logo.png> Войти через ИНСИС</a></div></div><h5 class=\"text-uppercase text-center\">Или</h5><div ng-if=LoginController.user.data.email class=clearfix><div class=\"alert alert-success col-xs-9\">Вы вошли как {{ LoginController.user.data.email }}</div><div class=col-xs-3><a href ng-click=logout() class=\"btn btn-danger\">Выйти</a></div></div><div class=form-group ng-class=\"(LoginController.login_form.email.$dirty || LoginController.login_form.$submitted) && LoginController.login_form.email.$invalid ? \'has-error\' : \'\'\"><label for=email class=control-label>Email</label><input type=text id=email class=form-control name=email ng-model=LoginController.requizites.email autofocus required><div class=help-block ng-show=LoginController.login_form.email.$error.email>Некорректный email</div></div><div class=form-group ng-class=\"(LoginController.login_form.password.$dirty || LoginController.login_form.$submitted) && LoginController.login_form.password.$invalid ? \'has-error\' : \'\'\"><label for=password class=control-label>Пароль</label><input type=password id=password class=form-control name=password ng-model=LoginController.requizites.password required></div><div class=row><div class=\"form-group col-sm-6 col-sm-offset-3\"><input type=submit value=Войти class=\"btn btn-block btn-success\"></div></div><div ng-if=LoginController.error><div class=\"alert alert-danger\">{{ LoginController.error }}</div></div></form></div>");
$templateCache.put("app/views/form/item.html","<div class=\"form-element {{(class ? class : \'col-sm-4 col-xs-12\')}}\" ng-class=\"(scopeformItem.$dirty || formItem.$dirty || form.$submitted) && (formItem.$invalid || scopeformItem.$invalid) ? \'has-error\' : \'\'\"><label for=\"{{(id ? id : name)}}\" class=control-label>{{title}}</label><div ng-transclude></div><div class=\"help-block m-b m-t-0\" ng-hide=helpHide><small ng-hide=\"form.$invalid && formItem.$error.server\" ng-show=helpMsg>{{helpMsg}}</small> <span ng-show=\"form.$invalid && formItem.$error.server\">{{formItem.msg}}</span> <span ng-show=\"form.$invalid && !formItem.$error.server && scopeformItem.$error.server\">{{scopeformItem.msg}}</span> <span ng-show=\"form.$invalid && formItem.$error.email\">Некорректный email</span> &nbsp;</div></div>");
$templateCache.put("app/pages/addresses/views/calibration_sensors.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">Калибровка датчиков <a ng-click=calibration.export() class=\"btn btn-sm btn-success-light\">Выгрузить список в файл</a></div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=calibration.error>{{calibration.error}}</div><div class=\"alert alert-danger\" ng-show=calibration.form.error>{{calibration.form.error}}</div><div class=well><form ng-submit=calibration.find() name=calibration.formFind novalidate><div class=row><form-element data-class=\"col-sm-4 p-b\" data-name=address_id data-title=Адрес data-help_hide=1 data-form=calibration.formFind><ui-select name=address_id ng-model=calibration.params.address_id on-select=calibration.find() required><ui-select-match placeholder=\"\" allow-clear=false remove-selected=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in calibration.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-sm-4 data-name=flat_name data-title=\"№ кв.\" data-form=calibration.formFind><input type=text name=flat_name class=form-control ng-model=calibration.params.flat_name ng-change=calibration.find()></form-element><form-element data-class=col-sm-4 data-name=counter_name data-title=\"Заводской номер прибора учета\" data-form=calibration.formFind><input type=text name=counter_name class=form-control ng-model=calibration.params.counter_name ng-change=calibration.find()></form-element><form-element data-class=col-sm-4 data-name=sensor_name data-title=\"Наименование датчика\" data-form=calibration.formFind><input type=text name=sensor_name class=form-control ng-model=calibration.params.sensor_name ng-change=calibration.find()></form-element><form-element data-class=col-sm-4 data-name=sensor_dev_eui data-title=DEV_EUI data-form=calibration.formFind><input type=text name=sensor_dev_eui class=form-control ng-model=calibration.params.sensor_dev_eui ng-change=calibration.find()></form-element><form-element data-class=col-sm-4 data-name=sensor_port data-title=Порт data-form=calibration.formFind><input type=text name=sensor_port class=form-control ng-model=calibration.params.sensor_port ng-change=calibration.find()></form-element></div><input type=submit class=hide></form></div><!--Форма --><form ng-submit=calibration.send() name=calibration.form novalidate ng-show=calibration.items><table class=\"table table-hover table-no-border\"><thead><th class=text-center>Адрес</th><th class=text-center>Прибор учета</th><th class=text-center>Текущее показание</th><th class=text-center>Новое показание</th><th></th></thead><tbody><tr ng-repeat=\"item in calibration.items\" ng-class=\"(calibration.result[item.id].success == 1 ? \'has-success\' : (calibration.result[item.id].error == 1 ? \'has-error\' : \'\'))\"><td>{{item.address}}, кв.{{item.flat}}</td><td>{{item.counter}}<br>{{item.counter_type}}</td><td class=text-center><small ng-if=\"item.value <= 1\">Некорректное значение импульсов</small> <span ng-if=\"item.value > 1\">{{item.current_value}}</span></td><td class=clearfix><form-element data-class=\"col-xs-12 p-a-0\" data-name=sensors[{{item.id}}] data-title=\"\" data-form=calibration.form ng-if=\"item.value > 1\" data-help_msg={{calibration.result[item.id].msg}}><input class=form-control type=number name=sensors[{{item.id}}] ng-model=calibration.sensors[item.id]></form-element></td><td><div class=buttons><a href target=_blank ui-sref=flats.counter({id:item.counter_id,address_id:item.address_id})><i class=\"fa fa-pencil\"></i></a></div></td></tr></tbody></table><div class=clearfix><div class=col-sm-4><ul uib-pagination total-items=calibration.cnt ng-model=calibration.page items-per-page=calibration.limit ng-change=calibration.init() force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div><div class=\"col-sm-4 col-xs-12 pull-right p-t-md\"><input type=submit value=Сохранить class=\"btn btn-success btn-block\"></div></div></form>");
$templateCache.put("app/pages/addresses/views/content.html","<!-- Заголовок --><h2>{{ addresses.title }}</h2><div class=p-t-lg><!--Таблица --><table class=\"table table-hover\"><tbody><tr ng-repeat=\"item in addresses.items\"><td><a href ui-sref=addresses.item({id:item.id})>{{item.name}}</a></td><td><div class=buttons><a href ui-sref=addresses.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=addresses.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><a href class=\"btn btn-success\" ui-sref=addresses.item>Добавить адрес</a></div>");
$templateCache.put("app/pages/addresses/views/form_item.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">Редактирование адреса</div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=address.error>{{address.error}}</div><!--Форма --><form ng-submit=address.send() name=address.form novalidate ng-show=address.item.id><div class=well><a class=h3>Общая информация</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=name data-title=Адрес data-form=address.form><input name=name id=name type=text class=form-control ng-model=address.item.name required></form-element><form-element data-class=col-xs-12 data-name=count_flats data-title=\"Количество квартир в доме\" data-form=address.form ng-hide=address.item.id><input name=count_flats id=count_flats type=number class=form-control ng-model=address.count_flats><p class=help-block>Укажите для автоматического создания кваритир</p></form-element><form-element data-class=col-xs-12 data-name=image data-title=\"Изображение карты дома\" data-form=address.form><small class=text-muted>Используется для раздела \"Управление доступом\"</small><div class=clearfix><div class=\"pull-left m-r-lg\" ng-show=address.image><img class=\"img-responsive bg-alfa\" alt={{address.currentImage.thumb}} ngf-thumbnail=address.image ngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div class=\"btn-group-xs text-right m-t\"><a href ng-click=address.deleteImage() type=button class=\"btn btn-block btn-default\" aria-label=Close><small>удалить</small></a></div></div><div class=\"pull-left m-t-lg\"><div class=\"btn btn-success-light\" name=image ng-model=address.item.image ngf-select ngf-change=\"address.preUploadImage($file, $invalidFiles)\" ngf-max-size=2MB ngf-accept=\"\'image/*\'\" ngf-pattern=\"\'image/*\'\">Загрузить изображение</div></div></div></form-element></div></div></div><input type=submit value=\"Сохранить изменения\" class=\"btn btn-success\"></form>");
$templateCache.put("app/pages/addresses/views/form_sensors.html","form_sensors.html");
$templateCache.put("app/pages/alerts/views/content.html","<h2>{{ alerts.title }}</h2><div class=p-t-lg><table class=\"table table-hover1\"><tbody><tr ng-repeat=\"item in alerts.items\"><td class=p-a-0><a ng-if=item.counter_id class=\"p-y btn-block\" ui-sref=flats.counter({id:item.counter_id,address_id:item.address_id})>{{errorList[item.error]}} {{item.message}} ({{item.name}})</a> <span ng-if=!item.counter_id class=\"p-y btn-block\">{{errorList[item.error]}} {{item.message}} ({{item.name}})</span></td></tr></tbody></table></div>");
$templateCache.put("app/pages/control/views/content.html","<!-- Заголовок --><h2>{{ control.title }}</h2><div class=\"p-t-lg row\"><uib-accordion close-others=oneAtATime class=\"col-md-10 p-x-lg\"><div uib-accordion-group class=well heading=\"\" ng-repeat=\"address in control.addresses track by $index\" is-open=control.openIndex[$index]><uib-accordion-heading><h3 class=m-a-0>{{address.item.name}}<div class=\"btn-group h5 p-b p-l\"><a href ui-sref=addresses.item({id:address.item.id}) title=\"Редактировать адрес\"><i class=\"fa fa-pencil\"></i></a></div><small><i class=\"pull-right glyphicon m-t\" ng-class=\"{\'glyphicon-menu-up\': flats.openIndex[$index], \'glyphicon-menu-down\': !flats.openIndex[$index]}\"></i></small></h3></uib-accordion-heading><div class=controll-map ng-show=address.item.image><img class=img-responsive ngf-src=address.item.image.file><div ng-repeat=\"controlMapItem in address.item.controllList track by $index\" class=h3><span class=\"label label-control label-{{controlMapItem.label ? controlMapItem.label : \'default\'}}\" style={{controlMapItem.style}}>{{$index+1}}</span></div></div><div class=\"alert alert-danger m-t-lg\" ng-show=control.error>{{control.error}}</div><div ng-show=address.item.controllList><div class=row><div class=col-sm-6 ng-repeat=\"controlItem in address.item.controllList track by $index\"><button ng-if=\"controlItem.links | inArray:\'status\'\" ng-click=\"control.sendAction(controlItem, \'toggle\')\" class=\"btn btn-info btn-block m-y-md p-x-0 {{!controlItem.label || controlItem.label == \'default\' ? \'disabled\' : \'\'}}\"><span class=\"label label-control label-{{controlItem.label ? controlItem.label : \'default\'}}\">{{$index+1}}</span>&nbsp; <span class=h6>{{controlItem.name}}</span></button> <button ng-if=\"!(controlItem.links | inArray:\'status\') && (controlItem.links | inArray:\'send\')\" ng-click=\"control.sendAction(controlItem, \'send\')\" class=\"btn btn-info btn-block m-y-md p-x-0\"><span class=\"label label-control label-white\">{{$index+1}}</span>&nbsp; <span class=h6>{{controlItem.name}}</span></button></div></div></div><hr><div class=col-md-10><ul class=list-inline><li><span class=\"label label-control label-success\">&nbsp;</span> Открыто</li><li><span class=\"label label-control label-danger\">&nbsp;</span> Закрыто</li></ul></div></div></uib-accordion></div>");
$templateCache.put("app/pages/control/views/content_simple.html","<update-title title={{control.metaTitle}}></update-title><div class=container><h3>{{ control.title }}</h3><div class=row><div class=col-xs-12 ng-show=control.error><div class=\"alert alert-danger\">{{control.error}}</div></div><div class=\"col-md-9 col-xs-12\"><div class=row><div class=col-xs-6 ng-repeat=\"controlItem in control.controllList track by $index\"><button class=\"btn btn-block m-y-md p-x-0 {{ controlItem.class }} {{!controlItem.label || controlItem.label == \'default\' ? \'disabled\' : \'\'}}\" ng-if=\"controlItem.links | inArray:\'status\'\" ng-click=\"control.sendAction(controlItem, \'toggle\')\"><div class=\"h2 m-t-0 m-b-md text-{{controlItem.label ? controlItem.label : \'default\'}}\"><span class={{controlItem.icon}}></span></div><div ng-bind-html=controlItem.name></div></button> <button ng-click=\"control.sendAction(controlItem, \'send\')\" class=\"btn {{ controlItem.class }} btn-block m-y-md p-x-0\" ng-if=\"!(controlItem.links | inArray:\'status\') && (controlItem.links | inArray:\'send\')\"><div class=\"h2 m-t-0 m-b-md text-white\"><span class={{controlItem.icon}}></span></div><div ng-bind-html=controlItem.name></div></button></div></div></div></div></div>");
$templateCache.put("app/pages/counter_stats/views/content.html","<!-- Заголовок --><h2>{{ counter_stats.title }}</h2><div class=p-t-lg><div class=well><form ng-submit=counter_stats.find() name=counter_stats.formFind novalidate><div class=row><div class=\"col-sm-4 row\"><form-element data-class=col-xs-12 data-name=flat_name data-title=\"Дата сдачи показаний\" data-help_hide=1 data-form=counter_stats.formFind><div class=clearfix><div class=\"col-xs-2 p-x-0 p-t-md\">с</div><datepicker class=\"col-xs-10 p-x-0\" date-format=yyyy-MM-dd><input type=text name=date_start class=form-control ng-model=counter_stats.date_start ng-change=counter_stats.find()></datepicker></div></form-element><form-element data-class=\"col-xs-12 p-t-md\" data-name=date_end data-title=\"\" data-help_hide=1 data-form=counter_stats.formFind><div class=clearfix><div class=\"col-xs-2 p-x-0 p-t-md\">по</div><datepicker class=\"col-xs-10 p-x-0\" date-format=yyyy-MM-dd><input type=text name=date_end class=form-control ng-model=counter_stats.date_end ng-change=counter_stats.find()></datepicker></div></form-element></div><form-element data-class=\"col-sm-4 p-b\" data-name=address_id data-title=Адрес data-help_hide=1 data-form=counter_stats.formFind><ui-select name=address_id ng-model=counter_stats.address_id on-select=counter_stats.find() required><ui-select-match placeholder=\"\" allow-clear=false remove-selected=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in counter_stats.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=\"col-sm-4 p-b\" data-name=type_id data-title=\"Вид показаний\" data-help_hide=1 data-form=counter_stats.formFind><ui-select name=type_id ng-model=counter_stats.type_id on-select=counter_stats.find() required><ui-select-match placeholder=\"\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in counter_stats.types | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-sm-4 data-name=flat_name data-title=\"№ кв.\" data-help_hide=1 data-form=counter_stats.formFind><input type=text name=flat_name class=form-control ng-model=counter_stats.flat_name ng-change=counter_stats.find()></form-element><!-- <form-element data-class=\"col-sm-4\" data-name=\"status_id\" data-title=\"Статус\" data-help_hide=\"1\" data-form=\"counter_stats.formFind\">\n          <ui-select name=\"status_id\" ng-model=\"counter_stats.status_id\" on-select=\"counter_stats.find()\" required>\n            <ui-select-match placeholder=\"\" allow-clear=\"true\">\n              <span ng-bind=\"$select.selected.name\"></span>\n            </ui-select-match>\n            <ui-select-choices repeat=\"item.id as item in counter_stats.statuses | filter: $select.search\">\n              <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n            </ui-select-choices>\n          </ui-select>\n        </form-element> --></div><input type=submit class=hide></form></div><div class=\"alert alert-danger\" ng-show=counter_stats.error>{{counter_stats.error}}</div><div class=\"p-x-lg table-wrap\"><table class=\"table table-hover table-no-border table-condensed\" ng-show=counter_stats.totalList><thead><tr><th colspan=2 class=\"h5 text-center\">Общедомовые показатели</th></tr><tr class=text-center><th>Вид показаний</th><th class=text-right>Показание</th></tr></thead><tbody><tr ng-repeat=\"item in counter_stats.totalList\"><td>{{item.name}}</td><td class=text-right>{{item.sum | number}}</td></tr></tbody></table><table class=\"table table-hover table-condensed\" ng-show=counter_stats.stats><thead><tr><th colspan=7 class=\"h5 text-center\">Статистика показаний</th></tr><tr class=text-center><th class=text-center>№ квартиры</th><th class=text-center>Вид показаний</th><th class=\"text-center hidden-xs\">Заводской номер</th><th class=\"text-center hidden-xs\">Дата поверки</th><th class=\"text-center hidden-xs\">Дата сдачи показаний</th><th class=\"text-center visible-xs\">Дата<br>Показание</th><th class=\"text-center hidden-xs\">Показание</th><th class=\"text-center hidden-xs\">Ед. изм.</th><!-- <th class=\"text-center hidden-xs\">Статус</th> --></tr></thead><tbody ng-repeat=\"item in counter_stats.stats\"><tr ng-if=!item.stats class=bg-warning><td class=text-center>{{item.flat}}</td><td class=text-nowrap><div ng-if=item.counter_id>{{item.counter_type}}</div><div ng-if=!item.counter_id class=\"small text-center\">нет приборов учета</div></td><td class=\"text-center hidden-xs\">{{item.counter_name}}</td><td class=\"text-center hidden-xs\">{{item.calibration | date:\'dd.MM.yyyy\'}}</td><td class=\"text-center small hidden-xs\" colspan=4>нет показаний</td><td class=\"text-center small visible-xs\">нет показаний</td></tr><tr ng-repeat=\"statItem in item.stats\" ng-class=\"{\'bg-danger\':statItem.error}\" uib-tooltip={{errorList[statItem.error]}}><td class=text-center>{{item.flat}}</td><td class=text-nowrap>{{item.counter_type}}</td><td class=\"text-center hidden-xs\">{{item.counter_name}}</td><td class=\"text-center hidden-xs\">{{item.calibration | date:\'dd.MM.yyyy\'}}</td><td class=text-center>{{statItem.create_date | date:\'dd.MM.yyyy\'}}<div class=visible-xs>{{statItem.value | number}} {{statItem.unit}}</div></td><td class=\"text-right hidden-xs\">{{statItem.value | number}}</td><td class=\"text-center hidden-xs\">{{statItem.unit}}</td><!-- <td class=\"text-center hidden-xs\">{{statItem.status}}</td> --></tr></tbody></table><ul ng-show=counter_stats.stats uib-pagination total-items=counter_stats.cnt_stats ng-model=counter_stats.page items-per-page=counter_stats.limit ng-change=counter_stats.initStats() force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div></div>");
$templateCache.put("app/pages/feedback/views/content.html","<h2>Вопрос-ответ</h2><div class=\"well m-t-lg\"><div class=\"alert alert-danger\" ng-show=feedback.error>{{feedback.error}}</div><table class=\"table table-hover table-condensed\"><thead><tr><th></th><th class=text-center>ID / Дата</th><th class=text-center>Адрес</th><th>Вопрос</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in feedback.items\" ng-class=\"{\'active\':!item.read_company}\"><td ui-sref=feedback.item({id:item.id}) role=button width=20px class=\"valign-top text-success text-center h6\"><span class=\"fa fa-check\" uib-tooltip=\"Вопрос опубликован на сайте\" ng-show=item.publish></span></td><td ui-sref=feedback.item({id:item.id}) role=button width=120px class=\"valign-top text-center\"><span class=h6>#{{item.id}}</span><br><small class=text-muted>{{item.created_at | date:\'dd.MM.yyyy HH:mm\'}}</small></td><td ui-sref=feedback.item({id:item.id}) role=button class=\"valign-top text-center\">{{item.address.name}}, кв. {{item.flat.name}}</td><td class=valign-top><div class=text-danger ng-show=item.deleted_flat>Вопрос удален из личного кабинета квартиры</div><div ui-sref=feedback.item({id:item.id}) role=button>{{item.question}}</div><div ng-show=item.answer><a href ng-click=\"item.answerShow = !item.answerShow\">Ответ <small class=text-muted>{{item.updated_at | date:\'dd.MM.yyyy HH:mm\'}}</small> <span class=h4><span class=\"fa fa-angle-up valign-middle\" ng-show=item.answerShow></span> <span class=\"fa fa-angle-down valign-middle\" ng-show=!item.answerShow></span></span></a><div uib-collapse=!item.answerShow class=well>{{item.answer}}</div></div></td><td class=valign-top><div class=buttons><a href ui-sref=feedback.item({id:item.id})><span class=\"fa fa-pencil\" uib-tooltip=Редактировать></span></a> <a href ng-click=feedback.delete(item)><span class=\"fa fa-remove\" uib-tooltip=Удалить></span></a></div></td></tr></tbody></table><ul uib-pagination total-items=feedback.cnt_items ng-model=feedback.page items-per-page=feedback.limit ng-change=feedback.init($index) force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div>");
$templateCache.put("app/pages/feedback/views/form_feedback.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=feedback.item.id>Ответ на вопрос</span></div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=feedback.error>{{feedback.error}}</div><div class=\"alert alert-danger\" ng-show=feedback.form.error>{{feedback.form.error}}</div><form ng-submit=feedback.send() name=feedback.form novalidate ng-show=\"!feedback.error && feedback.item.id\"><div class=well><div class=p-b-lg><div class=\"p-b-lg clearfix\"><div class=pull-left><span class=h4>Вопрос #{{feedback.item.id}}</span> <span class=text-muted>{{feedback.item.updated_at | date:\'dd.MM.yyyy HH:mm\'}}</span></div><div class=\"pull-right text-success\" ng-show=feedback.item.publish>Опубликован на сайте</div></div></div><p>{{feedback.item.question}}</p><span class=h4>Ответ</span><div class=row><form-element data-class=col-sm-9 data-name=answer data-title=\"\" data-form=feedback.form><textarea name=answer rows=8 id=answer class=form-control ng-model=feedback.item.answer required></textarea></form-element><form-element data-class=col-sm-12 data-name=publish data-title=\"\" data-form=feedback.form><label class=\"control-label m-a-0\"><input name=publish id=publish type=checkbox ng-model=feedback.item.publish> <span>Опубликовать на сайте</span></label></form-element></div></div><input type=submit value=\"Сохранить и отправить на email\" class=\"btn btn-success pull-left\"></form>");
$templateCache.put("app/pages/flats/views/content.html","<h2>{{ flats.title }}</h2><div class=p-t-lg><div class=well><form ng-submit=flats.initFlats() name=flats.formFind novalidate><div class=row><form-element data-class=\"col-sm-12 p-b\" data-name=address_id data-title=Адрес data-help_hide=1 data-form=\"\"><ui-select name=address_id ng-model=flats.findParams.address_id on-select=flats.initFlats() required><ui-select-match placeholder=\"\" allow-clear=false remove-selected=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in flats.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=\"col-sm-3 col-xs-12\" data-name=name data-title=\"\" data-help_hide=1 data-form=flats.formFind><input class=form-control ng-model=flats.findParams.name ng-change=flats.initFlats() placeholder=\"№ кв.\"></form-element><form-element data-class=\"col-sm-3 col-xs-12\" data-name=contact_face data-title=\"\" data-help_hide=1 data-form=flats.formFind><input class=form-control ng-model=flats.findParams.contact_face ng-change=flats.initFlats() placeholder=\"Контактное лицо\"></form-element><form-element data-class=\"col-sm-3 col-xs-12\" data-name=phone data-title=\"\" data-help_hide=1 data-form=flats.formFind><input class=form-control ng-model=flats.findParams.phone ng-change=flats.initFlats() placeholder=Телефон></form-element><form-element data-class=\"col-sm-3 col-xs-12\" data-name=email data-title=\"\" data-help_hide=1 data-form=flats.formFind><input class=form-control ng-model=flats.findParams.email ng-change=flats.initFlats() placeholder=Email></form-element></div><input type=submit class=hide></form></div><h3 class=m-a-0>{{flats.address.name}}<div class=\"btn-group h5 p-b p-l\"><a class=m-r href ui-sref=addresses.item({id:flats.address.id}) title=\"Редактировать адрес\"><i class=\"fa fa-pencil\"></i></a> <a class=m-r href ui-sref=reestr({address_id:flats.address.id}) title=\"Реестр жильцов\"><i class=\"fa fa-table\"></i></a> <a href ui-sref=addresses.sensors.calibration({address_id:flats.address.id}) title=\"Калибровка датчиков\"><i class=\"fa fa-cogs\"></i></a></div></h3><table class=\"table table-hover table-no-border\"><tbody><tr ng-repeat=\"item in flats.address.flats\"><td role=button ui-sref=flats.item({id:item.id}) class=text-center>{{item.name}}</td><td role=button ui-sref=flats.item({id:item.id})><div ng-repeat=\"owner in item.owners\">{{owner.contacts.name}}</div></td><td class=hidden-xs role=button ui-sref=flats.item({id:item.id})><div ng-repeat=\"owner in item.owners\">{{owner.contacts.phone}}</div></td><td class=hidden-xs role=button ui-sref=flats.item({id:item.id})><div ng-repeat=\"owner in item.owners\">{{owner.login}}</div></td><td><div class=buttons><a href ui-sref=flats.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=flats.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div class=col-sm-6><ul uib-pagination total-items=flats.address.cnt_flats ng-model=flats.page items-per-page=flats.findParams.limit ng-change=flats.initFlats() force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div><div class=\"col-sm-6 text-right p-t-lg\"><a href ui-sref=flats.item({address_id:address.item.id}) class=\"btn btn-sm btn-success\">Добавить квартиру</a></div></div></div>");
$templateCache.put("app/pages/flats/views/form_counter.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=counter.item.id>Редактирование счетчика</span> <span ng-hide=counter.item.id>Добавление счетчика</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=counter.error>{{counter.error}}</div><div class=\"alert alert-danger\" ng-show=counter.form.error>{{counter.form.error}}</div><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true ng-show=counter.item.flat_id><form ng-submit=counter.send() name=counter.form novalidate><div class=well><a class=h3>Общая информация</a><div class=p-t-lg><div class=row><form-element data-name=name data-title=\"Заводской номер\" data-form=counter.form><input name=name id=name type=text class=form-control ng-model=counter.item.name required></form-element><form-element data-name=calibration data-title=\"Дата поверки\" data-form=counter.form><datepicker date-format=dd.MM.yyyy><input name=calibration id=calibration type=text class=form-control ng-model=counter.item.calibration></datepicker></form-element><form-element data-name=type_id data-title=\"Тип счетчика\" data-form=counter.form><ui-select name=type_id ng-model=counter.item.type_id required><ui-select-match placeholder=\"Выберите тип\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in counter.types | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element></div><div class=row><form-element data-name=model_id data-title=\"Модель счетчика\" data-form=counter.form><ui-select name=model_id ng-model=counter.item.model_id><ui-select-match placeholder=\"Выберите модель\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in counter.models | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=dev_eui data-title=\"DEV_EUI модема\" data-form=counter.form><input name=dev_eui id=dev_eui type=text class=form-control ng-model=counter.item.dev_eui></form-element><form-element data-name=port_num data-title=\"Номер порта\" data-form=counter.form><input name=port_num id=port_num type=number class=form-control ng-model=counter.item.port_num></form-element><form-element ng-if=\"counter.item.type_value == \'value\'\" data-name=current_value data-title=\"Текущее показание\" data-form=counter.formCalibration><div class=row><div class=\"col-sm-9 col-xs-12\"><h5 class=m-t>{{counter.item.current_value | number}} {{counter.item.unit}}</h5><div ng-show=\"counter.item.status != -1\" ng-init=counter.setStatusSensor()><small>обновлено {{counter.item.status_date | date:\'dd.MM.yyyy HH:mm:ss\'}}</small></div><div ng-show=\"counter.item.status == -1\" class=\"label label-default\">{{counter.item.status_desc}}</div></div><div class=\"col-sm-3 col-xs-12\"><a href ng-click=counter.setStatusSensor() class=\"btn btn-sm btn-success-light\"><span class=\"glyphicon glyphicon-refresh\"></span></a></div></div></form-element></div></div><div class=row><div class=col-sm-4><input type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\" ng-show=counter.item.id> <input type=submit ng-hide=counter.item.id value=Создать class=\"btn btn-block btn-success\"></div></div></div></form><form ng-if=\"counter.item.type_value == \'impulse\'\" ng-submit=counter.sendCalibration() name=counter.formCalibration ng-show=counter.item.sensor_id novalidate><div class=well><a class=h3>Калибровка показаний</a><div class=p-t-lg><div class=row><form-element data-class=\"col-sm-3 col-xs-12\" data-name=new_value data-title=\"Новое показание\" data-form=counter.formCalibration><input name=new_value id=new_value type=number class=form-control ng-model=counter.item.new_value required></form-element><form-element data-class=\"col-sm-3 col-xs-12\" data-name=current_value data-title=\"Текущее показание\" data-form=counter.formCalibration><h5 class=m-t>{{counter.item.current_value | number}} {{counter.item.unit}}</h5></form-element><form-element data-class=col-sm-6 ng-show=counter.item.sensor_id data-name=\"\" data-title=\"К-во импульсов\"><div class=row><div class=\"col-sm-9 col-xs-12\"><div ng-show=\"counter.item.status != -1\"><h5 class=m-t ng-init=counter.setStatusSensor()>{{counter.item.value}} <small>обновлено {{counter.item.status_date | date:\'dd.MM.yyyy HH:mm:ss\'}}</small></h5></div><div ng-show=\"counter.item.status == -1\" class=\"label label-default\">{{counter.item.status_desc}}</div></div><div class=\"col-sm-3 col-xs-12\"><a href ng-click=counter.setStatusSensor() class=\"btn btn-sm btn-success-light\"><span class=\"glyphicon glyphicon-refresh\"></span></a></div></div></form-element></div><div class=row><div class=col-sm-4><input type=submit value=Калибровать class=\"btn btn-block btn-success\"></div></div></div></div></form></div>");
$templateCache.put("app/pages/flats/views/form_flat.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=flat.item.id>Редактирование квартиры</span> <span ng-hide=flat.item.id>Добавление квартиры</span></div><div class=\"text-right text-nowrap\"><a href ui-sref=flats({address_id:flat.item.address_id})><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=flat.form.error>{{flat.form.error}}</div><div class=\"alert alert-danger\" ng-show=flat.error>{{flat.error}}</div><uib-tabset class=uib-tabset-menu active=flat.indexTab justified=true><uib-tab index=0 ng-click=flat.setIndex(0) heading=\"Общая информация\"><form ng-submit=flat.send() name=flat.form novalidate><div><div class=p-t-lg><div class=row><form-element data-name=login data-title=\"№ счета\" data-form=flat.form><input name=login id=login type=login class=form-control ng-model=flat.item.login required></form-element><form-element data-name=address_id data-title=Адрес data-form=flat.form><ui-select name=address_id ng-model=flat.item.address_id required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in flat.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=name data-title=\"№ квартиры\" data-form=flat.form><input name=name id=name type=number class=form-control ng-model=flat.item.name required></form-element></div><div class=row><form-element data-class=col-sm-8 data-name=comment data-title=\"Дополнительная информация\" data-form=flat.comment><textarea class=form-control rows=4 name=comment ng-model=flat.item.comment></textarea></form-element></div><div class=\"row m-t-lg\" ng-show=flat.item.id><div class=col-sm-4><input type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div></div></div></div><input type=submit ng-hide=flat.item.id value=Создать class=\"btn btn-success\"></form></uib-tab><uib-tab index=1 ng-click=flat.setIndex(1) heading=Счетчики ng-if=flat.item.id><div class=p-t-lg ng-controller=\"CountersController as counters\"><table class=\"table table-hover\" ng-show=counters.listCounters><thead><tr><th>Вид показаний</th><th>Заводской номер</th><th>Дата поверки</th><th></th></tr></thead><tbody><tr ng-repeat=\"counter in counters.listCounters\"><td role=button ui-sref=flats.counter({id:counter.id,address_id:flat.item.address_id})>{{counter.type}}</td><td role=button ui-sref=flats.counter({id:counter.id,address_id:flat.item.address_id})>{{counter.name}}</td><td role=button ui-sref=flats.counter({id:counter.id,address_id:flat.item.address_id})>{{counter.calibration | date:\'dd.MM.yyyy\'}}</td><td><div class=buttons><a href ui-sref=flats.counter({id:counter.id,address_id:flat.item.address_id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=counters.delete(counter)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div class=col-sm-4><a href ui-sref=flats.counter({flat_id:flat.item.id,address_id:flat.item.address_id}) class=\"btn btn-block btn-success-light\">Добавить счетчик</a></div></div></div></uib-tab><uib-tab index=2 ng-click=flat.setIndex(2) heading=\"Список собственников\" ng-if=flat.item.id><table class=\"table table-hover table-no-border table-condensed table-reestr\"><thead><tr><th>Кв.</th><th>Телефон</th><th>ЕГРН</th><th>Сведения о правообладателе</th><th>Тип объекта</th><th class=text-center>Назначение объекта</th><th class=text-center>Площадь, м2</th><th class=text-center>Кол-во долей</th><th class=text-center>Всего долей</th><th>Документ о праве собственности</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in flat.item.owners\"><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.flat}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.contacts.phone}}</td><td class=text-center><a ng-if=item.reestr.egrn href={{item.reestr.egrn}} target=_blank><span class=\"fa fa-search\"></span></a></td><td role=button ui-sref=reestr.item({id:item.id})>{{item.contacts.name}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.reestr.type}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.function}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.area}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.part}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.part_all}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.reestr.type_registr}}, № {{item.reestr.num_registr}} от {{item.reestr.date_registr}}</td><td><div class=buttons><a href ui-sref=reestr.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=flat.deleteOwner(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div class=col-sm-4><a href ui-sref=\"reestr.item({address_id:flat.item.address_id, flat_id:flat.item.id})\" class=\"btn btn-block btn-success-light\">Добавить собственника</a></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/pages/flats/views/form_import.html","");
$templateCache.put("app/pages/main/views/content.html","<h2>{{user.data.company.name}}</h2><div class=p-t-lg><div class=row><div class=col-xs-12><div class=\"panel panel-default\"><div class=\"panel-body clearfix\"><div class=\"col-sm-8 p-l-0\"><h5>Вы вошли как, {{ user.data.name }} ({{ user.data.email }})</h5></div><div class=\"col-sm-4 text-right\"><a href ui-sref=workers.item({id:user.data.id}) class=\"btn btn-success\"><span>Сменить пароль</span></a></div></div></div></div><div class=col-xs-12><div class=\"panel panel-default\"><div class=\"panel-body clearfix\"><table class=\"table table-no-border\"><thead><tr><td colspan=2><h3 class=m-a-0>Общая информация</h3></td></tr></thead><tbody><tr><td>Название организации</td><td><strong>{{user.data.company.name}}</strong></td></tr><tr><td>Контактное лицо</td><td><strong>{{user.data.company.contact_face}}</strong></td></tr><tr><td>Телефон для уведомлений</td><td><strong>{{user.data.company.phone}}</strong></td></tr><tr><td>E-mail для уведомлений</td><td><strong>{{user.data.company.email}}</strong></td></tr><tr><td>ИНН</td><td><strong>{{user.data.company.inn}}</strong></td></tr><tr><td>Р.счет</td><td><strong>{{user.data.company.rs_num}}</strong></td></tr><tr><td>Кор.счет</td><td><strong>{{user.data.company.ks_num}}</strong></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/pages/messages/views/content.html","<!-- Заголовок --><h2>{{ messages.title }}</h2><div class=p-t-lg><!--Таблица --><table class=\"table table-hover\"><thead><tr><th>Дата</th><th>Адрес</th><th>Сообщение</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in messages.items\"><td ui-sref=messages.item({id:item.id}) role=button>{{item.create_date | date:\'dd.MM.yyyy HH:mm\'}}</td><td ui-sref=messages.item({id:item.id}) role=button>{{item.address}} {{item.flat ? \', кв. \'+item.flat : \'\'}}</td><td ui-sref=messages.item({id:item.id}) role=button>{{item.message}}</td><td><div class=buttons><a href ui-sref=messages.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=messages.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><a href class=\"btn btn-success\" ui-sref=messages.item>Добавить уведомление</a></div>");
$templateCache.put("app/pages/messages/views/form_message.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=message.item.id>Редактирование уведомления</span> <span ng-hide=message.item.id>Добавление уведомления</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=\"alert alert-danger\" ng-show=message.error>{{message.error}}</div><div class=\"alert alert-danger\" ng-show=message.form.error>{{message.form.error}}</div><form ng-submit=message.send() name=message.form novalidate ng-show=!message.error><div class=\"alert alert-warning\">Варианты уведомлений:<ol><li>Отправка по адресу (уведомление получат все жильцы дома)</li><li>Отправка по квартире (уведомление получат только жильцы указанной квартиры)</li></ol></div><div class=well><div class=row><form-element data-name=address_id data-title=Адрес data-form=message.form><ui-select name=address_id ng-model=message.item.address_id on-select=message.initFlats() required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in message.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=flat_id data-title=Квартира data-form=message.form><ui-select name=flat_id ng-model=message.item.flat_id><ui-select-match placeholder=\"Выберите квартиру\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in message.flats | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-sm-8 data-name=message data-title=Сообщение data-form=message.form><textarea name=message rows=8 id=message class=form-control ng-model=message.item.message required></textarea></form-element></div></div><input ng-hide=message.item.id type=submit value=\"Создать и отправить на email\" class=\"btn btn-success\"> <input ng-show=message.item.id type=submit value=\"Сохранить и отправить на email\" class=\"btn btn-success\"></form><div class=\"alert alert-info m-t-lg\" ng-show=message.mailStats><h4>Процесс отправки уведомления на email</h4><p ng-repeat=\"item in message.mailStats\">кв. {{item.name}} ({{item.email}}) - {{item.statusSend}}</p></div>");
$templateCache.put("app/pages/reestr/views/content.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ reestr.title }}</div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=p-t-lg><div class=well><form ng-submit=reestr.initReestr() name=reestr.formFind novalidate><div class=row><form-element data-class=\"col-sm-12 p-b\" data-name=address_id data-title=Адрес data-help_hide=1 data-form=\"\"><ui-select name=address_id ng-model=reestr.findParams.address_id on-select=reestr.initReestr() required><ui-select-match placeholder=\"\" allow-clear=false remove-selected=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element></div><input type=submit class=hide></form></div><table class=\"table table-hover table-no-border table-condensed table-reestr\"><thead><tr><th>Кв.</th><th>Телефон</th><th>ЕГРН</th><th>Сведения о правообладателе</th><th>Тип объекта</th><th class=text-center>Назначение объекта</th><th class=text-center>Площадь, м2</th><th class=text-center>Кол-во долей</th><th class=text-center>Всего долей</th><th>Документ о праве собственности</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in reestr.items\"><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.flat}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.contacts.phone}}</td><td class=text-center><a ng-if=item.reestr.egrn href={{item.reestr.egrn}} target=_blank><span class=\"fa fa-search\"></span></a></td><td role=button ui-sref=reestr.item({id:item.id})>{{item.contacts.name}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.reestr.type}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.function}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.area}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.part}}</td><td role=button ui-sref=reestr.item({id:item.id}) class=text-center>{{item.reestr.part_all}}</td><td role=button ui-sref=reestr.item({id:item.id})>{{item.reestr.type_registr}}, № {{item.reestr.num_registr}} от {{item.reestr.date_registr}}</td><td><div class=buttons><a href ui-sref=reestr.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=reestr.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div class=col-sm-6><ul uib-pagination total-items=reestr.cntItems ng-model=reestr.page items-per-page=reestr.findParams.limit ng-change=reestr.initReestr() force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div><div class=\"col-sm-6 text-right p-t-lg\"><a href ui-sref=reestr.item({address_id:reestr.findParams.address_id}) class=\"btn btn-sm btn-success\">Добавить собственника</a></div></div></div>");
$templateCache.put("app/pages/reestr/views/form_item.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=reestr.item.id>Редактирование собственника</span> <span ng-hide=reestr.item.id>Добавление собственника</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=reestr.form.error>{{reestr.form.error}} <button type=button class=close data-dismiss=alert aria-label=Close><span aria-hidden=true ng-click=\"reestr.form.error = \'\'\">&times;</span></button></div><div class=\"alert alert-danger\" ng-show=reestr.error>{{reestr.error}}</div><uib-tabset class=uib-tabset-menu active=reestr.indexTab justified=false><uib-tab index=0 ng-click=reestr.setIndex(0) heading=\"Общая информация\"><form ng-submit=reestr.send() name=reestr.form novalidate><div class=p-t-lg><div class=row><form-element data-name=login data-title=E-mail data-form=reestr.form><input name=login id=login type=login class=form-control placeholder=info@profintel.ru ng-model=reestr.item.login required></form-element><form-element data-id=address_id data-name=address_id data-title=Адрес data-form=reestr.form data-form-item=reestr.form.address_id><ui-select name=address_id ng-model=reestr.item.address_id on-select=reestr.loadFlats() required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=flat_id data-title=\"№ квартиры\" data-form=reestr.form data-form-item=reestr.form.flat_id><ui-select name=flat_id ng-model=reestr.item.flat_id ng-disabled=!reestr.flats.length required><ui-select-match placeholder=\"Выберите квартиру\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.flats | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element></div><div class=row><form-element data-name=contact_face data-title=ФИО data-form=reestr.form><input name=contact_face id=contact_face type=text class=form-control ng-model=reestr.item.contacts.name required></form-element><form-element data-name=phone data-title=Телефон data-form=reestr.form><input name=phone mask=+99999999999 id=phone type=text class=form-control ng-model=reestr.item.contacts.phone></form-element><form-element data-name=passport data-title=Паспорт data-form=reestr.form><input name=passport id=passport type=text class=form-control ng-model=reestr.item.contacts.passport></form-element></div><div class=row ng-if=!reestr.item.id><form-element data-name=password data-title=Пароль data-form=reestr.form><input name=password id=password type=text class=form-control ng-model=reestr.password ng-required=!reestr.item.password></form-element><form-element data-class=\"col-sm-4 password-block\" data-name=re_password data-title=\"Повтор пароля\" data-form=reestr.form><input name=re_password id=re_password type=text class=form-control ng-model=reestr.re_password ng-required=!reestr.item.password></form-element><div class=\"col-sm-4 m-t p-t-lg\"><a href ng-click=reestr.generatePassword() class=\"btn btn-block btn-success-light\">Сгенерировать пароль</a></div></div><div class=row><form-element data-name=type data-title=\"Тип объекта\" data-form=reestr.form><ui-select name=type ng-model=reestr.item.reestr.type><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.reestrParams.type | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=function data-title=\"Назначение объекта\" data-form=reestr.form><ui-select name=function ng-model=reestr.item.reestr.function><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.reestrParams.function | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=area data-title=\"Площадь, м2\" data-form=reestr.form><input type=number name=area id=area class=form-control ng-model=reestr.item.reestr.area></form-element></div><div class=row><form-element data-name=part data-title=\"Кол-во долей\" data-form=reestr.form><input name=part id=part class=form-control ng-model=reestr.item.reestr.part></form-element><form-element data-name=part_all data-title=\"Всего долей\" data-form=reestr.form><input name=part_all id=part_all class=form-control ng-model=reestr.item.reestr.part_all></form-element><form-element data-name=num_votes data-title=\"Кол-во голосов\" data-form=reestr.form><input type=number name=num_votes id=num_votes class=form-control ng-model=reestr.item.num_votes required></form-element></div><div class=row><form-element data-name=type_registr data-title=\"Вид государственной регистрации\" data-form=reestr.form><ui-select name=type_registr ng-model=reestr.item.reestr.type_registr><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in reestr.reestrParams.type_registr | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=num_registr data-title=\"Номер государственной регистрации\" data-form=reestr.form><input name=num_registr id=num_registr class=form-control ng-model=reestr.item.reestr.num_registr required></form-element><form-element data-name=date_registr data-title=\"Дата государственной регистрации\" data-form=reestr.form><datepicker date-format=dd.MM.yyyy><input type=text name=date_registr class=form-control ng-model=reestr.item.reestr.date_registr autocomplete=off></datepicker></form-element><form-element data-class=col-xs-12 data-name=egrn data-title=ЕГРН data-form=reestr.form><div class=text-overflow><a href={{reestr.item.reestr.egrn}} target=_blank>{{reestr.item.reestr.egrn}}</a></div><div>{{reestr.preEgrn.name}}</div><div class=\"btn btn-xs btn-success-light\" name=egrn ng-model=reestr.preEgrn ngf-select ngf-max-size=2MB>Загрузить файл</div></form-element></div></div><div class=\"row m-t-lg\"><div class=\"col-sm-4 col-xs-12\"><input ng-if=!reestr.item.id type=submit value=Создать class=\"btn btn-block btn-success\"> <input ng-if=reestr.item.id type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div></div></form></uib-tab><uib-tab index=2 ng-click=reestr.setIndex(2) heading=Реквизиты ng-if=reestr.item.id><form ng-submit=reestr.changePass() name=reestr.formPass novalidate><div class=\"clearfix m-b-lg\"><div class=\"pull-left p-r-lg h3\">Логин:</div><div class=\"pull-left h3\">{{reestr.item.login}}</div></div><div><a class=h3>Сменить пароль</a><div class=p-t-lg><div class=row><form-element data-class=\"col-sm-4 password-block\" data-id=changePassword data-name=password data-title=Пароль data-form=reestr.formPass><input name=password id=changePassword type=text class=form-control ng-model=reestr.password required></form-element><form-element data-class=\"col-sm-4 password-block\" data-name=re_password data-id=re_changePassword data-title=\"Повтор пароля\" data-form=reestr.formPass><input name=re_password id=re_changePassword type=text class=form-control ng-model=reestr.re_password required></form-element><div class=\"col-sm-4 m-t p-t-lg\"><a href ng-click=reestr.generatePassword() class=\"btn btn-block btn-success-light\">Сгенерировать пароль</a></div></div><div class=\"row m-t-lg\"><div class=\"col-lg-4 col-md-7 col-sm-8\"><input type=submit value=\"Сменить пароль и отправить по email\" class=\"btn btn-block btn-success\"></div></div></div></div></form></uib-tab></uib-tabset>");
$templateCache.put("app/pages/sensors/views/content.html","<h2>{{ sensor.title }}</h2><div class=\"p-t-lg row\"><uib-accordion close-others=oneAtATime class=\"col-md-10 p-x-lg\"><div uib-accordion-group class=well heading=\"\" ng-repeat=\"address in sensor.addresses track by $index\" is-open=sensor.openIndex[$index]><uib-accordion-heading><h3 class=m-a-0>{{address.name}}<div class=\"btn-group h5 p-b p-l\"><a href ui-sref=addresses.item({id:address.id}) title=\"Редактировать адрес\"><i class=\"fa fa-pencil\"></i></a></div><small><i class=\"pull-right glyphicon m-t\" ng-class=\"{\'glyphicon-menu-up\': sensor.openIndex[$index], \'glyphicon-menu-down\': !sensor.openIndex[$index]}\"></i></small></h3></uib-accordion-heading><div class=\"alert alert-danger m-t-lg\" ng-show=sensor.error>{{sensor.error}}</div><!--Таблица --><table class=\"table table-hover\" ng-show=address.sensorsList><thead><tr><th class=text-center>Статус</th><th class=text-center>Наименование</th><th class=text-center>Ответственный сотрудник</th><th class=text-center>Оповещение о тревоге</th><th class=text-center></th></tr></thead><tbody><tr ng-repeat=\"sensor in address.sensorsList track by $index\"><td role=button ui-sref=sensors.item({id:sensor.id}) ng-show=\"sensor.status != -1\"><div class=\"label label-control m-r-md p-a-0 pull-left\" ng-class=\"sensor.status == sensor.status_good ? \'label-success\' : \'label-danger\'\">&nbsp;</div></td><td role=button ui-sref=sensors.item({id:sensor.id}) ng-show=\"sensor.status != -1\">{{sensor.name}}<br><small class=text-muted>обновлено {{sensor.status_date | date:\'dd.MM.yyyy HH:mm:ss\'}}</small></td><td role=button ui-sref=sensors.item({id:sensor.id}) ng-show=\"sensor.status == -1\"><div class=\"label label-control label-default m-r-md p-a-0 pull-left\">&nbsp;</div></td><td role=button ui-sref=sensors.item({id:sensor.id}) ng-show=\"sensor.status == -1\"><div class=pull-left>{{sensor.name}}<br><small class=text-muted>{{sensor.status_desc}}</small></div></td><td role=button ui-sref=sensors.item({id:sensor.id}) class=text-center>{{sensor.worker}}</td><td role=button ui-sref=sensors.item({id:sensor.id}) class=text-center><i class=\"fa fa-check text-success\" ng-if=sensor.active_alert></i></td><td><div class=buttons><a href ui-sref=sensors.item({id:sensor.id})><i class=\"fa fa-pencil\"></i></a></div></td></tr></tbody></table><hr><div class=row><div class=col-md-8><ul class=list-inline><li><span class=\"label label-control label-success\">&nbsp;</span> Рабочее положение</li><li><span class=\"label label-control label-danger\">&nbsp;</span> Тревога</li><li><span class=\"label label-control label-default\">&nbsp;</span> Нет данных</li></ul></div><div class=\"col-md-4 text-right\"><a href ng-click=sensor.setStatuses(address) class=\"btn btn-block btn-success-light\">Обновить</a></div></div></div></uib-accordion></div>");
$templateCache.put("app/pages/sensors/views/form_sensor.html","<!-- Заголовок --><ul class=list-inline><li class=col-xs-10><h3><span ng-show=sensor.item.id>Редактирование датчика \"{{sensor.item.name}}\"</span></h3></li><li class=\"col-xs-2 text-right m-t-lg\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></li></ul><div class=\"alert alert-danger\" ng-show=sensor.error>{{sensor.error}}</div><div class=\"alert alert-danger\" ng-show=sensor.form.error>{{sensor.form.error}}</div><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true ng-hide=sensor.error ng-show=sensor.item.id><form ng-submit=sensor.updateSensor() name=sensor.form novalidate><div class=well><div class=p-t-lg><div class=row><form-element data-class=col-xs-6 data-name=worker_id data-title=\"Ответственный сотрудник\" data-form=sensor.form><ui-select name=worker_id ng-model=sensor.item.worker_id><ui-select-match placeholder=\"Выберите сотрудника\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in sensor.workers | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-sm-6 data-name=active_alert data-title=\"\" data-form=sensor.form data-help_msg=\"Включение смс оповещений при получении статуса тревоги\"><label><input type=checkbox name=active_alert ng-model=sensor.item.active_alert>&emsp;Оповещение о тревоге</label></form-element></div></div></div><div class=row><div class=col-xs-4><input type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div></div></form></div>");
$templateCache.put("app/pages/settings/views/content.html","<div class=row><div class=col-md-10><h2>{{ settings.title }}</h2><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=settings.error>{{settings.error}}</div><form ng-submit=settings.send() name=settings.form novalidate><div class=well><div class=row><div ng-repeat=\"item in settings.items track by $index\"><form-element data-name={{item.system_name}} data-title={{item.name}} data-form=settings.form><input name={{item.system_name}} id={{item.system_name}} type=number class=form-control ng-model=item.value required></form-element></div></div></div><div class=row><div class=col-sm-4><input type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div></div></form></div></div></div>");
$templateCache.put("app/pages/site/views/content.html","<!-- Заголовок --><h2>{{ site.title }}</h2><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=site.error>{{site.error}}</div><div class=\"row h3\"><div class=col-md-5><div class=\"panel panel-default\" ui-sref=site.domain role=button><div class=panel-body><span class=\"fa fa-cog m-r-lg\"></span> Настройки</div></div></div><div class=col-md-5><div class=\"panel panel-default\" ui-sref=site.structure role=button><div class=panel-body><span class=\"fa fa-th-list m-r-lg\"></span> Структура</div></div></div></div></div>");
$templateCache.put("app/pages/site/views/form_domain.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ domain.title }}</div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=domain.error>{{domain.error}}</div><div class=\"alert alert-danger\" ng-show=domain.form.error>{{domain.form.error}}</div><div ng-hide=domain.error><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true ng-hide=domain.error><form ng-submit=domain.updateDomain() name=domain.form novalidate><div class=well><a class=h3>Общая информация</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=domain data-title=\"Доменное имя\" data-form=domain.form><input name=domain id=domain type=text class=form-control ng-model=domain.item.domain required></form-element><form-element data-class=col-xs-12 data-name=name data-title=\"Название компании\" data-form=domain.form><input name=name id=name type=text class=form-control ng-model=domain.item.name required></form-element><form-element data-class=col-xs-12 data-name=name data-title=Слоган data-form=domain.form><input name=slogan id=slogan type=text class=form-control ng-model=domain.item.slogan></form-element><form-element data-class=col-xs-12 data-name=email data-title=\"Email для оповещений\" data-form=domain.form><input name=email id=email type=text class=form-control ng-model=domain.item.email></form-element><form-element data-class=col-xs-12 data-name=logo data-title=Логотип data-form=domain.form><div class=clearfix><div class=\"pull-left m-r-lg\" ng-show=domain.logo><img class=\"img-responsive bg-alfa\" alt={{domain.currentLogo.thumb}} ngf-thumbnail=domain.logo ngf-size=\"{width: 100, height: 100, quality: 0.9}\"><div class=\"btn-group-xs text-right m-t\"><a href ng-click=domain.deleteLogo() type=button class=\"btn btn-block btn-default\" aria-label=Close><small>удалить</small></a></div></div><div class=\"pull-left m-t-lg\"><div class=\"btn btn-success-light\" name=logo ng-model=domain.item.logo ngf-select ngf-change=\"domain.preUploadLogo($file, $invalidFiles)\" ngf-max-size=2MB ngf-accept=\"\'image/*\'\" ngf-pattern=\"\'image/*\'\">Загрузить логотип</div></div></div></form-element></div></div></div><div class=\"well domain-themes\"><a class=h3>Шаблон сайта</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=theme_id data-title=\"\" data-form=domain.form><div class=row><label role=button class=\"col-sm-6 domain-themes-item\" ng-model=domain.item.theme_id uib-btn-radio=theme.id ng-repeat=\"theme in domain.themes\"><div class=\"img-thumbnail domain-themes-img\"><img class=img-responsive ngf-src=theme.image alt={{theme.name}}></div></label></div></form-element></div></div></div><div class=well><a class=h3>Настройки шаблона</a><div class=p-t-lg><div class=row><div class=\"m-b-lg clearfix\"><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'body-bg\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Фон сайта</strong></div></div><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'text-color\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Цвет текста</strong></div></div><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'brand-additional\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Фон шапки</strong></div></div></div><div class=\"m-b-lg clearfix\"><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'header-color\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Цвет текста в шапке</strong></div></div><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'brand-primary\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Фон блока &quot;Контакты&quot;</strong></div></div><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'additional-text-color\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0\"><strong>Цвет текста в блоке &quot;Контакты&quot;</strong></div></div></div><div class=\"m-b-lg clearfix\"><div class=\"col-sm-4 col-xs-12 row\"><div class=\"col-xs-4 p-r-0\"><spectrum-colorpicker ng-model=\"domain.item.colors[\'brand-btn\']\" options=domain.optionsColorPicker></spectrum-colorpicker></div><div class=\"col-xs-8 p-l-0 p-t\"><strong>Фон кнопок</strong></div></div></div></div></div></div><div class=row><div class=col-sm-4><input type=submit ng-show=domain.item.id value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"> <input type=submit ng-hide=domain.item.id value=Создать class=\"btn btn-block btn-success\"></div></div></form></div></div></div>");
$templateCache.put("app/pages/site/views/form_structure.html","<div class=\"row m-b-lg\"><div class=\"h2 m-b-0 col-sm-8\"><span ng-show=structure.item.id>Редактирование страницы</span> <span ng-hide=structure.item.id>Добавление страницы</span></div><div class=\"text-right m-t-md col-sm-4\"><a href ui-sref=site.structure><span class=\"fa fa-arrow-circle-left\"></span> <span>Вернуться к структуре</span></a></div></div><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=structure.error>{{structure.error}}</div><div class=\"alert alert-danger\" ng-show=structure.form.error>{{structure.form.error}}</div><uib-tabset class=uib-tabset-menu active=activeJustified justified=true ng-show=structure.item.domain_id><uib-tab index=0 heading=\"Общая информация\"><form ng-submit=structure.send() name=structure.form class=m-t-lg novalidate><div class=well><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=name data-title=\"Внутреннее имя\" data-form=structure.form><input name=name id=name type=text class=form-control ng-change=structure.nameTranslit(); ng-model=structure.item.name required></form-element><form-element data-class=col-xs-12 data-name=alias data-title=Алиас data-form=structure.form data-help_msg=\"Уникальное в рамках раздела имя страницы, являющееся составной частью ее полного адреса\"><input name=alias id=alias type=text class=form-control ng-change=structure.checkAliasTranslit(); ng-model=structure.item.alias required></form-element><form-element data-class=col-xs-12 data-name=component_id data-title=Компонент data-form=structure.form><ui-select name=component_id ng-model=structure.item.component_id required><ui-select-match placeholder=\"Выберите компонент\" allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in structure.components | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><div class=col-xs-12><div class=row><div class=\"col-sm-4 p-y-md\"><label class=\"control-label m-a-0\"><input name=active id=active type=checkbox ng-model=structure.item.active> <span>Вкл./Выкл. страницы</span></label></div><div class=\"col-sm-4 p-y-md\"><label class=\"control-label m-a-0\"><input name=in_menu id=in_menu type=checkbox ng-model=structure.item.in_menu> <span>Отображать в меню</span></label></div><div class=\"col-sm-4 p-y-md\"><label class=\"control-label m-a-0\"><input name=is_main id=is_main type=checkbox ng-model=structure.item.is_main> <span>Главная страница</span></label></div></div></div></div></div></div><div class=well><a class=h3>Наполнение</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=h1 data-title=Заголовок data-form=structure.form><input name=h1 id=h1 type=text class=form-control ng-model=structure.item.h1></form-element><form-element data-class=col-xs-12 data-name=content data-title=\"Содержимое страницы\" data-form=structure.form><div trumbowyg-ng ng-model=structure.item.content editor-config=structure.trumbowygOptions></div></form-element></div></div></div><div class=well><a class=h3>SEO</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=title data-title=\"Название страницы\" data-form=structure.form><input name=title id=title type=text class=form-control ng-model=structure.item.title></form-element><form-element data-class=col-xs-12 data-name=title data-title=\"Ключевые слова\" data-form=structure.form><input name=keywords id=keywords type=text class=form-control ng-model=structure.item.keywords></form-element><form-element data-class=col-xs-12 data-name=title data-title=Описание data-form=structure.form><textarea name=description id=description type=text class=form-control ng-model=structure.item.description></textarea></form-element></div></div></div><div class=row><div class=col-sm-4><input type=submit ng-show=structure.item.id value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"> <input type=submit ng-hide=structure.item.id value=Создать class=\"btn btn-block btn-success\"></div></div></form></uib-tab><uib-tab index=1 heading=\"Галерея изображений\" ng-show=structure.item.id><div class=m-t-lg ng-show=structure.item.id><div class=\"btn btn-success\" ngf-select=structure.uploadFiles($files) ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=20MB ngf-max-files=10 ngf-multiple=true>Загрузить изображения</div><div class=\"row m-t-lg\"><div class=\"col-sm-4 m-b-lg text-center\" ng-repeat=\"image in structure.images track by $index\"><div class=\"img-thumbnail wrapper-buttons\"><div ng-click=structure.openLightboxModal($index)><img ngf-src=image.thumbUrl class=img-responsive></div><div class=\"buttons btn-group-xs text-right m-a-0 m-t\"><a href ng-click=structure.deleteImage($index) class=\"btn btn-default\"><small>удалить</small></a></div></div></div></div></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/pages/site/views/structure.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ structure.title }}</div><div class=text-right><a href ui-sref=site><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"p-y text-right\"><a href ui-sref=site.structure.item class=\"btn btn-xs btn-primary-light\">Создать раздел</a></div><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=structure.error>{{structure.error}}</div><div id=structureList class=list-group ng-sortable=\"{ animation: 150 }\"><div class=\"list-group-item p-y p-x-0\" ng-repeat=\"item in structure.items\" ng-include=\"\'structureItem.html\'\"></div></div></div>");
$templateCache.put("app/pages/sync/views/content.html","<!-- Заголовок --><h2>Синхронизация с расчетной системой</h2><div class=p-t-lg><div class=\"row h3\"><div class=col-sm-6><div class=\"panel panel-default\" ui-sref=sync.import role=button><div class=panel-body>Загрузить данные по квитанциям и приборам учета</div></div></div><div class=col-sm-6><div class=\"panel panel-default\" ui-sref=sync.export role=button><div class=panel-body>Выгрузить данные с показаниями приборов учета</div></div></div></div></div>");
$templateCache.put("app/pages/sync/views/form_export.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ sync.title }}</div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=sync.error>{{sync.error}}</div><div class=\"alert alert-danger\" ng-show=sync.form.error>{{sync.form.error}}</div><div ng-hide=sync.error><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true><form ng-submit=sync.export() name=sync.form novalidate><div class=well><div class=row><form-element data-name=address_id data-title=Адрес data-form=sync.form><ui-select name=address_id ng-model=sync.address_id ng-change=sync.clearUrl() required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in sync.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=\"col-sm-6 clearfix\" data-name=flat_name data-title=\"Месяц и год показаний счетчиков\" data-help_hide=1 data-form=counter_stats.formFind><div class=\"col-sm-6 p-l-0\"><ui-select name=month ng-model=sync.month ng-change=sync.clearUrl() required><ui-select-match placeholder=\"Выберите месяц\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in sync.months | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6 p-l-0\"><ui-select name=year ng-model=sync.year ng-change=sync.clearUrl() required><ui-select-match placeholder=\"Выберите год\" allow-clear=true><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices repeat=\"item in sync.years | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div></form-element></div><uib-progressbar class=\"progress-striped active\" value=sync.progressImport type={{sync.progressImportType}} ng-show=sync.progressImport></uib-progressbar></div><div class=row><div class=\"col-sm-4 col-xs-12\"><input type=submit value=Выгрузить class=\"btn btn-block btn-success m-b-lg\"></div><div class=\"col-lg-3 col-sm-4 col-xs-12\" ng-if=\"sync.fileXMLUrl || sync.msSaveOrOpenBlob\"><a ng-if=sync.msSaveOrOpenBlob ng-click=sync.msDownloadFile(sync.fileXMLblob,sync.fileXMLName) class=\"btn btn-block btn-default m-b-lg\">СКАЧАТЬ {{sync.fileXMLName}}</a> <a ng-if=sync.fileXMLUrl href={{sync.fileXMLUrl}} class=\"btn btn-block btn-default m-b-lg\" download={{sync.fileXMLName}}>СКАЧАТЬ {{sync.fileXMLName}}</a></div><div class=\"col-lg-3 col-sm-4 col-xs-12\" ng-if=\"sync.fileOneCXMLUrl || sync.msSaveOrOpenBlob\"><a ng-if=sync.msSaveOrOpenBlob ng-click=sync.msDownloadFile(sync.fileOneCXMLblob,sync.fileOneCXMLName) class=\"btn btn-block btn-default m-b-lg\">СКАЧАТЬ {{sync.fileOneCXMLName}} для 1С</a> <a ng-if=sync.fileOneCXMLUrl href={{sync.fileOneCXMLUrl}} class=\"btn btn-block btn-default m-b-lg\" download={{sync.fileOneCXMLName}}>СКАЧАТЬ {{sync.fileOneCXMLName}} для 1С</a></div><div class=\"col-lg-3 col-sm-4 col-xs-12\" ng-show=\"sync.fileXLSXUrl || sync.msSaveOrOpenBlob\"><a ng-if=sync.msSaveOrOpenBlob ng-click=sync.msDownloadFile(sync.fileXLSXblob,sync.fileXLSXName) class=\"btn btn-block btn-default m-b-lg\">СКАЧАТЬ {{sync.fileXLSXName}}</a> <a ng-if=sync.fileXLSXUrl href={{sync.fileXLSXUrl}} class=\"btn btn-block btn-default m-b-lg\" download={{sync.fileXLSXName}}>СКАЧАТЬ {{sync.fileXLSXName}}</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/sync/views/form_import.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ sync.title }}</div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=p-t-lg><div class=\"alert alert-danger\" ng-show=sync.error>{{sync.error}}</div><div class=\"alert alert-danger\" ng-show=sync.form.error>{{sync.form.error}}</div><div class=\"alert alert-success\" ng-show=sync.form.success>{{sync.form.success}}</div><div ng-hide=sync.error><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true><form ng-submit=sync.import() name=sync.form novalidate><div class=well><div class=row><form-element data-name=address_id data-title=Адрес data-form=sync.form><ui-select name=address_id ng-model=sync.address_id required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in sync.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=\"col-sm-5 col-xs-12\" data-name=address_id data-title=Тип data-form=sync.form><ui-select name=type ng-model=sync.type required><ui-select-match placeholder=\"Выберите тип загрузки\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.value as item in sync.types | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-xs-12 data-name=file data-title=\"Файл (.zip) {{sync.currentFile}}\" data-form=sync.form><div class=row><div class=\"col-sm-4 col-xs-12\"><button class=\"btn btn-block btn-success-light\" name=file ng-model=sync.file ngf-change=\"sync.preUploadFile($file, $invalidFiles)\" ngf-select>Выбрать файл</button></div></div></form-element></div><!--<uib-progressbar class=\"progress-striped active\" value=\"sync.progressImport\" type=\"{{sync.progressImportType}}\" ng-show=\"sync.progressImport\"></uib-progressbar>--></div><div class=row><div class=\"col-sm-4 col-xs-12\"><input type=submit value=Загрузить class=\"btn btn-block btn-success\" ng-class=\"{\'disabled\':sync.disabled}\"></div></div></form></div></div></div>");
$templateCache.put("app/pages/sync/views/test.html","<!DOCTYPE HTML PUBLIC \"-//W3C//DTD HTML 4.01 Transitional//EN\" \"http://www.w3.org/TR/html4/loose.dtd\"><html><head><title>Оператор связи Инсис</title><meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"><meta name=viewport content=\"width=device-width\"></head><body bgcolor=#0079b2 background=http://www.profintel.ru/images/email_stat/bg.jpg style=\"background:#0079b2 url(\'http://www.profintel.ru/images/email_stat/bg.jpg\');height: 100%;margin: 0;padding: 0;width: 100%;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;background-color: #0079b2;background-image: url(\'http://www.profintel.ru/images/email_stat/bg.jpg\')\"><table border=0 cellpadding=0 cellspacing=0 width=100%><tr><td height=100% align=center><center style=\"width: 710px; max-width: 710px; -webkit-text-size-adjust:none; display: block\"><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=710px><tr><td height=50px>&nbsp;</td></tr><tr><td><table background=http://www.profintel.ru/images/email_stat/mail_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/mail_bg_top.png\'); margin:0; padding:0\" width=710px><tr><td height=20px></td></tr></table></td></tr><tr><td><table background=http://www.profintel.ru/images/email_stat/mail_bg.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/mail_bg.png\'); margin:0; padding:0\" width=710px><tr><td align=center><table border=0 cellpadding=0 cellspacing=0 width=700px bgcolor=#ffffff style=\"background-color: #ffffff; width:700px\"><tr><td height=5px>&nbsp;</td></tr><tr><td align=center><center style=\"width: 650px; max-width: 650px; -webkit-text-size-adjust:none; display: block\"><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td align=left><table border=0 cellpadding=0 cellspacing=15 style=\"margin:0; padding:0\" width=100%><tr><td><a href=http://www.profintel.ru target=_blank style=\"text-decoration: underline\"><img src=http://www.profintel.ru/images/email_stat/logo.png border=0 width=190px height=65px alt=\"Оператор связи Инсис\"></a></td><td align=right><a href=https://vk.com/insys1999 target=_blank style=\"text-decoration: none\"><img src=http://www.profintel.ru/images/email_stat/vk2.png border=0 width=50px height=50px alt=\"Оператор связи Инсис\"> </a><a href=https://www.facebook.com/insys.ru/ target=_blank style=\"text-decoration: none\"><img src=http://www.profintel.ru/images/email_stat/fb2.png border=0 width=50px height=50px alt=\"Оператор связи Инсис\"> </a><a href=https://www.instagram.com/insysprofi/ target=_blank style=\"text-decoration: none\"><img src=http://www.profintel.ru/images/email_stat/instagram.png border=0 width=50px height=50px alt=\"Оператор связи Инсис\"> </a><a href=https://www.youtube.com/channel/UC3zFvk0o8c-ioC587p-H4KA target=_blank style=\"text-decoration: none\"><img src=http://www.profintel.ru/images/email_stat/youtube.png border=0 width=50px height=50px alt=\"Оператор связи Инсис\"></a></td></tr><tr><td colspan=2 height=30px>&nbsp;</td></tr><tr><td colspan=2 align=center><span style=\"color: #0678a9; font-size: 39px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 39px; -webkit-text-size-adjust:none; display: block\">Добро пожаловать!</span></td></tr><tr><td colspan=2 align=center><table border=0 cellpadding=0 cellspacing=18 style=\"margin:0; padding:0;font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=100%><tr><td width=30%><img src=http://www.profintel.ru/images/email_stat/manager.jpg border=0 width=154px height=195px style=\"display: block\" alt=\"Решетников Александр\"></td><td><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td><span style=\"color: #2b2a29; font-size: 20px; line-height: 28px; -webkit-text-size-adjust:none; display: block\">Меня зовут Александр Решетников.<br>Я ваш личный помощник.</span></td></tr><tr><td height=25px>&nbsp;</td></tr><tr><td><span style=\"color: #2b2a29; font-size: 20px; line-height: 22px; -webkit-text-size-adjust:none; display: block\">Обращайтесь ко мне по любым вопросам:</span></td></tr><tr><td height=8px>&nbsp;</td></tr><tr><td><span style=\"color: #0678a9; font-size: 20px; font-weight:bold; line-height: 24px; -webkit-text-size-adjust:none\">Тел.:</span> <span style=\"color: #2b2a29; font-size: 18px; line-height: 24px; -webkit-text-size-adjust:none\">+7 (343) 278-60-06 вн. 345</span></td></tr><tr><td><span style=\"color: #0678a9; font-size: 20px; font-weight:bold; line-height: 24px; -webkit-text-size-adjust:none\">E-mail:</span> <span style=\"color: #2b2a29; font-size: 18px; line-height: 24px; -webkit-text-size-adjust:none\">info@profintel.ru</span></td></tr><tr><td><span style=\"color: #0678a9; font-size: 20px; font-weight:bold; line-height: 24px; -webkit-text-size-adjust:none\">Skype/ICQ:</span> <span style=\"color: #2b2a29; font-size: 18px; line-height: 24px; -webkit-text-size-adjust:none\">info-profintel / 302467478</span></td></tr></table></td></tr></table></td></tr></table></td></tr><tr><td align=left><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td colspan=2 align=center><span style=\"color: #5B5B5B; font-size: 24px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; font-weight:bold; line-height: 40px; -webkit-text-size-adjust:none; display: block\">6 лайфхаков, которые сделают вашу работу проще</span></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; line-height: 20px; -webkit-text-size-adjust:none; display: block\">1. Личный кабинет: здесь есть все!</span><table border=0 cellpadding=0 cellspacing=20 style=margin:0;padding:0 width=100%><tr><td><table border=0 cellpadding=0 cellspacing=10 style=margin:0;padding:0 width=100%><tr><td><span style=\"color: #2b2a29; font-size: 24px; line-height: 24px; -webkit-text-size-adjust:none; display: block\">Логин: ik078754</span></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 24px; line-height: 24px; -webkit-text-size-adjust:none; display: block\">Пароль: wexcgfd</span></td></tr><tr><td><a href=https://stat.profintel.ru/ target=_blank style=\"text-decoration: none\"><img src=http://www.profintel.ru/images/email_stat/btn1.png border=0 width=237px height=47px style=\"display: block\" alt=\"Перейти в Личный кабинет\"></a></td></tr></table></td><td><img src=http://www.profintel.ru/images/email_stat/img4.png border=0 width=280px height=149px style=\"display: block\" alt=\"Перейти в Личный кабинет\"></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><table border=0 cellpadding=0 cellspacing=0 style=margin:0;padding:0 width=100%><tr><td width=35% align=center><img src=http://www.profintel.ru/images/email_stat/img5.png border=0 width=146px height=149px alt=\"Документы online\" style=\"margin:0; display: block\"></td><td width=65%><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 32px; -webkit-text-size-adjust:none; display: block\">2. Документы online</span></td></tr><tr><td><div style=\"height:15px; line-height:15px; font-size:13px\">&nbsp;</div></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 20px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">Счет, закрывающие и акт сверки всегда под рукой - в <a href=\"https://oauth.profintel.ru/login?oaction=authorize&application=stat-profintel-ru&return_url=https://stat.profintel.ru/docs&utm_source=email&utm_medium=post&utm_term=hello&utm_content=auth&utm_campaign=1\" target=_blank style=\"color: #0678a9\">Личном кабинете.</a></span></td></tr><tr><td><div style=\"height:15px; line-height:15px; font-size:13px\">&nbsp;</div></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 20px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">У нас <strong>кредитная</strong> система оплаты -<br><strong>до 15 числа</strong> периода, следующего за расчетным.</span></td></tr></table></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 32px; -webkit-text-size-adjust:none; display: block\">3. Экономьте</span><table border=0 cellpadding=0 cellspacing=0 style=margin:0;padding:0 width=100%><tr><td colspan=3 height=20px></td></tr><tr><td width=30% align=center><img src=http://www.profintel.ru/images/email_stat/img6.png border=0 width=127px height=149px style=\"display: block\" alt=\"\"></td><td width=30% align=center><img src=http://www.profintel.ru/images/email_stat/img6.png border=0 width=127px height=149px style=\"display: block\" alt=\"\"></td><td width=30% align=center><img src=http://www.profintel.ru/images/email_stat/img7.png border=0 width=130px height=70px style=\"display: block\" alt=\"\"></td></tr><tr><td colspan=3 height=20px>&nbsp;</td></tr><tr><td width=30% align=center><span style=\"color: #2b2a29; font-size: 18px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 22px; -webkit-text-size-adjust:none; display: block\">при покупке Абонемента</span></td><td width=30% align=center><span style=\"color: #2b2a29; font-size: 18px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 22px; -webkit-text-size-adjust:none; display: block\">вашим сотрудникам<br><strong>при подключении<br>«Инсис» дома</strong></span></td><td width=30% align=center><span style=\"color: #2b2a29; font-size: 18px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 22px; -webkit-text-size-adjust:none; display: block\">на Лицевой счет<br><strong>за рекомендацию</strong></span></td></tr><tr><td colspan=3 height=25px>&nbsp;</td></tr><tr><td colspan=3 align=center><span style=\"color: #2b2a29; font-size: 15px; -webkit-text-size-adjust:none; display: block\">Интересно? Звоните, расскажу подробнее.</span></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><table border=0 cellpadding=0 cellspacing=0 style=margin:0;padding:0 width=100%><tr><td width=30% align=center><img src=http://www.profintel.ru/images/email_stat/img8.png border=0 width=110px height=113px alt=Техподдержка style=margin:0;display:block></td><td width=70%><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 34px; -webkit-text-size-adjust:none\">4. Оставьте заявку в техподдержку, </span><span style=\"color: #2b2a29; font-size: 22px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 32px; -webkit-text-size-adjust:none\">если пропала связь:</span></td></tr><tr><td height=10px>&nbsp;</td></tr><tr><td><span style=\"color: #2b2a29; font-size: 19px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">- по <strong>бесплатному</strong> телефону: <strong>8-800-755-05-55</strong>;</span></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 19px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">- на e-mail: info@profintel.ru;</span></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 19px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">- в <a href=https://stat.profintel.ru/troubles target=_blank style=\"color: #0678a9\">Личном кабинете.</a></span></td></tr></table></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0;padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=100%><tr><td><table border=0 cellpadding=0 cellspacing=5 style=\"margin:0; padding:0\" width=100%><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 27px; -webkit-text-size-adjust:none; display: block\">5. Используйте доверительный платеж</span></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 22px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 22px; -webkit-text-size-adjust:none; display: block\">на <strong>3</strong> дня если не успели оплатить вовремя</span></td></tr></table></td><td width=20% align=center><img src=http://www.profintel.ru/images/email_stat/img9.png border=0 width=100px height=103px style=\"display: block\" alt=\"доверительный платеж\"></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=20px colspan=2>&nbsp;</td></tr><tr><td colspan=2 align=center><center style=\"width: 642px; max-width: 642px\"><table background=http://www.profintel.ru/images/email_stat/content_bg_top.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_top.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg.png bgcolor=#e7f5fd border=0 cellpadding=0 cellspacing=15 style=\"background-color: #e7f5fd; background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg.png\'); margin:0; padding:0; font-family: Trebuchet MS, Georgia, Arial, sans-serif\" width=642px><tr><td><table border=0 cellpadding=0 cellspacing=5 style=margin:0;padding:0 width=100%><tr><td width=30% align=center><img src=http://www.profintel.ru/images/email_stat/img10.png border=0 width=140px height=76px alt=Переезд style=\"margin:0; display:block\"></td><td width=70%><table border=0 cellpadding=0 cellspacing=5 style=\"margin:0; padding:0\" width=100%><tr><td><span style=\"color: #2b2a29; font-size: 27px; font-weight: bold; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 30px; -webkit-text-size-adjust:none; display: block\">6. Не платите за переезд</span></td></tr><tr><td><span style=\"color: #2b2a29; font-size: 20px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 24px; -webkit-text-size-adjust:none; display: block\">Мы подключим вас по новому адресу <strong>бесплатно</strong> в 99% случаев. Обращайтесь!</span></td></tr></table></td></tr></table></td></tr></table><table background=http://www.profintel.ru/images/email_stat/content_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/content_bg_bottom.png\'); margin:0; padding:0\" width=642px><tr><td height=10px><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></center></td></tr><tr><td height=40px colspan=2>&nbsp;</td></tr><tr><td valign=top colspan=2><table border=0 cellpadding=20 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td style=\"border-top:2px solid #5b5b5b;  border-top-color:#5b5b5b; border-top-style:solid; border-top-width:2px\"><span style=\"color: #2b2a29; font-size: 20px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 26px; -webkit-text-size-adjust:none; display: block\">Искренне рад нашему сотрудничеству,<br>Александр!</span></td></tr></table></td></tr></table></td></tr></table></center></td></tr><tr><td height=20px>&nbsp;</td></tr><tr><td align=center><span style=\"color: #2b2a29; font-size: 15px; font-family: Trebuchet MS, Georgia, Arial, sans-serif; line-height: 15px; -webkit-text-size-adjust:none; display: block\">Если письмо не отображается - откройте его в браузере.</span></td></tr><tr><td><div style=\"height:10px; line-height:10px; font-size:8px\">&nbsp;</div></td></tr></table></td></tr></table></td></tr><tr><td align=center><table background=http://www.profintel.ru/images/email_stat/mail_bg_bottom.png border=0 cellpadding=0 cellspacing=0 style=\"background-image: url(\'http://www.profintel.ru/images/email_stat/mail_bg_bottom.png\'); margin:0; padding:0\" width=710px><tr><td height=20px><div style=\"height:20px; line-height:20px; font-size:18px\">&nbsp;</div></td></tr></table></td></tr></table></center><table border=0 cellpadding=0 cellspacing=0 style=\"margin:0; padding:0\" width=100%><tr><td height=30px><div style=\"height:30px; line-height:30px; font-size:28px\">&nbsp;</div></td></tr></table></td></tr></table></body></html>");
$templateCache.put("app/pages/tech_orders/views/content.html","<h2>Заявки <a href class=\"btn btn-success\" ui-sref=technicians>Специалисты</a></h2><div class=\"well m-t-lg\"><table class=\"table table-hover table-condensed\"><thead><tr><th class=text-center>ID</th><th class=text-center>Адрес</th><th>Специалист</th><th>Дата</th><th class=hidden-xs>Комментарий</th><th class=hidden-xs>Статус</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in order.items\" ng-class=\"{\'active\':!item.read_company}\"><td ui-sref=tech_orders.item({id:item.id}) role=button class=\"valign-top text-center\"><span class=h6>#{{item.id}}</span></td><td ui-sref=tech_orders.item({id:item.id}) role=button width=180px class=\"valign-top text-center\">{{item.address.name}}, кв. {{item.flat.name}}</td><td ui-sref=tech_orders.item({id:item.id}) role=button class=valign-top><div>{{item.tech.name}}</div></td><td ui-sref=tech_orders.item({id:item.id}) role=button class=valign-top>{{item.date | date:\'dd.MM.yyyy HH:mm\'}}<div class=text-danger ng-show=item.deleted_company>Заявка удалена из личного кабинета компании</div></td><td ui-sref=tech_orders.item({id:item.id}) role=button class=\"valign-top hidden-xs\">{{item.comment}}</td><td ui-sref=tech_orders.item({id:item.id}) role=button class=\"valign-top text-nowrap hidden-xs\">{{item.status.name}}</td><td class=valign-top><div class=buttons><a href ui-sref=tech_orders.item({id:item.id})><span class=\"fa fa-pencil\" uib-tooltip=Редактировать></span></a></div></td></tr></tbody></table><ul uib-pagination total-items=order.cnt_items ng-model=order.page items-per-page=order.limit ng-change=order.init($index) force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div>");
$templateCache.put("app/pages/tech_orders/views/form_order.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">Заявка на вызов специалиста</div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=\"alert alert-danger\" ng-show=order.error>{{order.error}}</div><div class=\"alert alert-danger\" ng-show=order.form.error>{{order.form.error}}</div><form ng-submit=order.send() name=order.form novalidate ng-show=\"!order.error && order.item.id\"><div class=well><div class=\"m-b-lg row\"><div class=\"h3 m-y-0 col-sm-6\">Заявка #{{order.item.id}} <small class=text-muted>{{order.item.create_date | date:\'dd.MM.yyyy\'}}</small></div><div class=\"col-sm-6 text-right text-success\">Статус заявки: {{order.item.status}}</div></div><div class=\"row m-b-lg\"><div class=col-sm-2><strong>Адрес</strong></div><div class=col-sm-10>{{order.item.address}}</div><div class=col-sm-2><strong>Специалист</strong></div><div class=col-sm-10>{{order.item.technician}}</div><div class=col-sm-2><strong>Комментарий</strong></div><div class=col-sm-10>{{order.item.comment}}</div></div><div class=row><form-element data-name=date data-title=\"Дата прихода специалиста\" data-form=order.form><datepicker date-format=\"yyyy-MM-dd hh:mm:ss\"><input name=date id=date type=text class=form-control ng-model=order.item.date required></datepicker></form-element><form-element data-name=date data-title=\"Сотрудник (специалист)\" data-form=order.form><ui-select name=worker_id ng-model=order.item.worker_id on-remove=order.clearWorkerId()><ui-select-match placeholder=\"Выберите сотрудника\" allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in order.workers | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element><input type=submit value=\"Сохранить изменения\" class=\"btn btn-success\"></form-element></div></div></form><form ng-submit=order.changeStatus() name=order.formStatus novalidate ng-show=\"!order.error && order.item.id\"><div class=well><div class=\"h3 m-t-0 m-b-lg\">Смена статуса заявки</div><div class=row><form-element data-class=col-sm-5 data-name=status_id data-title=Статус data-form=order.formStatus><ui-select name=status_id ng-model=order.status.status_id><ui-select-match placeholder=\"Выберите статус\" allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in order.statuses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-sm-6 data-name=comment data-title=Комментарий data-form=order.formStatus><textarea name=comment rows=1 id=comment class=form-control ng-model=order.status.comment></textarea></form-element><div class=col-sm-5><input type=submit value=\"Сменить статус и отправить email\" class=\"btn btn-block btn-success\"></div></div></div></form><div class=h4 ng-show=order.order_statuses>История изменения статуса заявки</div><div class=p-x ng-show=order.order_statuses><table class=\"table table-condensed table-no-border\"><thead><tr><th>Дата</th><th>Статус</th><th>Комментарий</th></tr></thead><tbody><tr ng-repeat=\"item in order.order_statuses\"><td>{{item.create_date | date:\'dd.MM.yyyy HH:mm\'}}</td><td>{{item.status}}</td><td>{{item.comment}}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/technicians/views/content.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">Список специалистов</div><div class=\"text-right text-nowrap\"><a href ui-sref=tech_orders><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=p-t-lg><!--Таблица --><table class=\"table table-hover\"><thead><tr><th>Специалист</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in technician.items\"><td><a href ui-sref=technicians.item({id:item.id})>{{item.name}}</a></td><td><div class=buttons><a href ui-sref=technicians.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=technician.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><a href class=\"btn btn-success\" ui-sref=technicians.item>Добавить специалиста</a></div>");
$templateCache.put("app/pages/technicians/views/form_technician.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=technician.item.id>Редактирование специалиста</span> <span ng-hide=technician.item.id>Добавление специалиста</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=\"alert alert-danger\" ng-show=technician.error>{{technician.error}}</div><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true><form ng-submit=technician.send() name=technician.form novalidate><div class=well><a class=h3>Общая информация</a><div class=p-t-lg><div class=row><form-element data-class=col-xs-12 data-name=name data-title=Специалист data-form=technician.form><input name=name id=name type=text class=form-control ng-model=technician.item.name required></form-element></div></div></div><input type=submit ng-hide=technician.item.id value=Создать class=\"btn btn-success\"> <input type=submit ng-show=technician.item.id value=\"Сохранить изменения\" class=\"btn btn-success\"></form></div>");
$templateCache.put("app/pages/video/views/content.html","<h2>Видеонаблюдение</h2><div class=p-t-lg><div ng-repeat=\"camera in video.cameras\"><div ng-show=camera.isPlaying><h4>{{camera.cam_name}}</h4><div id=cam{{camera.group__id}}{{camera.cam_id}}></div></div></div></div>");
$templateCache.put("app/pages/voting/views/content.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">{{ voting.title }}</div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=p-t-lg><div class=well><form ng-submit=voting.init() name=voting.formFind novalidate><div class=row><form-element data-class=\"col-sm-12 p-b\" data-name=address_id data-title=Адрес data-help_hide=1 data-form=\"\"><ui-select name=address_id ng-model=voting.findParams.address_id on-select=voting.initVotings() required><ui-select-match placeholder=\"\" allow-clear=false remove-selected=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in voting.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element></div><input type=submit class=hide></form></div><table class=\"table table-hover table-no-border table-condensed table-voting\"><thead><tr><th>Вопрос</th><th>Дата старта</th><th>Дата окончания</th><th>Статус</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in voting.items\"><td role=button ui-sref=voting.item({id:item.id})>{{item.name}}</td><td role=button ui-sref=voting.item({id:item.id})>{{item.tm_start | date}}</td><td role=button ui-sref=voting.item({id:item.id})>{{item.tm_end | date}}</td><td role=button ui-sref=voting.item({id:item.id})><span ng-if=\"item.status === 1 && (item.tm_end | date) > (voting.now | date)\">Запущено</span> <span ng-if=\"item.status === 1 && (item.tm_end | date) <= (voting.now | date)\">Завершено</span></td><td><div class=buttons><a href ui-sref=voting.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=voting.delete(item) ng-if=!item.status><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div class=col-sm-6><ul uib-pagination total-items=voting.cntItems ng-model=voting.page items-per-page=voting.findParams.limit ng-change=voting.init() force-ellipses=true rotate=true max-size=5 class=pagination-sm boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div><div class=\"col-sm-6 text-right p-t-lg\"><a href ui-sref=voting.item({address_id:voting.findParams.address_id}) class=\"btn btn-sm btn-success\">Добавить голосование</a></div></div></div>");
$templateCache.put("app/pages/voting/views/form_question.html","<div class=\"flex flex-center m-b-lg\"><div ng-if=!vm.item.id class=\"h2 m-b-0 m-r-lg\">Добавление вопроса</div><div ng-if=vm.item.id class=\"h2 m-b-0 m-r-lg\">Редактирование вопроса</div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=voting.error>{{voting.error}}</div><div class=\"alert alert-danger\" ng-show=voting.form.error>{{voting.form.error}} <button type=button class=close data-dismiss=alert aria-label=Close><span aria-hidden=true ng-click=\"voting.form.error = \'\'\">&times;</span></button></div><!--Форма --><form ng-if=!voting.error ng-submit=voting.send() name=voting.form novalidate><div class=well><h5><small>адрес:</small> {{voting.address.name}}</h5><h5 class=p-b-lg><small>название:</small> {{voting.voting.name}}</h5><div class=row><form-element data-class=col-xs-12 data-name=name data-title=\"Текст вопроса\" data-form=voting.form><textarea ng-model=voting.item.name name=name rows=4 id=name type=name class=form-control required></textarea></form-element></div></div><div class=row><div class=col-sm-4><input type=submit value=Отправить class=\"btn btn-block btn-success m-t\"></div></div></form>");
$templateCache.put("app/pages/voting/views/form_result.html","<div class=\"flex flex-center m-b-lg\"><div ng-if=!vm.item.id class=\"h2 m-b-0 m-r-lg\">Добавление ответа собственника</div><div ng-if=vm.item.id class=\"h2 m-b-0 m-r-lg\">Редактирование ответа собственника</div><div class=text-right><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=voting.error>{{voting.error}}</div><div class=\"alert alert-danger\" ng-show=voting.form.error>{{voting.form.error}} <button type=button class=close data-dismiss=alert aria-label=Close><span aria-hidden=true ng-click=\"voting.form.error = \'\'\">&times;</span></button></div><!--Форма --><form ng-if=!voting.error ng-submit=voting.send() name=voting.form novalidate><div class=well><h5><small>адрес:</small> {{voting.address.name}}<span ng-if=voting.owner>, кв. {{voting.owner.flat}}</span></h5><h5 class=p-b-lg><small>вопрос:</small> {{voting.voting.name}}</h5><h5 ng-if=voting.item.id class=p-b-lg><small>собственник:</small> {{voting.item.contacts.name}}</h5><div class=row><form-element ng-if=!voting.item.id data-class=col-xs-12 data-name=owner_id data-title=Собственник data-form=voting.form data-form-item=voting.form.owner_id><ui-select name=owner_id ng-model=voting.item.owner_id required><ui-select-match placeholder=\"Выберите квартиру\" allow-clear=true><span ng-bind=\"\'кв. \' + $select.selected.flat + \' - \' + $select.selected.contacts.name\"></span></ui-select-match><ui-select-choices repeat=\"item.id as item in voting.owners | filter: $select.search\"><div ng-bind-html=\"\'кв. \' + item.flat + \' - \' + item.contacts.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><div ng-repeat=\"question in voting.questions\" class=m-b><div class=col-xs-12><h5 class=\"m-t-0 m-b-lg\">{{question.name}}</h5><div ng-repeat=\"answer in voting.answers\" class=m-b><input ng-model=voting.item.answers[question.id] name=answer[{{question.id}}] ng-value=answer.id id=answer{{answer.id}}_{{question.id}} type=radio class=radio><label for=answer{{answer.id}}_{{question.id}}>{{answer.name}}</label></div></div></div></div></div><div class=row><div class=col-sm-4><input type=submit value=Отправить class=\"btn btn-block btn-success m-t-lg\"></div></div></form>");
$templateCache.put("app/pages/voting/views/form_voting.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=voting.item.id>Редактирование голосования</span> <span ng-hide=voting.item.id>Добавление голосования</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> <span>Назад</span></a></div></div><div class=\"alert alert-danger\" ng-show=voting.form.error><button type=button class=close data-dismiss=alert aria-label=Close><span aria-hidden=true ng-click=\"voting.form.error = \'\'\">&times;</span></button><p ng-bind-html=voting.form.error></p><div ng-repeat=\"item in voting.errorOwners\"><a ui-sref=reestr.item({id:item.id}) class=p-y target=_blank>кв. {{item.flat}}, {{item.contacts.name}}</a></div></div><div class=\"alert alert-danger\" ng-show=voting.error>{{voting.error}}</div><uib-tabset class=uib-tabset-menu active=voting.indexTab justified=false><uib-tab index=0 ng-click=voting.setIndex(0) heading=\"Общая информация\"><form ng-submit=voting.send() name=voting.form novalidate><div class=p-t-lg><div class=row><form-element data-id=address_id data-name=address_id data-title=Адрес data-form=voting.form data-form-item=voting.form.address_id><ui-select name=address_id ng-model=voting.item.address_id required><ui-select-match placeholder=\"Выберите адрес\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in voting.addresses | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=type data-title=\"Вид голосования\" data-form=voting.form><ui-select name=type ng-model=voting.item.params.type><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in voting.params.type | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-name=type data-title=\"Форма голосования\" data-form=voting.form><ui-select name=form ng-model=voting.item.params.form><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in voting.params.form | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></form-element><form-element data-class=col-xs-12 data-name=name data-title=Название data-form=voting.form><input name=name id=name type=name class=form-control ng-model=voting.item.name required></form-element><form-element data-name=tm_start data-title=\"Дата старта\" data-form=voting.form data-form-item=voting.form.tm_start><datepicker date-format=yyyy-MM-dd required><input name=tm_start class=form-control ng-model=voting.item.tm_start autocomplete=off></datepicker></form-element><form-element data-name=tm_end data-title=\"Дата окончания\" data-form=voting.form data-form-item=voting.form.tm_end><datepicker date-format=yyyy-MM-dd required><input name=tm_end class=form-control ng-model=voting.item.tm_end autocomplete=off></datepicker></form-element></div></div><div class=\"row m-t-lg\"><div class=\"col-sm-4 col-xs-12 m-b\"><input ng-if=!voting.item.id type=submit value=Создать class=\"btn btn-block btn-success\"> <input ng-if=\"voting.item.id && !voting.item.status\" type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div><div class=\"col-sm-4 col-xs-12 pull-right m-b\"><input ng-if=\"voting.item.id && !voting.item.status\" ng-click=voting.setVotingStatus() type=button value=\"Запустить голосование\" class=\"btn btn-block btn-success-light\"></div></div></form></uib-tab><uib-tab ng-if=voting.item.id index=3 ng-click=voting.setIndex(3) heading=Вопросы><table class=\"table table-hover table-no-border table-condensed table-reestr\"><thead><tr><th>Вопрос</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in voting.questions\"><td>{{item.name}}</td><td><div ng-if=\"voting.item.status !== 1\" class=buttons><a href ui-sref=voting.question({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=voting.deleteQuestion(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div ng-if=\"voting.item.status !== 1\" class=row><div class=col-sm-4><a href ui-sref=voting.question({voting_id:voting.item.id}) class=\"btn btn-block btn-success-light\">Добавить вопрос</a></div></div></uib-tab><uib-tab ng-if=\"voting.item.id && voting.openResult\" ng-click=voting.setIndex(1) index=1 heading=Результаты><h5 class=p-b-lg>&laquo;{{voting.item.name}}&raquo;</h5><div ng-repeat=\"question in voting.questions\" class=m-b><h5 class=m-y-lg>{{question.name}}</h5><div ng-repeat=\"itemResult in question.result\" class=m-b>&laquo;{{itemResult.answer_name}}&raquo; &ndash; {{(itemResult.cnt_votes ? itemResult.cnt_votes : 0)}} гол., {{(itemResult.prt ? itemResult.prt : 0)}} % от общего числа голосов</div></div><div class=p-y-lg>Всего проголосовало {{(voting.cnt_owners ? voting.cnt_owners : 0)}} чел.</div><div ng-if=voting.openFormResult class=row><div class=col-sm-4><a href ui-sref=voting.result({voting_id:voting.item.id}) class=\"btn btn-block btn-success-light\">Добавить ответ собственника</a></div></div><div ng-if=!voting.openFormResult class=row><div class=\"col-sm-4 col-xs-12\"><a ng-click=voting.protocol() class=\"btn btn-block btn-success-light m-b-lg\">Выгрузить протокол</a></div><div class=\"col-lg-3 col-sm-4 col-xs-12\" ng-if=\"voting.fileUrl || voting.msSaveOrOpenBlob\"><a ng-if=voting.msSaveOrOpenBlob ng-click=voting.msDownloadFile(voting.fileBlob,voting.fileName) class=\"btn btn-block btn-default m-b-lg\">СКАЧАТЬ {{voting.fileName}}</a> <a ng-if=voting.fileUrl href={{voting.fileUrl}} class=\"btn btn-block btn-default m-b-lg\" download={{voting.fileName}}>СКАЧАТЬ {{voting.fileName}}</a></div></div></uib-tab><uib-tab ng-if=\"voting.item.id && voting.openResult\" ng-click=voting.setIndex(2) index=2 heading=\"Список проголосовавших\"><h5 class=p-b-lg>&laquo;{{voting.item.name}}&raquo;</h5><table class=\"table table-hover table-no-border table-condensed table-voting\"><thead><tr><th>Собственник</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in voting.item.result_owners\"><td>кв. {{item.flat}} - {{item.contacts.name}}</td><td><div ng-if=voting.openFormResult class=buttons><a href ui-sref=voting.result({voting_id:voting.item.id,owner_id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=voting.deleteResult(item) ng-if=!item.status><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><div class=row><div ng-if=voting.openFormResult class=\"col-sm-6 col-xs-12\"><a href ui-sref=voting.result({voting_id:voting.item.id}) class=\"btn btn-success-light\">Добавить ответ собственника</a></div><div class=\"col-sm-6 col-xs-12 text-right pull-right\"><ul uib-pagination total-items=voting.cnt_owners ng-model=voting.page items-per-page=voting.ownerParams.limit ng-change=voting.getVotingResultOwners() force-ellipses=true rotate=true max-size=5 class=\"pagination-sm m-y-0\" boundary-links=true previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/pages/workers/views/content.html","<div class=row><div class=col-md-10><h2>{{ workers.title }}</h2><table class=\"table table-hover p-t-lg\"><thead><tr><th>ФИО</th><th>Телефон</th><th>Email</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in workers.items\"><td role=button ui-sref=workers.item({id:item.id})>{{item.name}}</td><td role=button ui-sref=workers.item({id:item.id})>{{item.phone}}</td><td role=button ui-sref=workers.item({id:item.id})>{{item.email}}</td><td><div class=buttons><a href ui-sref=workers.permitions({id:item.id})><i class=\"fa fa-unlock-alt\"></i></a> <a href ui-sref=workers.item({id:item.id})><i class=\"fa fa-pencil\"></i></a> <a href ng-click=workers.delete(item)><span class=\"fa fa-remove\"></span></a></div></td></tr></tbody></table><a href class=\"btn btn-success\" ui-sref=workers.item>Добавить сотрудника</a></div></div>");
$templateCache.put("app/pages/workers/views/form_item.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\"><span ng-show=worker.item.id>Редактирование сотрудника</span> <span ng-hide=worker.item.id>Добавление сотрудника</span></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=\"alert alert-danger\" ng-show=worker.error>{{worker.error}}</div><!--Форма --><div class=collapse-group id=accordion role=tablist aria-multiselectable=true><form ng-submit=worker.send() name=worker.form novalidate><div class=well><a class=h3>Общая информация</a><div class=p-t-lg><div class=row><form-element data-name=name data-title=ФИО data-form=worker.form><input name=name id=name type=text class=form-control ng-model=worker.item.name required></form-element><form-element data-name=phone data-title=Телефон data-form=worker.form><input name=phone mask=+99999999999 id=phone type=text class=form-control ng-model=worker.item.phone required></form-element><form-element data-name=ip data-title=\"IP адрес\" data-form=worker.form><input name=ip id=ip type=text class=form-control ng-model=worker.item.ip placeholder=192.168.1.1></form-element><form-element data-name=emailNew data-title=E-mail data-form=worker.form ng-if=\"worker.item.id && !worker.item.email\"><input name=emailNew id=emailNew type=text class=form-control placeholder=info@profintel.ru ng-model=worker.item.emailNew ng-required=\"worker.item.id && !worker.item.email\"></form-element><form-element data-name=email data-title=E-mail ng-if=\"worker.item.id && worker.item.email\"><div class=h5>{{worker.item.email}}</div></form-element><form-element data-class=col-sm-8 data-name=superuser data-title=\"\" data-help_msg=\"Доступны все права доступа в административную панель\"><label><input type=checkbox name=superuser ng-model=worker.item.superuser>&emsp;Суперпользователь</label></form-element></div><div class=row ng-show=worker.item.id><div class=col-sm-4><input type=submit value=\"Сохранить изменения\" class=\"btn btn-block btn-success\"></div><div class=\"col-sm-4 pull-right\" ng-if=worker.item.id><a href ui-sref=workers.permitions({id:worker.item.id}) class=\"btn btn-block btn-info-light\"><i class=\"fa fa-unlock-alt\"></i>&nbsp;Назначить права доступа</a></div></div></div></div><div class=well ng-if=!worker.item.id><a class=h3>Регистрационная информация</a><div class=p-t-lg><div class=row><form-element data-name=email data-title=E-mail data-form=worker.form><input name=email id=emailCreate type=text class=form-control placeholder=info@profintel.ru ng-model=worker.item.email ng-required=!worker.item.id></form-element><form-element data-name=password data-title=Пароль data-form=worker.form><input name=password id=password type=text class=form-control ng-model=worker.item.password ng-required=!worker.item.id></form-element></div><div class=row><div class=col-sm-4><a href ng-click=worker.generatePassword() class=\"btn btn-block btn-success-light\">Сгенерировать пароль</a></div></div></div></div><div class=row><div class=col-sm-4><input type=submit ng-hide=worker.item.id value=Создать class=\"btn btn-block btn-success\"></div></div></form><div ng-show=worker.item.id><form ng-submit=worker.changePass() name=worker.formPass novalidate><div class=well><a class=h3>Сменить пароль</a><div class=p-t-lg><div class=\"row m-b-lg\"><form-element data-class=\"col-sm-4 password-block clearfix\" data-id=changePassword data-name=password data-title=Пароль data-form=worker.formPass><input name=password id=changePassword type=password class=form-control ng-model=worker.password required> <span class=\"glyphicon glyphicon-eye-open\" onclick=\"$(\'#changePassword\').attr(\'type\',\'text\')\"></span></form-element><form-element data-class=\"col-sm-4 password-block clearfix\" data-name=re_password data-title=\"Повтор пароля\" data-form=worker.formPass><input name=re_password id=re_password type=password class=form-control ng-model=worker.re_password required> <span class=\"glyphicon glyphicon-eye-open\" onclick=\"$(\'#re_password\').attr(\'type\',\'text\')\"></span></form-element><div class=\"col-sm-4 m-t p-t-lg m-b-lgx2\"><a href ng-click=worker.generatePassword() class=\"btn btn-block btn-success-light\">Сгенерировать пароль</a></div><div class=col-sm-4><input type=submit value=\"Сменить пароль\" class=\"btn btn-block btn-success\"></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/workers/views/permitions.html","<div class=\"flex flex-center m-b-lg\"><div class=\"h2 m-b-0 m-r-lg\">Права доступа <small>({{ permitions.worker.name }})</small></div><div class=\"text-right text-nowrap\"><a href ng-click=goBack()><span class=\"fa fa-arrow-circle-left\"></span> Назад</a></div></div><div class=\"alert alert-danger\" ng-show=permitions.error>{{permitions.error}}</div><form ng-submit=permitions.send() name=permitions.form class=p-t-lg novalidate><table class=\"table table-hover\"><thead><tr><th><input id=states_selectAll type=checkbox ng-change=permitions.toggleAll() ng-model=permitions.selectAll></th><th>Описание</th><th>Наименование</th></tr></thead><tbody><tr ng-repeat=\"state in permitions.states\"><td><input id=states_{{state.name}} type=checkbox ng-true-value=\"\'{{state.name}}\'\" ng-change=permitions.send() ng-model=permitions.worker.states[state.name]></td><td><label for=states_{{state.name}}>{{state.description}}</label></td><td>{{state.name}}</td></tr></tbody></table></form>");}]);